import { jsxs as r, jsx as e, Fragment as ie } from "react/jsx-runtime";
import { App as G, Form as b, Input as x, Button as y, Typography as O, theme as Ne, Alert as C, Table as ge, Modal as Te, Row as fe, Col as H, Card as K, Tabs as mt, Switch as se, Select as V, Avatar as Kt, Upload as Jt, DatePicker as gt, Skeleton as nt, Space as k, Tag as T, Popconfirm as $, message as de, Descriptions as m, Divider as ne, Tooltip as ce, Spin as Re, Radio as Oe, Result as Yt, Steps as rt, Checkbox as Ht } from "antd";
import { logger as Qe } from "@digiwedge/logger";
import { useNavigate as Z, useParams as ee, Link as J } from "react-router-dom";
import { useTenantsControllerCreateTenantMutation as Xt, useTenantsControllerFindTenantByIdQuery as Zt, useTenantsControllerUpdateTenantMutation as ht, normalizeAccessControlBasePath as en, useTenantsControllerFindAllTenantsQuery as pt, useTenantsControllerSoftDeleteTenantMutation as tn, useTenantsControllerRestoreTenantMutation as nn, useAccessControlContext as rn, useUsersQueryControllerFindAllUsersQuery as yt, useUsersControllerSoftDeleteUserMutation as ft, useUsersControllerRestoreUserMutation as bt, useUsersControllerPermanentlyDeleteUserMutation as At, useUsersControllerCreateUserMutation as an, useUsersQueryControllerGetUserByIdQuery as vt, useUsersControllerUpdateUserMutation as sn, useUsersControllerUpdateUserStatusMutation as ln, useRolesControllerFindAllRolesQuery as We, useUsersControllerChangeUserRoleMutation as on, useUsersControllerChangePasswordMutation as dn, useRolesControllerSoftDeleteRoleMutation as It, useRolesControllerRestoreRoleMutation as wt, useRolesControllerCreateRoleMutation as cn, useRolesControllerFindRoleByIdQuery as Ct, useRolesControllerUpdateRoleMutation as un, usePermissionsControllerListPermissionsQuery as mn, usePermissionsControllerDeletePermissionMutation as Tt, usePermissionsControllerCreatePermissionMutation as gn, usePermissionsControllerGetPermissionByIdQuery as Et, usePermissionsControllerUpdatePermissionMutation as hn, usePermissionAssignmentsControllerListAssignmentsQuery as pn, usePermissionAssignmentsControllerCreateAssignmentMutation as yn, usePermissionAssignmentsControllerGetAssignmentByIdQuery as St, usePermissionAssignmentsControllerUpdateAssignmentMutation as fn, useFeaturesQueryControllerGetAllFeaturesQuery as Ke, useFeaturesControllerSoftDeleteFeatureMutation as kt, useFeaturesControllerRestoreFeatureMutation as Pt, useFeaturesControllerToggleFeatureStateMutation as Dt, useFeaturesControllerCreateFeatureMutation as bn, useFeaturesControllerGetFeatureByIdQuery as Rt, useFeaturesControllerUpdateFeatureMutation as An, useFeatureFlagsControllerGetNonDeletedFeatureFlagsQuery as vn, useFeatureFlagsControllerUpdateFeatureFlagMutation as Je, useFeatureFlagsControllerSoftDeleteFeatureFlagMutation as Mt, useFeatureFlagsControllerRestoreFeatureFlagMutation as xt, useFeatureFlagsControllerCreateFeatureFlagMutation as In, useFeatureFlagsControllerGetFeatureFlagByIdQuery as Nt, useConsentsControllerFindAllQuery as wn, useConsentsControllerRevokeMutation as Lt, useConsentsControllerCreateMutation as Cn, useConsentsControllerUpdateMutation as Tn, useConsentsControllerFindByIdQuery as En, useSessionsControllerGetAllSessionsByUserIdQuery as Sn, useSessionsControllerGetSessionByIdQuery as kn, useSessionsControllerRevokeSessionMutation as Pn, useLoginAttemptsControllerGetLoginAttemptsQuery as Dn, useLoginAttemptsControllerGetLoginAttemptByIdQuery as Rn, useInvitationsControllerListInvitationsQuery as Mn, useInvitationsControllerResendInvitationMutation as Ft, useInvitationsControllerMarkInvitationAsCanceledMutation as Ut, useInvitationsControllerMarkInvitationAsUsedMutation as xn, useInvitationsControllerMarkInvitationAsDeclinedMutation as Nn, useInvitationsControllerCreateInvitationMutation as Ln, useInvitationsControllerGetInvitationByIdQuery as Ot, useInvitationsControllerCancelMutation as Fn, useAuditLogsControllerGetDeletionAuditLogsQuery as Un } from "@digiwedge/access-control-api-hooks";
import { AccessControlApiProvider as Za } from "@digiwedge/access-control-api-hooks";
import at, { useEffect as re, createContext as On, useCallback as X, useMemo as oe, useContext as Bn, useState as P, useRef as qe } from "react";
import _n from "dayjs";
import { WarningOutlined as zn, CheckCircleOutlined as Ye, CloseCircleOutlined as De, ClockCircleOutlined as $n, MailOutlined as Gn, DeleteOutlined as _e, InfoCircleOutlined as Vn, UndoOutlined as jn, BankOutlined as it, GlobalOutlined as qn, UserOutlined as Qn, LoadingOutlined as Wn, EditOutlined as Kn, ReloadOutlined as He, PlusOutlined as Jn, KeyOutlined as Yn, SyncOutlined as Hn, SaveOutlined as Xn } from "@ant-design/icons";
import Ce from "axios";
function Yr() {
  const { message: t } = G.useApp(), n = Z(), {
    mutateAsync: a,
    isPending: i,
    error: l
  } = Xt(), s = async (d) => {
    const u = await a([d]);
    if (u) {
      const g = u?.data;
      t.success(`Tenant "${g?.name}" created successfully!`), n("/tenants");
    }
  }, c = (d) => {
    t.error("Failed to create tenant. Please correct the errors and try again."), Qe.error("CreateTenantPage form error", {
      transactionId: "create-tenant",
      error: d
    });
  };
  return /* @__PURE__ */ r("div", { style: { maxWidth: 500, margin: "0 auto", padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create Tenant" }),
    !!l && /* @__PURE__ */ r("div", { style: { color: "red", marginBottom: 16 }, children: [
      "Error: ",
      l?.message ?? "Error"
    ] }),
    /* @__PURE__ */ r(
      b,
      {
        name: "create-tenant",
        layout: "vertical",
        onFinish: s,
        onFinishFailed: c,
        initialValues: { name: "", description: "" },
        children: [
          /* @__PURE__ */ e(
            b.Item,
            {
              label: "Tenant Name",
              name: "name",
              rules: [
                { required: !0, message: "Please enter a tenant name!" },
                { min: 3, max: 50, message: "Name must be 3-50 characters long." }
              ],
              children: /* @__PURE__ */ e(x, { placeholder: "e.g. Acme Corp" })
            }
          ),
          /* @__PURE__ */ e(
            b.Item,
            {
              label: "Description",
              name: "description",
              rules: [{ max: 255, message: "Description must be under 255 characters." }],
              children: /* @__PURE__ */ e(x.TextArea, { rows: 3, placeholder: "Optional description..." })
            }
          ),
          /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: i, children: "Create Tenant" }) })
        ]
      }
    )
  ] });
}
const ze = (t) => {
  if (t)
    return typeof t == "object" && t !== null && "data" in t ? t.data : t;
}, pe = (t) => {
  if (!t) return [];
  if (Array.isArray(t)) return t;
  if (typeof t == "object" && t !== null && "data" in t) {
    const n = t.data;
    return Array.isArray(n) ? n : [];
  }
  return [];
};
function Hr() {
  const { message: t } = G.useApp(), n = Z(), { tenantId: a } = ee(), {
    data: i,
    isPending: l,
    error: s
  } = Zt([a ?? ""], {
    enabled: !!a
  }), c = ze(i), {
    mutateAsync: d,
    isPending: u,
    error: g
  } = ht(), [o] = b.useForm();
  re(() => {
    c && o.setFieldsValue({
      name: c.name,
      description: c.description ?? ""
    });
  }, [c, o]);
  const h = async (w) => {
    if (!a) return;
    const S = await d([a, w]);
    if (S) {
      const f = S?.data;
      t.success(`Tenant "${f?.name}" updated successfully!`), n("/tenants");
    }
  }, p = (w) => {
    t.error("Failed to update tenant. Please correct the errors and try again."), Qe.error("EditTenantPage form error", {
      transactionId: a,
      error: w
    });
  };
  if (s) {
    const w = s instanceof Error ? s.message : String(s);
    return /* @__PURE__ */ r("div", { style: { color: "red", padding: 24 }, children: [
      "Error loading tenant: ",
      w
    ] });
  }
  return /* @__PURE__ */ r("div", { style: { maxWidth: 500, margin: "0 auto", padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit Tenant" }),
    !!g && /* @__PURE__ */ r("div", { style: { color: "red", marginBottom: 16 }, children: [
      "Update error:",
      " ",
      String(g instanceof Error ? g.message : String(g))
    ] }),
    /* @__PURE__ */ r(
      b,
      {
        form: o,
        name: "edit-tenant",
        layout: "vertical",
        onFinish: h,
        onFinishFailed: p,
        children: [
          /* @__PURE__ */ e(
            b.Item,
            {
              label: "Tenant Name",
              name: "name",
              rules: [
                { required: !0, message: "Please enter a tenant name!" },
                { min: 3, max: 50, message: "Name must be 3-50 characters long." }
              ],
              children: /* @__PURE__ */ e(x, { placeholder: "e.g. Acme Corp", disabled: l || u })
            }
          ),
          /* @__PURE__ */ e(
            b.Item,
            {
              label: "Description",
              name: "description",
              rules: [{ max: 255, message: "Description must be under 255 characters." }],
              children: /* @__PURE__ */ e(
                x.TextArea,
                {
                  rows: 3,
                  placeholder: "Optional description...",
                  disabled: l || u
                }
              )
            }
          ),
          /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: u, disabled: l, children: "Update Tenant" }) })
        ]
      }
    )
  ] });
}
const Bt = On(null);
function Zn() {
  try {
    const n = globalThis.importMetaEnv?.VITE_ACCESS_CONTROL_BASE_URL, a = typeof process < "u" ? process.env?.VITE_ACCESS_CONTROL_BASE_URL : void 0;
    return (n ?? a)?.replace(/\/$/, "");
  } catch {
    return;
  }
}
function er(t) {
  if (typeof document > "u") return;
  const n = `${t}=`, a = document.cookie.split(";").map((l) => l.trim()).find((l) => l.startsWith(n));
  if (!a) return;
  const i = a.slice(n.length);
  return i ? decodeURIComponent(i) : void 0;
}
const Xr = ({
  authMode: t = "bearer",
  children: n,
  baseUrl: a,
  credentials: i = "include",
  getAccessToken: l,
  tenantId: s
}) => {
  const c = X(
    async (u) => {
      const g = u.tenantId || !s ? u : { ...u, tenantId: s }, o = en(a ?? Zn()), h = o ? `${o}/api/capabilities/can` : "/api/capabilities/can", p = t === "bearer" ? l?.() ?? (typeof localStorage < "u" ? localStorage.getItem("accessToken") ?? void 0 : void 0) ?? (typeof sessionStorage < "u" ? sessionStorage.getItem("accessToken") ?? void 0 : void 0) : void 0, w = { "content-type": "application/json" };
      p && (w.Authorization = `Bearer ${p}`), g.tenantId && (w["x-tenant-id"] = g.tenantId);
      const S = t === "cookie" && i === "include" ? er("XSRF-TOKEN") : void 0;
      S && (w["X-XSRF-Token"] = S);
      const f = await fetch(h, {
        method: "POST",
        credentials: t === "cookie" ? i : "same-origin",
        headers: w,
        body: JSON.stringify({ checks: [g] })
      });
      if (!f.ok)
        return { allowed: !1, reason: "none" };
      const R = (await f.json()).results?.[0];
      return { allowed: !!R?.allowed, reason: R?.reason };
    },
    [t, a, i, l, s]
  ), d = oe(() => ({ can: c }), [c]);
  return /* @__PURE__ */ e(Bt.Provider, { value: d, children: n });
};
function N(t) {
  const n = Bn(Bt), [a, i] = at.useState({ allowed: !1, loading: !0 }), { feature: l, action: s, tenantId: c } = t;
  return at.useEffect(() => {
    let d = !1;
    if (!n) {
      const u = typeof process < "u" && !!process.env?.JEST_WORKER_ID;
      i({ allowed: u, loading: !1, reason: u ? "bypass" : "none" });
      return;
    }
    return i((u) => ({ ...u, loading: !0 })), n.can({ feature: l, action: s, tenantId: c }).then((u) => {
      d || i({ allowed: u.allowed, loading: !1, reason: u.reason });
    }).catch(() => {
      d || i({ allowed: !1, loading: !1, reason: "none" });
    }), () => {
      d = !0;
    };
  }, [n, l, s, c]), a;
}
const { Title: tr } = O;
function Zr() {
  const { token: t } = Ne.useToken(), n = N({ feature: "TENANT_MGMT", action: "read" }), a = N({ feature: "TENANT_MGMT", action: "update" }), i = Z(), [l, s] = P(1), c = 10, d = oe(() => (l - 1) * c, [l, c]), {
    data: u,
    isPending: g,
    error: o,
    refetch: h
  } = pt([d], {
    enabled: n.allowed
  }), p = pe(u), {
    mutateAsync: w,
    isPending: S,
    error: f
  } = ht(), { mutateAsync: I, isPending: R } = tn(), { mutateAsync: M, isPending: E } = nn(), [B, F] = P(null), [v] = b.useForm(), le = X((U) => {
    s(U);
  }, []), be = (U) => {
    a.allowed && (F(U), v.setFieldsValue({
      name: U.name,
      description: U.description
    }));
  }, he = async () => {
    if (a.allowed)
      try {
        const U = await v.validateFields();
        if (!B) return;
        await w([B.id, U]) && (h(), F(null));
      } catch (U) {
        Qe.error("Tenant update error", {
          transactionId: B?.id,
          error: U
        });
      }
  }, j = N({ feature: "TENANT_MGMT", action: "delete" }), ue = N({ feature: "TENANT_MGMT", action: "restore" }), q = async (U) => {
    j.allowed && (await I([U.id]), h());
  }, Ae = async (U) => {
    ue.allowed && (await M([U.id]), h());
  }, Ie = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      ellipsis: !0
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ellipsis: !0,
      sorter: (U, ae) => U.name.localeCompare(ae.name)
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: !0
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (U) => new Date(U).toLocaleString(),
      sorter: (U, ae) => new Date(U.createdAt).getTime() - new Date(ae.createdAt).getTime()
    },
    {
      title: "Actions",
      key: "actions",
      render: (U, ae) => /* @__PURE__ */ r(ie, { children: [
        a.allowed && /* @__PURE__ */ e(y, { type: "link", onClick: () => be(ae), children: "Edit" }),
        a.allowed && /* @__PURE__ */ e(y, { type: "link", onClick: () => i(`/tenants/${ae.id}/scim`), children: "SCIM" }),
        a.allowed && /* @__PURE__ */ e(y, { type: "link", onClick: () => i(`/tenants/${ae.id}/saml`), children: "SAML" }),
        j.allowed && /* @__PURE__ */ e(y, { type: "link", danger: !0, onClick: () => q(ae), disabled: R, children: "Archive" }),
        ue.allowed && /* @__PURE__ */ e(y, { type: "link", onClick: () => Ae(ae), disabled: E, children: "Restore" })
      ] })
    }
  ], ve = (U, ae, Ee, ye) => {
    le(U.current ?? 1);
  };
  return o ? /* @__PURE__ */ e(
    C,
    {
      message: "Error",
      description: o instanceof Error ? o.message : "An error occurred while loading tenants",
      type: "error",
      showIcon: !0,
      style: { margin: t.marginLG || 16 }
    }
  ) : /* @__PURE__ */ r(
    "div",
    {
      style: {
        padding: t.paddingLG || 24,
        background: t.colorBgContainer
      },
      children: [
        /* @__PURE__ */ e(tr, { level: 2, style: { marginBottom: t.marginLG || 16 }, children: "Tenants" }),
        /* @__PURE__ */ e(
          y,
          {
            type: "primary",
            onClick: () => void h(),
            disabled: !n.allowed,
            style: { marginBottom: t.marginMD || 16 },
            children: "Refresh"
          }
        ),
        /* @__PURE__ */ e(
          ge,
          {
            dataSource: p,
            columns: Ie,
            loading: g || S || R || E,
            rowKey: "id",
            pagination: {
              current: l,
              pageSize: c,
              total: p.length,
              onChange: (U) => le(U)
            },
            onChange: ve
          }
        ),
        /* @__PURE__ */ r(
          Te,
          {
            open: !!B,
            title: "Edit Tenant",
            onCancel: () => F(null),
            onOk: he,
            okText: "Update",
            confirmLoading: S,
            okButtonProps: { disabled: !a.allowed },
            children: [
              !!f && /* @__PURE__ */ e(
                C,
                {
                  message: "Update Error",
                  description: f instanceof Error ? f.message : "An error occurred while updating the tenant",
                  type: "error",
                  showIcon: !0,
                  style: { marginBottom: t.marginSM || 8 }
                }
              ),
              /* @__PURE__ */ r(b, { form: v, layout: "vertical", children: [
                /* @__PURE__ */ e(
                  b.Item,
                  {
                    name: "name",
                    label: "Tenant Name",
                    rules: [
                      { required: !0, message: "Please enter the tenant name" },
                      { min: 3, max: 50, message: "Name must be 3-50 characters long" }
                    ],
                    children: /* @__PURE__ */ e(x, { placeholder: "Enter tenant name" })
                  }
                ),
                /* @__PURE__ */ e(
                  b.Item,
                  {
                    name: "description",
                    label: "Description",
                    rules: [{ max: 255, message: "Description must be under 255 characters" }],
                    children: /* @__PURE__ */ e(x.TextArea, { rows: 3, placeholder: "Enter description (optional)" })
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}
const { Title: nr, Text: Me } = O, rr = [
  { label: "Users", to: "/users" },
  { label: "Roles", to: "/roles" },
  { label: "Permissions", to: "/permissions" },
  { label: "Permission Assignments", to: "/permission-assignments" },
  { label: "Tenants", to: "/tenants" },
  { label: "VoicePro Onboarding", to: "/onboarding/voicepro" },
  { label: "Login Attempts", to: "/login-attempts" },
  { label: "Sessions", to: "/sessions" },
  { label: "Invitations", to: "/invitations" }
], ea = () => {
  const { token: t } = Ne.useToken();
  return /* @__PURE__ */ r("div", { style: { padding: t.paddingLG, background: t.colorBgContainer }, children: [
    /* @__PURE__ */ e(nr, { level: 2, children: "Dashboard" }),
    /* @__PURE__ */ e(
      C,
      {
        type: "info",
        showIcon: !0,
        message: /* @__PURE__ */ e(Me, { style: { color: t.colorText }, children: "Operational metrics coming soon" }),
        description: /* @__PURE__ */ e(Me, { style: { color: t.colorTextSecondary }, children: "Dashboard metrics will appear once data pipelines are enabled. Use the quick links below to manage tenants, users, roles, and permissions." }),
        style: {
          marginBottom: t.marginLG,
          color: t.colorText,
          background: t.colorBgContainer,
          borderColor: t.colorBorderSecondary
        }
      }
    ),
    /* @__PURE__ */ r(fe, { gutter: [16, 16], children: [
      /* @__PURE__ */ e(H, { xs: 24, md: 8, children: /* @__PURE__ */ e(K, { title: "Metrics", bordered: !0, children: /* @__PURE__ */ e(Me, { type: "secondary", children: "User counts, role usage, and permission coverage will appear here." }) }) }),
      /* @__PURE__ */ e(H, { xs: 24, md: 8, children: /* @__PURE__ */ e(K, { title: "Health", bordered: !0, children: /* @__PURE__ */ e(Me, { type: "secondary", children: "Authentication, API health, and tenant status checks will appear here." }) }) }),
      /* @__PURE__ */ e(H, { xs: 24, md: 8, children: /* @__PURE__ */ e(K, { title: "Audit & Activity", bordered: !0, children: /* @__PURE__ */ e(Me, { type: "secondary", children: "Recent changes and access-control events will appear here." }) }) })
    ] }),
    /* @__PURE__ */ e(K, { title: "Quick Links", style: { marginTop: t.marginLG }, children: /* @__PURE__ */ e(fe, { gutter: [12, 12], children: rr.map((n) => /* @__PURE__ */ e(H, { xs: 24, sm: 12, md: 8, children: /* @__PURE__ */ e(J, { to: n.to, children: n.label }) }, n.to)) }) })
  ] });
}, _t = ":tenantId", Xe = "unknown", ar = {
  teetime: {
    host: "teetime",
    entryPath: "/access-control",
    tenantRoute: "/tenants/:tenantId/access-control",
    entryLabel: "Overview",
    tenantMenuLabel: "Tenant Access"
  },
  scl: {
    host: "scl",
    entryPath: "/admin/access-control",
    tenantRoute: "/admin/access-control/:tenantId",
    entryLabel: "Access Control",
    tenantMenuLabel: "Tenant Access"
  },
  facilities: {
    host: "facilities",
    entryPath: "/access-control",
    tenantRoute: "/access-control/:tenantId",
    entryLabel: "Access Control",
    tenantMenuLabel: "Tenant Access"
  },
  crm: {
    host: "crm",
    entryPath: "/access-control",
    tenantRoute: "/access-control/:tenantId",
    entryLabel: "Access Control",
    tenantMenuLabel: "Tenant Access"
  }
}, ir = [
  {
    suffix: "",
    label: "Access Control",
    protected: !0,
    feature: "TENANT_MGMT",
    action: "read"
  },
  {
    suffix: "/permissions",
    label: "Permissions",
    protected: !0,
    feature: "PERMISSION_MGMT",
    action: "read"
  },
  {
    suffix: "/roles",
    label: "Roles",
    protected: !0,
    feature: "ROLE_MGMT",
    action: "read"
  },
  {
    suffix: "/users",
    label: "Users",
    protected: !0,
    feature: "USER_MGMT",
    action: "read"
  },
  {
    suffix: "/user-profiles",
    label: "User Profiles",
    protected: !0,
    feature: "USER_MGMT",
    action: "read"
  },
  {
    suffix: "/permission-assignments",
    label: "Permission Assignments",
    protected: !0,
    feature: "PERMISSION_ASSIGNMENT",
    action: "read"
  },
  {
    suffix: "/settings",
    label: "Settings",
    protected: !0,
    feature: "TENANT_MGMT",
    action: "read"
  }
], sr = [
  {
    suffix: "",
    label: "Access Control",
    protected: !0,
    feature: "TENANT_MGMT",
    action: "read"
  },
  {
    suffix: "/users",
    label: "Users",
    protected: !0,
    feature: "USER_MGMT",
    action: "read"
  },
  {
    suffix: "/invitations",
    label: "Invitations",
    protected: !0,
    feature: "INVITATION_MGMT",
    action: "read"
  },
  {
    suffix: "/sessions",
    label: "Sessions",
    protected: !0,
    feature: "SESSION_MGMT",
    action: "read"
  },
  {
    suffix: "/login-attempts",
    label: "Login Attempts",
    protected: !0,
    feature: "LOGIN_ATTEMPTS",
    action: "read"
  }
], lr = [
  { suffix: "", label: "Tenant Access" },
  { suffix: "/users", label: "Users" },
  { suffix: "/invitations", label: "Invitations" },
  { suffix: "/sessions", label: "Sessions" },
  { suffix: "/login-attempts", label: "Audit" }
];
function st(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function zt(t, n) {
  return n ? n.startsWith("/") ? `${t}${n}` : `${t}/${n}` : t;
}
function or(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    return t;
  }
}
function Ze(t) {
  return ar[t];
}
function dr(t) {
  return Ze(t).entryPath;
}
function ta(t) {
  return `${dr(t)}/*`;
}
function $e(t) {
  return Ze(t).tenantRoute;
}
function na(t) {
  return `${$e(t)}/*`;
}
function et(t, n, a = {}) {
  const i = $e(t), l = n?.trim() ?? "", s = l.length > 0 ? l : a.fallbackTenantId?.trim() || Xe;
  return i.replace(_t, encodeURIComponent(s));
}
function ra(t, n) {
  const a = Ze(t), i = n?.trim(), l = [
    {
      key: a.entryPath,
      to: a.entryPath,
      label: a.entryLabel,
      disabled: !1
    }
  ], s = et(
    t,
    i || Xe
  );
  return l.push({
    key: s,
    to: s,
    label: a.tenantMenuLabel,
    disabled: !i
  }), l;
}
function aa(t, n) {
  const a = n?.trim(), i = et(
    t,
    a || Xe
  );
  return lr.map((l) => {
    const s = zt(i, l.suffix);
    return {
      key: s,
      to: s,
      label: l.label,
      disabled: !a
    };
  });
}
function ia(t, n = {}) {
  const a = $e(t);
  return (n.routeProfile === "tenant-admin" ? sr : ir).map((l) => ({
    path: zt(a, l.suffix),
    label: l.label,
    protected: l.protected,
    feature: l.feature,
    action: l.action
  }));
}
function cr(t, n) {
  const i = $e(t).split(_t), l = i[0] ?? "", s = i[1] ?? "", c = `^${st(l)}([^/]+)${st(s)}(.*)$`, d = n.match(new RegExp(c));
  if (!d)
    return;
  const u = or(d[1]), g = d[2] ?? "";
  return { tenantId: u, suffixPath: g };
}
function sa(t, n, a) {
  const i = cr(t, a);
  return i ? `${et(t, n)}${i.suffixPath}` : void 0;
}
function la() {
  try {
    const t = globalThis;
    return (t.__viteImportMetaEnv__?.VITE_ACCESS_CONTROL_BASE_URL || t.importMetaEnv?.VITE_ACCESS_CONTROL_BASE_URL || t.process?.env?.VITE_ACCESS_CONTROL_BASE_URL)?.trim() ?? "";
  } catch {
    return "";
  }
}
const { Title: Ve, Text: lt } = O, { TabPane: Le } = mt, oa = () => {
  const { message: t } = G.useApp(), { token: n } = Ne.useToken(), [a, i] = P(!1), [l, s] = P(!1), [c, d] = P(!1), u = (S) => {
    i(!0), setTimeout(() => {
      i(!1), t.success("General settings saved!");
    }, 1e3);
  }, g = (S) => {
    s(!0), setTimeout(() => {
      s(!1), t.success("Notifications updated!");
    }, 1e3);
  }, o = (S) => {
    d(!0), setTimeout(() => {
      d(!1), t.success("Privacy settings updated!");
    }, 1e3);
  }, h = () => {
    t.info("Enable MFA wizard goes here.");
  }, p = () => {
    t.info("Disable MFA logic goes here.");
  }, w = () => {
    t.info("Change password modal / flow goes here.");
  };
  return /* @__PURE__ */ r(
    K,
    {
      style: {
        margin: n.marginLG,
        padding: n.paddingMD,
        background: n.colorBgContainer
      },
      children: [
        /* @__PURE__ */ e(Ve, { level: 3, style: { marginBottom: n.marginMD }, children: "Settings" }),
        /* @__PURE__ */ r(mt, { defaultActiveKey: "general", children: [
          /* @__PURE__ */ e(Le, { tab: "General", children: /* @__PURE__ */ r(
            b,
            {
              layout: "vertical",
              initialValues: { fullName: "John Doe", language: "en" },
              onFinish: u,
              children: [
                /* @__PURE__ */ e(
                  b.Item,
                  {
                    label: "Full Name",
                    name: "fullName",
                    rules: [{ required: !0, message: "Please enter your full name" }],
                    children: /* @__PURE__ */ e(x, { placeholder: "Enter your name" })
                  }
                ),
                /* @__PURE__ */ e(b.Item, { label: "Language", name: "language", children: /* @__PURE__ */ e(x, { placeholder: "Language code (e.g. en, fr, es)" }) }),
                /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: a, children: "Save General" }) })
              ]
            }
          ) }, "general"),
          /* @__PURE__ */ e(Le, { tab: "Notifications", children: /* @__PURE__ */ r(
            b,
            {
              layout: "vertical",
              initialValues: { notifications: !0, darkMode: !1 },
              onFinish: g,
              children: [
                /* @__PURE__ */ e(b.Item, { label: "Enable Notifications", name: "notifications", valuePropName: "checked", children: /* @__PURE__ */ e(se, {}) }),
                /* @__PURE__ */ e(b.Item, { label: "Dark Mode", name: "darkMode", valuePropName: "checked", children: /* @__PURE__ */ e(se, {}) }),
                /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: l, children: "Save Notifications" }) })
              ]
            }
          ) }, "notifications"),
          /* @__PURE__ */ e(Le, { tab: "Privacy", children: /* @__PURE__ */ r(
            b,
            {
              layout: "vertical",
              initialValues: { shareData: !1 },
              onFinish: o,
              children: [
                /* @__PURE__ */ e(b.Item, { label: "Share Usage Data", name: "shareData", valuePropName: "checked", children: /* @__PURE__ */ e(se, {}) }),
                /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: c, children: "Save Privacy" }) })
              ]
            }
          ) }, "privacy"),
          /* @__PURE__ */ r(Le, { tab: "Security", children: [
            /* @__PURE__ */ e(Ve, { level: 4, style: { marginBottom: n.marginSM }, children: "MFA Management" }),
            /* @__PURE__ */ e(lt, { children: "Enable or disable Multi-Factor Authentication. If you have none enabled, you can enable one below:" }),
            /* @__PURE__ */ r(
              "div",
              {
                style: {
                  marginTop: n.marginMD,
                  marginBottom: n.marginMD
                },
                children: [
                  /* @__PURE__ */ e(
                    y,
                    {
                      type: "primary",
                      onClick: h,
                      style: { marginRight: n.marginSM },
                      children: "Enable MFA"
                    }
                  ),
                  /* @__PURE__ */ e(y, { danger: !0, onClick: p, children: "Disable MFA" })
                ]
              }
            ),
            /* @__PURE__ */ e(Ve, { level: 4, style: { marginBottom: n.marginSM }, children: "Change Password" }),
            /* @__PURE__ */ e(lt, { children: "It’s a good practice to periodically change your password." }),
            /* @__PURE__ */ e("div", { style: { marginTop: n.marginMD }, children: /* @__PURE__ */ e(y, { onClick: w, children: "Change Password" }) })
          ] }, "security")
        ] })
      ]
    }
  );
}, ot = () => /* @__PURE__ */ e("span", {}), ur = () => /* @__PURE__ */ e("span", {}), mr = () => /* @__PURE__ */ e("span", {}), gr = () => /* @__PURE__ */ e("span", {}), { Title: hr, Text: pr } = O, { Option: Fe } = V, da = () => {
  const { message: t } = G.useApp(), [n, a] = P(!1), [i, l] = P(null), [s, c] = P([]), { token: d } = Ne.useToken(), u = N({ feature: "USER_MGMT", action: "update" }), g = (h) => {
    a(!0);
    let p;
    h.birthday && (p = h.birthday.format("YYYY-MM-DD"));
    const w = {
      ...h,
      birthday: p
      // now a string
    };
    console.log("Saving profile data:", w), setTimeout(() => {
      a(!1), t.success("Profile updated successfully!");
    }, 1e3);
  }, o = {
    fileList: s,
    beforeUpload: (h) => {
      const p = new FileReader();
      return p.onload = () => {
        l(p.result);
      }, p.onerror = () => {
        t.error("Failed to read file");
      }, p.readAsDataURL(h), !1;
    },
    onChange: ({ file: h, fileList: p }) => {
      const w = p.map(
        (S) => S.uid === h.uid ? { ...S, status: h.status, percent: h.percent } : S
      );
      c(w), h.status === "done" ? t.success(`${h.name} uploaded successfully`) : h.status === "error" && t.error(`${h.name} upload failed`);
    },
    showUploadList: !0,
    maxCount: 1
  };
  return /* @__PURE__ */ e(
    K,
    {
      style: {
        margin: d.marginLG,
        padding: d.paddingMD,
        background: d.colorBgContainer
      },
      children: /* @__PURE__ */ r(fe, { gutter: [16, 16], wrap: !0, children: [
        /* @__PURE__ */ r(H, { xs: 24, md: 6, style: { textAlign: "center" }, children: [
          /* @__PURE__ */ e(
            Kt,
            {
              size: 120,
              icon: /* @__PURE__ */ e(ot, {}),
              src: i ?? void 0,
              style: { marginBottom: d.marginSM }
            }
          ),
          /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(Jt, { ...o, children: /* @__PURE__ */ e(y, { icon: /* @__PURE__ */ e(ur, {}), children: "Change Avatar" }) }) })
        ] }),
        /* @__PURE__ */ r(H, { xs: 24, md: 18, children: [
          /* @__PURE__ */ e(hr, { level: 3, style: { marginBottom: d.marginMD }, children: "My Profile" }),
          /* @__PURE__ */ e(pr, { type: "secondary", style: { marginBottom: d.marginMD, display: "block" }, children: "Keep your information current so we can verify your identity and contact you if needed." }),
          /* @__PURE__ */ r(
            b,
            {
              layout: "vertical",
              onFinish: g,
              initialValues: {
                givenName: "John",
                familyName: "Doe",
                preferredName: "Johnny",
                email: "johndoe@example.com",
                phone: "+1 (555) 555-0123",
                // Convert the birthday string to a dayjs object so the DatePicker is pre-filled
                birthday: _n("1990-01-15", "YYYY-MM-DD"),
                gender: "male",
                locale: "en-US"
              },
              children: [
                /* @__PURE__ */ r(fe, { gutter: [16, 16], wrap: !0, style: { marginBottom: d.marginMD }, children: [
                  /* @__PURE__ */ e(H, { xs: 24, sm: 6, md: 4, lg: 3, style: { textAlign: "center" }, children: /* @__PURE__ */ e(
                    "div",
                    {
                      style: {
                        width: 40,
                        height: 40,
                        borderRadius: 8,
                        background: d.colorFillTertiary,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto"
                      },
                      children: /* @__PURE__ */ e(ot, {})
                    }
                  ) }),
                  /* @__PURE__ */ r(H, { xs: 24, sm: 18, md: 20, lg: 21, children: [
                    /* @__PURE__ */ r(fe, { gutter: [16, 16], children: [
                      /* @__PURE__ */ e(H, { xs: 24, md: 12, children: /* @__PURE__ */ e(
                        b.Item,
                        {
                          label: "Given Name",
                          name: "givenName",
                          rules: [
                            {
                              required: !0,
                              message: "Please enter your given name"
                            }
                          ],
                          children: /* @__PURE__ */ e(x, { placeholder: "Enter your given name" })
                        }
                      ) }),
                      /* @__PURE__ */ e(H, { xs: 24, md: 12, children: /* @__PURE__ */ e(
                        b.Item,
                        {
                          label: "Family Name",
                          name: "familyName",
                          rules: [
                            {
                              required: !0,
                              message: "Please enter your family name"
                            }
                          ],
                          children: /* @__PURE__ */ e(x, { placeholder: "Enter your family (last) name" })
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ e(fe, { gutter: [16, 16], children: /* @__PURE__ */ e(H, { xs: 24, children: /* @__PURE__ */ e(b.Item, { label: "Preferred Name", name: "preferredName", children: /* @__PURE__ */ e(x, { placeholder: "Nickname or chosen name (optional)" }) }) }) })
                  ] })
                ] }),
                /* @__PURE__ */ r(fe, { gutter: [16, 16], wrap: !0, style: { marginBottom: d.marginMD }, children: [
                  /* @__PURE__ */ e(H, { xs: 24, sm: 6, md: 4, lg: 3, style: { textAlign: "center" }, children: /* @__PURE__ */ e(
                    "div",
                    {
                      style: {
                        width: 40,
                        height: 40,
                        borderRadius: 8,
                        background: d.colorFillTertiary,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto"
                      },
                      children: /* @__PURE__ */ e(mr, {})
                    }
                  ) }),
                  /* @__PURE__ */ e(H, { xs: 24, sm: 18, md: 20, lg: 21, children: /* @__PURE__ */ r(fe, { gutter: [16, 16], children: [
                    /* @__PURE__ */ e(H, { xs: 24, md: 12, children: /* @__PURE__ */ e(
                      b.Item,
                      {
                        label: "Email",
                        name: "email",
                        rules: [
                          { required: !0, message: "Please enter your email" },
                          {
                            type: "email",
                            message: "Enter a valid email address"
                          }
                        ],
                        children: /* @__PURE__ */ e(x, { placeholder: "Enter your email", type: "email" })
                      }
                    ) }),
                    /* @__PURE__ */ e(H, { xs: 24, md: 12, children: /* @__PURE__ */ e(
                      b.Item,
                      {
                        label: "Phone Number",
                        name: "phone",
                        rules: [
                          {
                            required: !0,
                            message: "Please enter your phone number"
                          }
                        ],
                        children: /* @__PURE__ */ e(x, { placeholder: "+1 (555) 555-0123" })
                      }
                    ) })
                  ] }) })
                ] }),
                /* @__PURE__ */ r(fe, { gutter: [16, 16], wrap: !0, style: { marginBottom: d.marginMD }, children: [
                  /* @__PURE__ */ e(H, { xs: 24, sm: 6, md: 4, lg: 3, style: { textAlign: "center" }, children: /* @__PURE__ */ e(
                    "div",
                    {
                      style: {
                        width: 40,
                        height: 40,
                        borderRadius: 8,
                        background: d.colorFillTertiary,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto"
                      },
                      children: /* @__PURE__ */ e(gr, {})
                    }
                  ) }),
                  /* @__PURE__ */ e(H, { xs: 24, sm: 18, md: 20, lg: 21, children: /* @__PURE__ */ r(fe, { gutter: [16, 16], children: [
                    /* @__PURE__ */ e(H, { xs: 24, md: 8, children: /* @__PURE__ */ e(b.Item, { label: "Birthday", name: "birthday", children: /* @__PURE__ */ e(gt, { style: { width: "100%" } }) }) }),
                    /* @__PURE__ */ e(H, { xs: 24, md: 8, children: /* @__PURE__ */ e(b.Item, { label: "Gender", name: "gender", children: /* @__PURE__ */ r(V, { placeholder: "Select gender", children: [
                      /* @__PURE__ */ e(Fe, { value: "male", children: "Male" }),
                      /* @__PURE__ */ e(Fe, { value: "female", children: "Female" }),
                      /* @__PURE__ */ e(Fe, { value: "other", children: "Other" }),
                      /* @__PURE__ */ e(Fe, { value: "preferNot", children: "Prefer not to say" })
                    ] }) }) }),
                    /* @__PURE__ */ e(H, { xs: 24, md: 8, children: /* @__PURE__ */ e(b.Item, { label: "Locale", name: "locale", children: /* @__PURE__ */ e(x, { placeholder: "e.g. en-US, fr-FR" }) }) })
                  ] }) })
                ] }),
                /* @__PURE__ */ e(b.Item, { style: { marginTop: d.marginMD }, children: /* @__PURE__ */ e(
                  y,
                  {
                    type: "primary",
                    htmlType: "submit",
                    loading: n,
                    disabled: !u.allowed,
                    children: "Save Changes"
                  }
                ) })
              ]
            }
          )
        ] })
      ] })
    }
  );
}, yr = {
  ACTIVE: "green",
  INACTIVE: "default",
  LOCKED_OUT: "orange",
  SUSPENDED: "gold",
  BANNED: "red",
  PENDING_VERIFICATION: "blue",
  DELETED: "volcano"
};
function ca({
  readOnly: t = !1,
  showVoiceProOnlyFilter: n = !1,
  tenantName: a
}) {
  const { message: i } = G.useApp(), { tenantId: l } = rn(), s = !!l, u = yt([l, 500, 0], {
    enabled: s
  }), g = pe(u.data), o = u.isPending, h = u.error, p = u.refetch, [w, S] = P(null), [f, I] = P(!1), [R, M] = P(!1), [E, B] = P("ALL"), [F, v] = P(!1), le = ft(), be = bt(), he = At(), j = X(() => {
    I(!1), S(null);
  }, []), ue = X(() => {
    M(!1), S(null);
  }, []), q = X(() => {
    s && p();
  }, [s, p]), Ae = X(
    async (Q) => {
      try {
        await le.mutateAsync([Q]), i.success("User soft-deleted successfully"), q();
      } catch (z) {
        i.error(
          `Failed to delete user: ${z instanceof Error ? z.message : "Unknown error"}`
        );
      }
    },
    [le, q, i]
  ), Ie = X(
    async (Q) => {
      try {
        await be.mutateAsync([Q]), i.success("User restored successfully"), q();
      } catch (z) {
        i.error(
          `Failed to restore user: ${z instanceof Error ? z.message : "Unknown error"}`
        );
      }
    },
    [be, q, i]
  ), ve = X(
    async (Q) => {
      try {
        await he.mutateAsync([Q]), i.success("User permanently deleted"), q();
      } catch (z) {
        i.error(
          `Failed to permanently delete user: ${z instanceof Error ? z.message : "Unknown error"}`
        );
      }
    },
    [he, q, i]
  );
  if (!s)
    return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
      /* @__PURE__ */ e(
        C,
        {
          type: "info",
          showIcon: !0,
          message: "Waiting for tenant context...",
          description: "User list will load once tenant scope is resolved.",
          style: { marginBottom: 16 }
        }
      ),
      /* @__PURE__ */ e(nt, { active: !0, paragraph: { rows: 4 } })
    ] });
  if (h) {
    const Q = h instanceof Error ? h.message : String(h);
    return /* @__PURE__ */ e(C, { type: "error", message: Q });
  }
  if (o)
    return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(nt, { active: !0, paragraph: { rows: 4 } }) });
  const U = E === "ALL" ? g : g.filter((Q) => Q.status === E), ae = !n || !F ? U : U.filter(
    (Q) => (Q.roles ?? []).some((z) => z.name?.toUpperCase().startsWith("VOICEPRO_"))
  ), Ee = [
    { title: "ID", dataIndex: "userId", width: 280 },
    { title: "Email", dataIndex: "email" },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      render: (Q) => {
        const z = Q ?? "ACTIVE";
        return /* @__PURE__ */ e(T, { color: yr[z] ?? "default", children: z });
      }
    },
    {
      title: "Deleted At",
      dataIndex: "deletedAt",
      width: 180,
      render: (Q) => Q ? new Date(Q).toLocaleDateString() : "-"
    },
    {
      title: "Actions",
      key: "actions",
      width: 380,
      render: (Q, z) => {
        const _ = z.status === "DELETED" || !!z.deletedAt;
        return /* @__PURE__ */ r(k, { size: "small", wrap: !0, children: [
          !t && /* @__PURE__ */ r(ie, { children: [
            /* @__PURE__ */ e(
              y,
              {
                type: "link",
                size: "small",
                "aria-label": `Change role for user ${z.email}`,
                onClick: () => {
                  S(z.userId), I(!0);
                },
                disabled: _,
                children: "Role"
              }
            ),
            /* @__PURE__ */ e(
              y,
              {
                type: "link",
                size: "small",
                "aria-label": `Reset password for user ${z.email}`,
                onClick: () => {
                  S(z.userId), M(!0);
                },
                disabled: _,
                children: "Password"
              }
            )
          ] }),
          !t && !_ && /* @__PURE__ */ e(
            $,
            {
              title: "Soft-delete this user?",
              description: "User will be marked as deleted and can be restored within 30 days.",
              onConfirm: () => Ae(z.userId),
              okText: "Delete",
              okButtonProps: { danger: !0 },
              children: /* @__PURE__ */ e(y, { type: "link", size: "small", danger: !0, children: "Delete" })
            }
          ),
          !t && _ && /* @__PURE__ */ r(ie, { children: [
            /* @__PURE__ */ e(
              y,
              {
                type: "link",
                size: "small",
                style: { color: "#52c41a" },
                onClick: () => Ie(z.userId),
                children: "Restore"
              }
            ),
            /* @__PURE__ */ e(
              $,
              {
                title: "Permanently delete this user?",
                description: "This action cannot be undone. All user data will be erased.",
                onConfirm: () => ve(z.userId),
                okText: "Permanently Delete",
                okButtonProps: { danger: !0 },
                children: /* @__PURE__ */ e(y, { type: "link", size: "small", danger: !0, children: "Purge" })
              }
            )
          ] })
        ] });
      }
    }
  ], ye = a?.trim(), Se = ye && ye !== l ? ye : l ? `${l.substring(0, 8)}...` : "";
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16
        },
        children: [
          /* @__PURE__ */ r(k, { children: [
            /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Users" }),
            /* @__PURE__ */ r(T, { color: "blue", title: `Full tenant ID: ${l}`, children: [
              "Tenant: ",
              Se
            ] })
          ] }),
          /* @__PURE__ */ r(k, { children: [
            n ? /* @__PURE__ */ r(k, { children: [
              /* @__PURE__ */ e("span", { children: "VoicePro only:" }),
              /* @__PURE__ */ e(
                se,
                {
                  "aria-label": "VoicePro-only users filter",
                  checked: F,
                  onChange: v
                }
              )
            ] }) : null,
            /* @__PURE__ */ e("span", { children: "Filter by status:" }),
            /* @__PURE__ */ e(
              V,
              {
                "aria-label": "Filter users by status",
                value: E,
                onChange: B,
                style: { width: 180 },
                options: [
                  { label: "All Users", value: "ALL" },
                  { label: "Active", value: "ACTIVE" },
                  { label: "Deleted", value: "DELETED" },
                  { label: "Suspended", value: "SUSPENDED" },
                  { label: "Locked Out", value: "LOCKED_OUT" },
                  { label: "Banned", value: "BANNED" },
                  { label: "Pending Verification", value: "PENDING_VERIFICATION" },
                  { label: "Inactive", value: "INACTIVE" }
                ]
              }
            ),
            /* @__PURE__ */ e(y, { onClick: q, children: "Refresh" })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e(
      ge,
      {
        "aria-label": "Users table",
        dataSource: ae,
        columns: Ee,
        rowKey: "userId",
        locale: { emptyText: "No users match the current filter." },
        scroll: { x: 1e3 }
      }
    ),
    w && /* @__PURE__ */ r(ie, { children: [
      /* @__PURE__ */ e($t, { open: f, userId: w, onClose: j }),
      /* @__PURE__ */ e(Gt, { open: R, userId: w, onClose: ue })
    ] })
  ] });
}
function ua() {
  const [t, n] = P(""), a = an(), i = a.status === "pending", l = a.error;
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create User" }),
    /* @__PURE__ */ e("label", { htmlFor: "email", style: { display: "block" }, children: "Email" }),
    /* @__PURE__ */ e(
      x,
      {
        id: "email",
        type: "email",
        "aria-required": "true",
        value: t,
        onChange: (c) => n(c.target.value),
        placeholder: "Email"
      }
    ),
    /* @__PURE__ */ e(y, { onClick: async () => {
      const c = { email: t };
      await a.mutateAsync([c]);
    }, type: "primary", loading: i, style: { marginTop: 8 }, children: "Create" }),
    l && /* @__PURE__ */ e("div", { style: { color: "red" }, children: l.message })
  ] });
}
function ma() {
  const { userId: t } = ee(), n = vt([t ?? ""], {
    enabled: !!t
  }), a = n.data ?? null, i = sn(), l = ln(), s = i.status === "pending", c = i.error, [d, u] = P(""), [g, o] = P(!1), [h, p] = P("ACTIVE");
  re(() => {
    if (a) {
      const f = a?.data;
      u(f?.email ?? "");
      const I = f?.status;
      I && p(I);
    }
  }, [a]);
  const w = async () => {
    if (!t) return;
    const f = { email: d };
    await i.mutateAsync([t, f]), await n.refetch();
  }, S = async () => {
    if (t)
      try {
        o(!0), await l.mutateAsync([t, { status: h }]), de.success(`Status updated to ${h}`), await n.refetch();
      } catch (f) {
        de.error(f.message);
      } finally {
        o(!1);
      }
  };
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit User" }),
    /* @__PURE__ */ e(x, { value: d, onChange: (f) => u(f.target.value), placeholder: "Email" }),
    /* @__PURE__ */ e(y, { onClick: w, type: "primary", loading: s, style: { marginTop: 8 }, children: "Update" }),
    c && /* @__PURE__ */ e("div", { style: { color: "red" }, children: c.message }),
    /* @__PURE__ */ r("div", { style: { marginTop: 24 }, children: [
      /* @__PURE__ */ e("h3", { children: "Update Status" }),
      /* @__PURE__ */ r("div", { style: { display: "flex", gap: 8 }, children: [
        /* @__PURE__ */ e(
          V,
          {
            value: h,
            onChange: (f) => p(f),
            style: { minWidth: 260 },
            options: [
              { value: "ACTIVE", label: "ACTIVE" },
              { value: "INACTIVE", label: "INACTIVE" },
              { value: "LOCKED_OUT", label: "LOCKED_OUT" },
              { value: "SUSPENDED", label: "SUSPENDED" },
              { value: "BANNED", label: "BANNED" },
              { value: "PENDING_VERIFICATION", label: "PENDING_VERIFICATION" },
              { value: "DELETED", label: "DELETED" }
            ]
          }
        ),
        /* @__PURE__ */ e(y, { type: "default", onClick: S, loading: g, children: "Update Status" })
      ] })
    ] })
  ] });
}
const fr = {
  ACTIVE: "green",
  INACTIVE: "default",
  LOCKED_OUT: "orange",
  SUSPENDED: "gold",
  BANNED: "red",
  PENDING_VERIFICATION: "blue",
  DELETED: "volcano"
};
function ga({ readOnly: t = !1 }) {
  const { message: n } = G.useApp(), { userId: a } = ee(), i = Z(), l = vt([a ?? ""], {
    enabled: !!a
  }), s = l.data ?? null, c = l.isLoading, d = l.error, [u, g] = P(!1), [o, h] = P(!1), p = ft(), w = bt(), S = At(), f = X(() => {
    a && l.refetch();
  }, [a, l]);
  re(() => {
    f();
  }, [f]);
  const I = X(async () => {
    if (a)
      try {
        await p.mutateAsync([a]), n.success("User soft-deleted successfully"), f();
      } catch (v) {
        n.error(
          `Failed to delete user: ${v instanceof Error ? v.message : "Unknown error"}`
        );
      }
  }, [a, p, f, n]), R = X(async () => {
    if (a)
      try {
        await w.mutateAsync([a]), n.success("User restored successfully"), f();
      } catch (v) {
        n.error(
          `Failed to restore user: ${v instanceof Error ? v.message : "Unknown error"}`
        );
      }
  }, [a, w, f, n]), M = X(async () => {
    if (a)
      try {
        await S.mutateAsync([a]), n.success("User permanently deleted"), i("..", { relative: "path" });
      } catch (v) {
        n.error(
          `Failed to permanently delete user: ${v instanceof Error ? v.message : "Unknown error"}`
        );
      }
  }, [a, S, i, n]);
  if (c) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (d) return /* @__PURE__ */ e(C, { type: "error", message: d.message, style: { margin: 24 } });
  if (!s) return /* @__PURE__ */ e(C, { type: "warning", message: "User not found", style: { margin: 24 } });
  const E = s, B = E.status === "DELETED" || !!E.deletedAt, F = E.status ?? "ACTIVE";
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "User Detail" }),
          /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(y, { onClick: () => i("..", { relative: "path" }), children: "Back to Users" }) })
        ]
      }
    ),
    B && /* @__PURE__ */ e(
      C,
      {
        type: "warning",
        message: "This user has been soft-deleted",
        description: E.deletedAt ? `Deleted on ${new Date(E.deletedAt).toLocaleString()}. The user can be restored within the grace period.` : "The user can be restored within the grace period.",
        style: { marginBottom: 24 }
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "User ID", children: E.userId }),
      /* @__PURE__ */ e(m.Item, { label: "Email", children: E.email }),
      /* @__PURE__ */ e(m.Item, { label: "Status", children: /* @__PURE__ */ e(T, { color: fr[F] ?? "default", children: F }) }),
      /* @__PURE__ */ e(m.Item, { label: "Roles", children: E.roles?.length ? /* @__PURE__ */ e(k, { wrap: !0, children: E.roles.map((v) => /* @__PURE__ */ e(T, { children: v.name }, v.id)) }) : /* @__PURE__ */ e("span", { style: { color: "#999" }, children: "No roles assigned" }) }),
      E.deletedAt && /* @__PURE__ */ e(m.Item, { label: "Deleted At", children: new Date(E.deletedAt).toLocaleString() })
    ] }),
    !t && /* @__PURE__ */ r(ie, { children: [
      /* @__PURE__ */ e(ne, {}),
      /* @__PURE__ */ e("h3", { children: "User Actions" }),
      /* @__PURE__ */ r(k, { wrap: !0, children: [
        /* @__PURE__ */ e(y, { onClick: () => g(!0), disabled: B, children: "Change Role" }),
        /* @__PURE__ */ e(y, { onClick: () => h(!0), disabled: B, children: "Reset Password" })
      ] }),
      /* @__PURE__ */ e(ne, {}),
      /* @__PURE__ */ e("h3", { children: "Account Lifecycle" }),
      /* @__PURE__ */ e("p", { style: { color: "#666", marginBottom: 16 }, children: "Manage the user's account status. Soft-deleted users have a 30-day grace period before permanent deletion." }),
      /* @__PURE__ */ r(k, { wrap: !0, children: [
        !B && /* @__PURE__ */ e(
          $,
          {
            title: "Soft-delete this user?",
            description: "User will be marked as deleted and can be restored within 30 days.",
            onConfirm: I,
            okText: "Delete",
            okButtonProps: { danger: !0 },
            children: /* @__PURE__ */ e(y, { danger: !0, children: "Delete User" })
          }
        ),
        B && /* @__PURE__ */ r(ie, { children: [
          /* @__PURE__ */ e(
            y,
            {
              type: "primary",
              style: { backgroundColor: "#52c41a", borderColor: "#52c41a" },
              onClick: R,
              children: "Restore User"
            }
          ),
          /* @__PURE__ */ e(
            $,
            {
              title: "Permanently delete this user?",
              description: "This action cannot be undone. All user data will be permanently erased.",
              onConfirm: M,
              okText: "Permanently Delete",
              okButtonProps: { danger: !0 },
              children: /* @__PURE__ */ e(y, { danger: !0, type: "primary", children: "Permanently Delete" })
            }
          )
        ] })
      ] })
    ] }),
    a && /* @__PURE__ */ r(ie, { children: [
      /* @__PURE__ */ e($t, { open: u, userId: a, onClose: () => g(!1) }),
      /* @__PURE__ */ e(Gt, { open: o, userId: a, onClose: () => h(!1) })
    ] })
  ] });
}
function $t({ open: t, userId: n, onClose: a }) {
  const { message: i } = G.useApp(), l = We([], {
    enabled: t
  }), s = l.data, c = Array.isArray(s) ? s : s?.data ?? [], d = on(), u = d.mutateAsync, g = d.status === "pending", o = d.error, [h, p] = P(), w = qe(void 0);
  return re(() => {
    const f = (I) => {
      const M = I.target.closest('[role="option"]');
      if (M) {
        const E = M.textContent?.trim();
        E && (w.current = E, p(E));
      }
    };
    return document.addEventListener("mousedown", f), () => document.removeEventListener("mousedown", f);
  }, []), re(() => {
    t && l.refetch();
  }, [t, l]), /* @__PURE__ */ r(
    Te,
    {
      open: t,
      onCancel: a,
      onOk: async () => {
        const f = w.current;
        if (!f) {
          i.error("Please select a role");
          return;
        }
        await u([n, { userId: n, role: f }]) && (i.success("Role updated"), a());
      },
      confirmLoading: g || l.isPending,
      title: "Change Role",
      children: [
        o && /* @__PURE__ */ e(
          C,
          {
            type: "error",
            message: o?.message ?? "An error occurred",
            style: { marginBottom: 8 }
          }
        ),
        /* @__PURE__ */ e(
          V,
          {
            value: h,
            onChange: (f) => {
              w.current = f, p(f);
            },
            onSelect: (f) => {
              w.current = f, p(f);
            },
            style: { width: "100%" },
            placeholder: "Select role",
            loading: l.isPending,
            children: c.map((f) => /* @__PURE__ */ e(
              V.Option,
              {
                value: f.name,
                onMouseDown: () => {
                  w.current = f.name, p(f.name);
                },
                children: f.name
              },
              f.id
            ))
          }
        )
      ]
    }
  );
}
function Gt({ open: t, userId: n, onClose: a }) {
  const { message: i } = G.useApp(), [l] = b.useForm(), {
    mutateAsync: s,
    isPending: c,
    error: d
  } = dn();
  return /* @__PURE__ */ r(
    Te,
    {
      open: t,
      onCancel: a,
      onOk: async () => {
        const g = await l.validateFields();
        await s([
          n,
          { userId: n, oldPassword: "", newPassword: g.password }
        ]) && (i.success("Password reset"), a(), l.resetFields());
      },
      confirmLoading: c,
      title: "Reset Password",
      children: [
        !!d && /* @__PURE__ */ e(
          C,
          {
            type: "error",
            message: d instanceof Error ? d.message : "An unexpected error occurred",
            style: { marginBottom: 8 }
          }
        ),
        /* @__PURE__ */ r(b, { form: l, layout: "vertical", children: [
          /* @__PURE__ */ e(
            b.Item,
            {
              name: "password",
              label: "New Password",
              rules: [
                {
                  required: !0,
                  min: 8,
                  message: "Password must be at least 8 characters"
                }
              ],
              children: /* @__PURE__ */ e(x.Password, { "aria-label": "New Password" })
            }
          ),
          /* @__PURE__ */ e(
            b.Item,
            {
              name: "confirm",
              label: "Confirm Password",
              dependencies: ["password"],
              rules: [
                { required: !0, message: "Please confirm the password" },
                ({ getFieldValue: g }) => ({
                  validator(o, h) {
                    return !h || g("password") === h ? Promise.resolve() : Promise.reject(new Error("Passwords do not match"));
                  }
                })
              ],
              children: /* @__PURE__ */ e(x.Password, { "aria-label": "Confirm Password" })
            }
          )
        ] })
      ]
    }
  );
}
function ha() {
  const t = N({ feature: "ROLE_MGMT", action: "read" }), n = N({ feature: "ROLE_MGMT", action: "create" }), a = N({ feature: "ROLE_MGMT", action: "update" }), i = N({ feature: "ROLE_MGMT", action: "delete" }), l = N({ feature: "ROLE_MGMT", action: "restore" }), s = We([], {
    enabled: t.allowed
  }), c = pe(s.data), d = s.isPending, u = s.error, g = It(), o = wt(), h = async (S) => {
    try {
      await g.mutateAsync([S]), de.success("Role deleted"), s.refetch();
    } catch {
      de.error("Failed to delete role");
    }
  }, p = async (S) => {
    try {
      await o.mutateAsync([S]), de.success("Role restored"), s.refetch();
    } catch {
      de.error("Failed to restore role");
    }
  };
  if (u) {
    const S = u instanceof Error ? u.message : "Failed to load roles";
    return /* @__PURE__ */ e(C, { type: "error", message: S });
  }
  if (!t.allowed && !d)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Not authorized to view roles" });
  const w = [
    { title: "ID", dataIndex: "id" },
    { title: "Name", dataIndex: "name" },
    {
      title: "Actions",
      key: "actions",
      render: (S, f) => /* @__PURE__ */ r(k, { size: "small", children: [
        a.allowed && /* @__PURE__ */ e(ce, { title: a.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: `/roles/${f.id}/edit`, children: "Edit" }) }),
        i.allowed && !f.deletedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Delete role",
            description: "Are you sure you want to delete this role?",
            onConfirm: () => h(f.id),
            okText: "Delete",
            okButtonProps: { danger: !0 },
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", danger: !0, size: "small", children: "Delete" })
          }
        ),
        l.allowed && f.deletedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Restore role",
            description: "Are you sure you want to restore this role?",
            onConfirm: () => p(f.id),
            okText: "Restore",
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", size: "small", children: "Restore" })
          }
        ),
        !a.allowed && !i.allowed && !l.allowed && /* @__PURE__ */ e(T, { children: "Read-only" })
      ] })
    }
  ];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", marginBottom: 12 }, children: [
      /* @__PURE__ */ e("h2", { style: { margin: 0, flex: 1 }, children: "Roles" }),
      n.allowed && /* @__PURE__ */ e(ce, { title: n.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: "/roles/create", children: /* @__PURE__ */ e(y, { type: "primary", children: "Create Role" }) }) })
    ] }),
    /* @__PURE__ */ e(
      ge,
      {
        "aria-label": "Roles table",
        dataSource: c,
        columns: w,
        rowKey: "id",
        loading: d
      }
    )
  ] });
}
function pa() {
  const [t, n] = P(""), a = cn(), i = a.status === "pending", l = a.error;
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create Role" }),
    /* @__PURE__ */ e(x, { value: t, onChange: (c) => n(c.target.value), placeholder: "Name" }),
    /* @__PURE__ */ e(y, { onClick: async () => {
      const c = { name: t };
      await a.mutateAsync([c]);
    }, type: "primary", loading: i, style: { marginTop: 8 }, children: "Create" }),
    l && /* @__PURE__ */ e("div", { style: { color: "red" }, children: l.message })
  ] });
}
function ya() {
  const { roleId: t } = ee(), n = Ct([t ?? ""], {
    enabled: !!t
  }), a = n.data?.data ?? null, i = un(), l = i.status === "pending", s = i.error, [c, d] = P("");
  return re(() => {
    a && d(a.name ?? "");
  }, [a]), /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit Role" }),
    /* @__PURE__ */ e(x, { value: c, onChange: (g) => d(g.target.value), placeholder: "Name" }),
    /* @__PURE__ */ e(y, { onClick: async () => {
      if (!t) return;
      const g = { name: c };
      await i.mutateAsync([t, g]), await n.refetch();
    }, type: "primary", loading: l, style: { marginTop: 8 }, children: "Update" }),
    s && /* @__PURE__ */ e("div", { style: { color: "red" }, children: s.message })
  ] });
}
function fa() {
  const { message: t } = G.useApp(), { roleId: n } = ee(), a = Z(), i = Ct([n ?? ""], {
    enabled: !!n
  }), l = i.data?.data ?? null, s = i.isLoading, c = i.error, d = It(), u = wt(), g = N({ feature: "ROLE_MGMT", action: "delete" }), o = N({ feature: "ROLE_MGMT", action: "restore" }), h = N({ feature: "ROLE_MGMT", action: "update" }), p = X(() => {
    n && i.refetch();
  }, [n, i]);
  re(() => {
    p();
  }, [p]);
  const w = X(async () => {
    if (n)
      try {
        await d.mutateAsync([n]), t.success("Role deleted"), p();
      } catch {
        t.error("Failed to delete role");
      }
  }, [n, d, p, t]), S = X(async () => {
    if (n)
      try {
        await u.mutateAsync([n]), t.success("Role restored"), p();
      } catch {
        t.error("Failed to restore role");
      }
  }, [n, u, p, t]);
  if (s) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (c) return /* @__PURE__ */ e(C, { type: "error", message: c.message, style: { margin: 24 } });
  if (!l) return /* @__PURE__ */ e(C, { type: "warning", message: "Role not found", style: { margin: 24 } });
  const f = l, I = !!f.deletedAt;
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Role Details" }),
          /* @__PURE__ */ r(k, { children: [
            /* @__PURE__ */ e(y, { onClick: () => a("/roles"), children: "Back to Roles" }),
            h.allowed && !I && /* @__PURE__ */ e(y, { type: "primary", onClick: () => a(`/roles/${n}/edit`), children: "Edit" })
          ] })
        ]
      }
    ),
    I && /* @__PURE__ */ e(
      C,
      {
        type: "warning",
        message: "This role has been deleted",
        description: f.deletedAt ? `Deleted on ${new Date(f.deletedAt).toLocaleString()}. The role can be restored.` : "The role can be restored.",
        style: { marginBottom: 24 }
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "ID", children: f.id }),
      /* @__PURE__ */ e(m.Item, { label: "Name", children: f.name || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Description", children: f.description || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Status", children: /* @__PURE__ */ e(T, { color: I ? "volcano" : "green", children: I ? "Deleted" : "Active" }) }),
      /* @__PURE__ */ e(m.Item, { label: "Permissions", children: f.permissions?.length ? /* @__PURE__ */ e(k, { wrap: !0, children: f.permissions.map((R) => /* @__PURE__ */ e(T, { children: R.featureId }, R.id)) }) : /* @__PURE__ */ e("span", { style: { color: "#999" }, children: "No permissions assigned" }) }),
      f.createdAt && /* @__PURE__ */ e(m.Item, { label: "Created At", children: new Date(f.createdAt).toLocaleString() }),
      f.updatedAt && /* @__PURE__ */ e(m.Item, { label: "Updated At", children: new Date(f.updatedAt).toLocaleString() }),
      f.deletedAt && /* @__PURE__ */ e(m.Item, { label: "Deleted At", children: new Date(f.deletedAt).toLocaleString() })
    ] }),
    /* @__PURE__ */ e(ne, {}),
    /* @__PURE__ */ e("h3", { children: "Lifecycle Actions" }),
    /* @__PURE__ */ e("p", { style: { color: "#666", marginBottom: 16 }, children: "Manage the role's lifecycle. Deleted roles can be restored." }),
    /* @__PURE__ */ r(k, { wrap: !0, children: [
      !I && g.allowed && /* @__PURE__ */ e(
        $,
        {
          title: "Delete role",
          description: "Are you sure you want to delete this role?",
          onConfirm: w,
          okText: "Delete",
          okButtonProps: { danger: !0 },
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(y, { danger: !0, children: "Delete Role" })
        }
      ),
      I && o.allowed && /* @__PURE__ */ e(
        $,
        {
          title: "Restore role",
          description: "Are you sure you want to restore this role?",
          onConfirm: S,
          okText: "Restore",
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(y, { type: "primary", style: { backgroundColor: "#52c41a", borderColor: "#52c41a" }, children: "Restore Role" })
        }
      )
    ] })
  ] });
}
function ba() {
  const t = mn([0, 1e3]), n = t.data?.data ?? [], a = t.isLoading, i = t.error, l = Tt(), s = N({ feature: "PERMISSION_MGMT", action: "read" }), c = N({ feature: "PERMISSION_MGMT", action: "create" }), d = N({ feature: "PERMISSION_MGMT", action: "update" }), u = N({ feature: "PERMISSION_MGMT", action: "delete" }), g = async (h) => {
    try {
      await l.mutateAsync([h]), de.success("Permission deleted"), await t.refetch();
    } catch {
      de.error("Failed to delete permission");
    }
  };
  if (re(() => {
    t.refetch();
  }, [t]), i)
    return /* @__PURE__ */ e(C, { type: "error", message: i.message });
  if (!s.allowed && !a)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Not authorized to view permissions" });
  const o = [
    { title: "ID", dataIndex: "id" },
    { title: "Feature", dataIndex: "featureId" },
    {
      title: "Actions",
      key: "actions",
      render: (h, p) => /* @__PURE__ */ r(k, { size: "small", children: [
        d.allowed && /* @__PURE__ */ e(ce, { title: d.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: `/permissions/${p.id}/edit`, children: "Edit" }) }),
        u.allowed && /* @__PURE__ */ e(
          $,
          {
            title: "Delete permission",
            description: "Are you sure you want to delete this permission?",
            onConfirm: () => g(p.id),
            okText: "Delete",
            okButtonProps: { danger: !0 },
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", danger: !0, size: "small", children: "Delete" })
          }
        ),
        !d.allowed && !u.allowed && /* @__PURE__ */ e(T, { children: "Read-only" })
      ] })
    }
  ];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", marginBottom: 12 }, children: [
      /* @__PURE__ */ e("h2", { style: { margin: 0, flex: 1 }, children: "Permissions" }),
      c.allowed && /* @__PURE__ */ e(ce, { title: c.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: "/permissions/create", children: /* @__PURE__ */ e(y, { type: "primary", children: "Create Permission" }) }) })
    ] }),
    /* @__PURE__ */ e(
      ge,
      {
        dataSource: n,
        columns: o,
        rowKey: "id",
        loading: a
      }
    )
  ] });
}
const br = ({ error: t, className: n, ...a }) => /* @__PURE__ */ r("div", { className: "mb-2", children: [
  /* @__PURE__ */ e(
    "input",
    {
      ...a,
      className: `w-full rounded border p-2 ${t ? "border-red-500" : "border-gray-300"} ${n ?? ""}`
    }
  ),
  t && /* @__PURE__ */ e("p", { className: "mt-1 text-sm text-red-600", children: t })
] }), Ar = ({
  className: t,
  ...n
}) => /* @__PURE__ */ e(
  "button",
  {
    ...n,
    className: `rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 ${t ?? ""}`
  }
);
function Aa() {
  const [t, n] = P(""), [a, i] = P(!1), l = gn(), s = l.status === "pending", c = l.error, d = async (g) => {
    if (g.preventDefault(), i(!0), !t.trim()) return;
    const o = { featureId: t };
    await l.mutateAsync([o]);
  }, u = a && !t.trim() ? "Feature ID is required" : null;
  return /* @__PURE__ */ r("form", { onSubmit: d, className: "p-6 space-y-2", children: [
    /* @__PURE__ */ e("h2", { className: "text-xl font-semibold", children: "Create Permission" }),
    /* @__PURE__ */ e(
      br,
      {
        value: t,
        onChange: (g) => n(g.target.value),
        placeholder: "Feature ID",
        error: u
      }
    ),
    /* @__PURE__ */ e(Ar, { type: "submit", disabled: s, className: "mt-2", children: s ? "Saving…" : "Create" }),
    c && /* @__PURE__ */ e("div", { className: "mt-2 text-red-600", children: c.message })
  ] });
}
function va() {
  const { permissionId: t } = ee(), n = Et([t ?? ""], {
    enabled: !!t
  }), a = n.data?.data ?? null, i = hn(), l = i.status === "pending", s = i.error, [c, d] = P("");
  return re(() => {
    a && d(a.featureId ?? "");
  }, [a]), /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit Permission" }),
    /* @__PURE__ */ e(
      x,
      {
        value: c,
        onChange: (g) => d(g.target.value),
        placeholder: "Feature ID"
      }
    ),
    /* @__PURE__ */ e(y, { onClick: async () => {
      if (!t) return;
      const g = { featureId: c };
      await i.mutateAsync([t, g]), await n.refetch();
    }, type: "primary", loading: l, style: { marginTop: 8 }, children: "Update" }),
    s && /* @__PURE__ */ e("div", { style: { color: "red" }, children: s.message })
  ] });
}
function Ia() {
  const { message: t } = G.useApp(), { permissionId: n } = ee(), a = Z(), i = Et([n ?? ""], {
    enabled: !!n
  }), l = i.data?.data ?? null, s = i.isLoading, c = i.error, d = Tt(), u = N({ feature: "PERMISSION_MGMT", action: "delete" }), g = N({ feature: "PERMISSION_MGMT", action: "update" });
  re(() => {
    n && i.refetch();
  }, [n, i]);
  const o = async () => {
    if (n)
      try {
        await d.mutateAsync([n]), t.success("Permission deleted"), a("/permissions");
      } catch {
        t.error("Failed to delete permission");
      }
  };
  if (s) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (c) return /* @__PURE__ */ e(C, { type: "error", message: c.message, style: { margin: 24 } });
  if (!l)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Permission not found", style: { margin: 24 } });
  const h = l, p = (w) => /* @__PURE__ */ e(T, { color: w ? "green" : "default", children: w ? "Yes" : "No" });
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Permission Details" }),
          /* @__PURE__ */ r(k, { children: [
            /* @__PURE__ */ e(y, { onClick: () => a("/permissions"), children: "Back to Permissions" }),
            g.allowed && /* @__PURE__ */ e(y, { type: "primary", onClick: () => a(`/permissions/${n}/edit`), children: "Edit" })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "ID", children: h.id }),
      /* @__PURE__ */ e(m.Item, { label: "Feature ID", children: h.featureId || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Can Create", children: p(h.canCreate) }),
      /* @__PURE__ */ e(m.Item, { label: "Can Read", children: p(h.canRead) }),
      /* @__PURE__ */ e(m.Item, { label: "Can Update", children: p(h.canUpdate) }),
      /* @__PURE__ */ e(m.Item, { label: "Can Delete", children: p(h.canDelete) }),
      /* @__PURE__ */ e(m.Item, { label: "Can Restore", children: p(h.canRestore) }),
      /* @__PURE__ */ e(m.Item, { label: "Extra Actions", children: h.extraActions?.length ? /* @__PURE__ */ e(k, { wrap: !0, children: h.extraActions.map((w) => /* @__PURE__ */ e(T, { children: w }, w)) }) : /* @__PURE__ */ e("span", { style: { color: "#999" }, children: "None" }) }),
      h.createdAt && /* @__PURE__ */ e(m.Item, { label: "Created At", children: new Date(h.createdAt).toLocaleString() }),
      h.updatedAt && /* @__PURE__ */ e(m.Item, { label: "Updated At", children: new Date(h.updatedAt).toLocaleString() })
    ] }),
    u.allowed && /* @__PURE__ */ r(ie, { children: [
      /* @__PURE__ */ e(ne, {}),
      /* @__PURE__ */ e("h3", { children: "Actions" }),
      /* @__PURE__ */ e(
        $,
        {
          title: "Delete permission",
          description: "Are you sure you want to delete this permission? This action cannot be undone.",
          onConfirm: o,
          okText: "Delete",
          okButtonProps: { danger: !0 },
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(y, { danger: !0, children: "Delete Permission" })
        }
      )
    ] })
  ] });
}
function wa() {
  const t = pn([
    void 0,
    void 0,
    void 0,
    0,
    1e3
  ]), n = t.data?.data ?? [], a = N({ feature: "PERMISSION_ASSIGNMENT", action: "read" }), i = N({
    feature: "PERMISSION_ASSIGNMENT",
    action: "UPDATE_ASSIGNMENT"
  }), l = N({ feature: "PERMISSION_ASSIGNMENT", action: "ASSIGN" }), s = N({ feature: "PERMISSION_ASSIGNMENT", action: "UNASSIGN" });
  re(() => {
    t.refetch();
  }, [t]);
  const c = [
    { title: "SubjectType", dataIndex: "subjectType" },
    { title: "SubjectId", dataIndex: "subjectId" },
    { title: "PermissionId", dataIndex: "permissionId" },
    { title: "ExpiresAt", dataIndex: "expiresAt" },
    {
      title: "Actions",
      key: "actions",
      render: (d, u) => /* @__PURE__ */ r(k, { size: "middle", children: [
        a.allowed && /* @__PURE__ */ e(ce, { title: a.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: `/permission-assignments/${u.id}`, children: "View" }) }),
        i.allowed && /* @__PURE__ */ e(ce, { title: i.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: `/permission-assignments/${u.id}/edit`, children: "Edit" }) }),
        s.allowed && /* @__PURE__ */ e(ce, { title: s.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: `/permission-assignments/${u.id}/delete`, children: "Unassign" }) })
      ] })
    }
  ];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", marginBottom: 12 }, children: [
      /* @__PURE__ */ e("h2", { style: { margin: 0, flex: 1 }, children: "Permission Assignments" }),
      l.allowed && /* @__PURE__ */ e(ce, { title: l.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: "/permission-assignments/create", children: /* @__PURE__ */ e(y, { type: "primary", children: "Assign Permission" }) }) })
    ] }),
    /* @__PURE__ */ e(
      ge,
      {
        "aria-label": "PermissionAssignments table",
        dataSource: n,
        columns: c,
        rowKey: "id"
      }
    )
  ] });
}
function Vt({
  initialValues: t,
  onFinish: n,
  submitText: a = "Submit"
}) {
  return /* @__PURE__ */ r(
    b,
    {
      layout: "vertical",
      initialValues: t,
      onFinish: n,
      style: { maxWidth: 400 },
      children: [
        /* @__PURE__ */ e(b.Item, { label: "Subject Type", name: "subjectType", rules: [{ required: !0 }], children: /* @__PURE__ */ e(V, { options: [{ value: "USER" }, { value: "ROLE" }, { value: "TENANT" }] }) }),
        /* @__PURE__ */ e(b.Item, { label: "Subject ID", name: "subjectId", rules: [{ required: !0 }], children: /* @__PURE__ */ e(x, {}) }),
        /* @__PURE__ */ e(b.Item, { label: "Permission ID", name: "permissionId", rules: [{ required: !0 }], children: /* @__PURE__ */ e(x, {}) }),
        /* @__PURE__ */ e(b.Item, { label: "Expires At", name: "expiresAt", children: /* @__PURE__ */ e(gt, { showTime: !0, style: { width: "100%" } }) }),
        /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e("button", { type: "submit", className: "ant-btn ant-btn-primary", children: a }) })
      ]
    }
  );
}
const vr = (t) => {
  if (!t) return;
  if (typeof t == "string") return t;
  const n = t;
  if (typeof n.toISOString == "function") return n.toISOString();
};
function Ca() {
  const { message: t } = G.useApp(), n = Z(), a = yn();
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create Permission Assignment" }),
    /* @__PURE__ */ e(Vt, { onFinish: async (l) => {
      const s = {
        subjectType: l.subjectType,
        subjectId: l.subjectId,
        permissionId: l.permissionId,
        expiresAt: vr(l.expiresAt)
      };
      await a.mutateAsync([s]), t.success("Permission Assignment created"), n("/permission-assignments");
    }, submitText: "Create" })
  ] });
}
const Ir = (t) => {
  if (!t) return;
  if (typeof t == "string") return t;
  const n = t;
  if (typeof n.toISOString == "function") return n.toISOString();
};
function Ta() {
  const { message: t } = G.useApp(), { assignmentId: n } = ee(), a = Z(), i = St([n ?? ""], {
    enabled: !!n
  }), l = ze(i.data), s = oe(() => {
    if (l)
      return {
        subjectType: l.subjectType,
        subjectId: l.subjectId,
        permissionId: l.permissionId,
        expiresAt: l.expiresAt ? new Date(l.expiresAt).toISOString() : void 0
      };
  }, [l]), c = fn(), d = async (u) => {
    if (!n) return;
    const g = Ir(u.expiresAt), o = g ? { expiresAt: g } : {};
    await c.mutateAsync([n, o]), t.success("Permission Assignment updated"), a(`/permission-assignments/${n}`);
  };
  return i.isPending ? /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(Re, {}) }) : /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit Permission Assignment" }),
    /* @__PURE__ */ e(
      Vt,
      {
        initialValues: s,
        onFinish: d,
        submitText: "Update"
      }
    )
  ] });
}
function Ea() {
  const { assignmentId: t } = ee(), n = St([t ?? ""], {
    enabled: !!t
  }), a = ze(n.data);
  if (n.isPending)
    return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(Re, {}) });
  if (!a) return /* @__PURE__ */ e("div", { children: "No data" });
  const i = a.expiresAt ? new Date(a.expiresAt).toISOString() : "";
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Permission Assignment Detail" }),
    /* @__PURE__ */ r(m, { bordered: !0, children: [
      /* @__PURE__ */ e(m.Item, { label: "SubjectType", children: a.subjectType }),
      /* @__PURE__ */ e(m.Item, { label: "SubjectId", children: a.subjectId }),
      /* @__PURE__ */ e(m.Item, { label: "PermissionId", children: a.permissionId }),
      /* @__PURE__ */ e(m.Item, { label: "ExpiresAt", children: i })
    ] })
  ] });
}
function Sa() {
  const { message: t } = G.useApp(), [n, a] = P(!1), i = N({ feature: "FEATURE_MGMT", action: "read" }), l = N({ feature: "FEATURE_MGMT", action: "create" }), s = N({ feature: "FEATURE_MGMT", action: "update" }), c = N({ feature: "FEATURE_MGMT", action: "delete" }), d = N({ feature: "FEATURE_MGMT", action: "restore" }), u = Ke(
    [void 0, n, 0, 200],
    { enabled: i.allowed }
  ), g = kt(), o = Pt(), h = Dt(), p = oe(
    () => pe(u.data),
    [u.data]
  );
  if (u.error)
    return /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: u.error instanceof Error ? u.error.message : "Failed to load features"
      }
    );
  if (!i.allowed && !i.loading)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Not authorized to view features" });
  const w = async (R) => {
    try {
      await g.mutateAsync([R]), t.success("Feature deleted"), u.refetch();
    } catch {
      t.error("Failed to delete feature");
    }
  }, S = async (R) => {
    try {
      await o.mutateAsync([R]), t.success("Feature restored"), u.refetch();
    } catch {
      t.error("Failed to restore feature");
    }
  }, f = async (R, M) => {
    try {
      await h.mutateAsync([R.id]), t.success(`Feature ${M ? "enabled" : "disabled"}`), u.refetch();
    } catch {
      t.error("Failed to toggle feature");
    }
  }, I = [
    {
      title: "Name",
      dataIndex: "name",
      render: (R, M) => /* @__PURE__ */ e(J, { to: `/features/${M.id}`, children: R || M.id })
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (R) => R || "—"
    },
    {
      title: "Enabled",
      key: "enabled",
      render: (R, M) => /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(T, { color: M.enabled ? "green" : "default", children: M.enabled ? "Enabled" : "Disabled" }),
        s.allowed && !M.deletedAt && /* @__PURE__ */ e(
          se,
          {
            checked: !!M.enabled,
            onChange: (E) => f(M, E),
            loading: h.isPending
          }
        )
      ] })
    },
    {
      title: "Status",
      key: "status",
      render: (R, M) => /* @__PURE__ */ e(T, { color: M.deletedAt ? "volcano" : "green", children: M.deletedAt ? "Deleted" : "Active" })
    },
    {
      title: "Actions",
      key: "actions",
      render: (R, M) => /* @__PURE__ */ r(k, { size: "small", children: [
        /* @__PURE__ */ e(J, { to: `/features/${M.id}`, children: "View" }),
        s.allowed && !M.deletedAt && /* @__PURE__ */ e(ce, { title: s.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: `/features/${M.id}/edit`, children: "Edit" }) }),
        c.allowed && !M.deletedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Delete feature",
            description: "Are you sure you want to delete this feature?",
            onConfirm: () => w(M.id),
            okText: "Delete",
            okButtonProps: { danger: !0 },
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", danger: !0, size: "small", children: "Delete" })
          }
        ),
        d.allowed && M.deletedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Restore feature",
            description: "Are you sure you want to restore this feature?",
            onConfirm: () => S(M.id),
            okText: "Restore",
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", size: "small", children: "Restore" })
          }
        ),
        !s.allowed && !c.allowed && !d.allowed && /* @__PURE__ */ e(T, { children: "Read-only" })
      ] })
    }
  ];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", marginBottom: 12 }, children: [
      /* @__PURE__ */ e("h2", { style: { margin: 0, flex: 1 }, children: "Features" }),
      /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(
          se,
          {
            checked: n,
            onChange: a,
            checkedChildren: "Include deleted",
            unCheckedChildren: "Hide deleted"
          }
        ),
        l.allowed && /* @__PURE__ */ e(ce, { title: l.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: "/features/create", children: /* @__PURE__ */ e(y, { type: "primary", children: "Create Feature" }) }) })
      ] })
    ] }),
    /* @__PURE__ */ e(
      ge,
      {
        "aria-label": "Features table",
        dataSource: p,
        columns: I,
        rowKey: "id",
        loading: u.isLoading
      }
    )
  ] });
}
function ka() {
  const { message: t } = G.useApp(), n = Z(), [a] = b.useForm(), i = bn(), l = async (s) => {
    try {
      await i.mutateAsync([s]), t.success("Feature created successfully"), n("/features");
    } catch (c) {
      t.error(
        `Failed to create feature: ${c instanceof Error ? c.message : "Unknown error"}`
      );
    }
  };
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create Feature" }),
    !!i.error && /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: "Creation failed",
        description: String(
          i.error instanceof Error ? i.error.message : "Unknown error"
        ),
        style: { marginBottom: 16 }
      }
    ),
    /* @__PURE__ */ r(
      b,
      {
        form: a,
        layout: "vertical",
        onFinish: l,
        initialValues: { enabled: !1 },
        style: { maxWidth: 520 },
        children: [
          /* @__PURE__ */ e(
            b.Item,
            {
              name: "name",
              label: "Feature Name",
              rules: [
                { required: !0, message: "Name is required" },
                { min: 3, message: "Name must be at least 3 characters" },
                { max: 100, message: "Name must be at most 100 characters" },
                {
                  pattern: /^[a-zA-Z0-9-_\s]+$/,
                  message: "Only letters, numbers, spaces, hyphens, and underscores are allowed"
                }
              ],
              children: /* @__PURE__ */ e(x, { placeholder: "e.g., FEATURE_FLAG" })
            }
          ),
          /* @__PURE__ */ e(
            b.Item,
            {
              name: "description",
              label: "Description",
              rules: [{ max: 255, message: "Description must be at most 255 characters" }],
              children: /* @__PURE__ */ e(x.TextArea, { rows: 3, placeholder: "Optional description" })
            }
          ),
          /* @__PURE__ */ e(b.Item, { name: "enabled", label: "Enabled", valuePropName: "checked", children: /* @__PURE__ */ e(se, {}) }),
          /* @__PURE__ */ r(b.Item, { children: [
            /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: i.isPending, children: "Create Feature" }),
            /* @__PURE__ */ e(y, { style: { marginLeft: 8 }, onClick: () => n("/features"), children: "Cancel" })
          ] })
        ]
      }
    )
  ] });
}
function Pa() {
  const { featureId: t } = ee(), { message: n } = G.useApp(), a = Z(), [i] = b.useForm(), l = Rt([t ?? ""], {
    enabled: !!t
  }), s = An();
  re(() => {
    if (l.data) {
      const d = l.data;
      i.setFieldsValue({
        name: d.name ?? "",
        description: d.description ?? "",
        enabled: !!d.enabled
      });
    }
  }, [l.data, i]);
  const c = async (d) => {
    if (!t) return;
    const u = {
      id: t,
      name: d.name,
      description: d.description,
      enabled: d.enabled
    };
    try {
      await s.mutateAsync([t, u]), n.success("Feature updated successfully"), a("/features");
    } catch (g) {
      n.error(
        `Failed to update feature: ${g instanceof Error ? g.message : "Unknown error"}`
      );
    }
  };
  return l.isLoading ? /* @__PURE__ */ e("div", { style: { padding: 24, textAlign: "center" }, children: /* @__PURE__ */ e(Re, { size: "large" }) }) : l.error ? /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(
    C,
    {
      type: "error",
      message: "Failed to load feature",
      description: l.error instanceof Error ? l.error.message : "Unknown error"
    }
  ) }) : /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit Feature" }),
    !!s.error && /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: "Update failed",
        description: String(
          s.error instanceof Error ? s.error.message : "Unknown error"
        ),
        style: { marginBottom: 16 }
      }
    ),
    /* @__PURE__ */ r(b, { form: i, layout: "vertical", onFinish: c, style: { maxWidth: 520 }, children: [
      /* @__PURE__ */ e(
        b.Item,
        {
          name: "name",
          label: "Feature Name",
          rules: [
            { required: !0, message: "Name is required" },
            { min: 3, message: "Name must be at least 3 characters" },
            { max: 100, message: "Name must be at most 100 characters" },
            {
              pattern: /^[a-zA-Z0-9-_\s]+$/,
              message: "Only letters, numbers, spaces, hyphens, and underscores are allowed"
            }
          ],
          children: /* @__PURE__ */ e(x, { placeholder: "e.g., FEATURE_FLAG" })
        }
      ),
      /* @__PURE__ */ e(
        b.Item,
        {
          name: "description",
          label: "Description",
          rules: [{ max: 255, message: "Description must be at most 255 characters" }],
          children: /* @__PURE__ */ e(x.TextArea, { rows: 3, placeholder: "Optional description" })
        }
      ),
      /* @__PURE__ */ e(b.Item, { name: "enabled", label: "Enabled", valuePropName: "checked", children: /* @__PURE__ */ e(se, {}) }),
      /* @__PURE__ */ r(b.Item, { children: [
        /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: s.isPending, children: "Update Feature" }),
        /* @__PURE__ */ e(y, { style: { marginLeft: 8 }, onClick: () => a("/features"), children: "Cancel" })
      ] })
    ] })
  ] });
}
function Da() {
  const { message: t } = G.useApp(), { featureId: n } = ee(), a = Z(), {
    data: i,
    isLoading: l,
    error: s,
    refetch: c
  } = Rt([n ?? ""], { enabled: !!n }), d = kt(), u = Pt(), g = Dt(), o = N({ feature: "FEATURE_MGMT", action: "delete" }), h = N({ feature: "FEATURE_MGMT", action: "restore" }), p = N({ feature: "FEATURE_MGMT", action: "update" }), w = async () => {
    if (n)
      try {
        await d.mutateAsync([n]), t.success("Feature deleted"), c();
      } catch {
        t.error("Failed to delete feature");
      }
  }, S = async () => {
    if (n)
      try {
        await u.mutateAsync([n]), t.success("Feature restored"), c();
      } catch {
        t.error("Failed to restore feature");
      }
  }, f = async (M) => {
    if (n)
      try {
        await g.mutateAsync([n]), t.success(`Feature ${M ? "enabled" : "disabled"}`), c();
      } catch {
        t.error("Failed to toggle feature");
      }
  };
  if (l) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (s) return /* @__PURE__ */ e(C, { type: "error", message: String(s), style: { margin: 24 } });
  if (!i) return /* @__PURE__ */ e(C, { type: "warning", message: "Feature not found", style: { margin: 24 } });
  const I = i, R = !!I.deletedAt;
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Feature Details" }),
          /* @__PURE__ */ r(k, { children: [
            /* @__PURE__ */ e(y, { onClick: () => a("/features"), children: "Back to Features" }),
            p.allowed && !R && /* @__PURE__ */ e(y, { type: "primary", onClick: () => a(`/features/${n}/edit`), children: "Edit" })
          ] })
        ]
      }
    ),
    R && /* @__PURE__ */ e(
      C,
      {
        type: "warning",
        message: "This feature has been deleted",
        description: I.deletedAt ? `Deleted on ${new Date(I.deletedAt).toLocaleString()}. The feature can be restored.` : "The feature can be restored.",
        style: { marginBottom: 24 }
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "ID", children: I.id }),
      /* @__PURE__ */ e(m.Item, { label: "Name", children: I.name || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Description", children: I.description || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Global Status", children: /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(T, { color: I.enabled ? "green" : "default", children: I.enabled ? "Enabled" : "Disabled" }),
        p.allowed && !R && /* @__PURE__ */ e(
          se,
          {
            checked: I.enabled,
            onChange: f,
            loading: g.isPending,
            checkedChildren: "ON",
            unCheckedChildren: "OFF"
          }
        )
      ] }) }),
      /* @__PURE__ */ e(m.Item, { label: "Lifecycle Status", children: /* @__PURE__ */ e(T, { color: R ? "volcano" : "green", children: R ? "Deleted" : "Active" }) }),
      I.createdAt && /* @__PURE__ */ e(m.Item, { label: "Created At", children: new Date(I.createdAt).toLocaleString() }),
      I.updatedAt && /* @__PURE__ */ e(m.Item, { label: "Updated At", children: new Date(I.updatedAt).toLocaleString() }),
      I.deletedAt && /* @__PURE__ */ e(m.Item, { label: "Deleted At", children: new Date(I.deletedAt).toLocaleString() })
    ] }),
    /* @__PURE__ */ e(ne, {}),
    /* @__PURE__ */ e("h3", { children: "Lifecycle Actions" }),
    /* @__PURE__ */ e("p", { style: { color: "#666", marginBottom: 16 }, children: "Manage the feature's lifecycle. Deleted features can be restored." }),
    /* @__PURE__ */ r(k, { wrap: !0, children: [
      !R && o.allowed && /* @__PURE__ */ e(
        $,
        {
          title: "Delete feature",
          description: "Are you sure you want to delete this feature? Feature flags using this feature will also be affected.",
          onConfirm: w,
          okText: "Delete",
          okButtonProps: { danger: !0 },
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(y, { danger: !0, loading: d.isPending, children: "Delete Feature" })
        }
      ),
      R && h.allowed && /* @__PURE__ */ e(
        $,
        {
          title: "Restore feature",
          description: "Are you sure you want to restore this feature?",
          onConfirm: S,
          okText: "Restore",
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(
            y,
            {
              type: "primary",
              style: { backgroundColor: "#52c41a", borderColor: "#52c41a" },
              loading: u.isPending,
              children: "Restore Feature"
            }
          )
        }
      )
    ] })
  ] });
}
function Ra() {
  const { message: t } = G.useApp(), n = N({ feature: "FEATURE_FLAG", action: "read" }), a = N({ feature: "FEATURE_FLAG", action: "create" }), i = N({ feature: "FEATURE_FLAG", action: "update" }), l = N({ feature: "FEATURE_FLAG", action: "delete" }), s = N({ feature: "FEATURE_FLAG", action: "restore" }), c = vn([0, 50], {
    enabled: n.allowed
  }), d = Ke([void 0, !0, 0, 200], {
    enabled: n.allowed
  }), u = Je(), g = Mt(), o = xt(), h = oe(
    () => pe(c.data),
    [c.data]
  ), p = oe(
    () => pe(d.data),
    [d.data]
  ), w = oe(() => {
    const F = /* @__PURE__ */ new Map();
    return p.forEach((v) => {
      F.set(v.id, v.name || v.id);
    }), F;
  }, [p]), S = c.isLoading || d.isLoading;
  if (c.error)
    return /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: c.error instanceof Error ? c.error.message : "Failed to load feature flags"
      }
    );
  if (!n.allowed && !n.loading)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Not authorized to view feature flags" });
  const f = (F) => {
    switch (F) {
      case "USER":
        return "User";
      case "ROLE":
        return "Role";
      case "TENANT":
        return "Tenant";
    }
  }, I = (F) => {
    switch (F) {
      case "USER":
        return "blue";
      case "ROLE":
        return "purple";
      case "TENANT":
        return "orange";
    }
  }, R = async (F, v) => {
    try {
      await u.mutateAsync([{ id: F.id, enabled: v }]), t.success(`Feature flag ${v ? "enabled" : "disabled"}`), c.refetch();
    } catch {
      t.error("Failed to update feature flag");
    }
  }, M = async (F) => {
    try {
      await g.mutateAsync([F]), t.success("Feature flag deleted"), c.refetch();
    } catch {
      t.error("Failed to delete feature flag");
    }
  }, E = async (F) => {
    try {
      await o.mutateAsync([F]), t.success("Feature flag restored"), c.refetch();
    } catch {
      t.error("Failed to restore feature flag");
    }
  }, B = [
    {
      title: "Feature",
      key: "feature",
      render: (F, v) => /* @__PURE__ */ e(J, { to: `/features/${v.featureId}`, children: v.feature?.name ?? w.get(v.featureId) ?? v.featureId })
    },
    {
      title: "Target",
      key: "target",
      render: (F, v) => /* @__PURE__ */ r(k, { size: "small", children: [
        /* @__PURE__ */ e(T, { color: I(v.subjectType), children: f(v.subjectType) }),
        /* @__PURE__ */ e("span", { children: v.subjectId })
      ] })
    },
    {
      title: "Enabled",
      key: "enabled",
      render: (F, v) => /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(T, { color: v.enabled ? "green" : "default", children: v.enabled ? "Enabled" : "Disabled" }),
        i.allowed && !v.deletedAt && /* @__PURE__ */ e(
          se,
          {
            checked: v.enabled,
            onChange: (le) => R(v, le),
            loading: u.isPending
          }
        )
      ] })
    },
    {
      title: "Status",
      key: "status",
      render: (F, v) => /* @__PURE__ */ e(T, { color: v.deletedAt ? "volcano" : "green", children: v.deletedAt ? "Deleted" : "Active" })
    },
    {
      title: "Actions",
      key: "actions",
      render: (F, v) => /* @__PURE__ */ r(k, { size: "small", children: [
        /* @__PURE__ */ e(J, { to: `/feature-flags/${v.id}`, children: "View" }),
        i.allowed && !v.deletedAt && /* @__PURE__ */ e(ce, { title: i.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: `/feature-flags/${v.id}/edit`, children: "Edit" }) }),
        l.allowed && !v.deletedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Delete feature flag",
            description: "Are you sure you want to delete this feature flag?",
            onConfirm: () => M(v.id),
            okText: "Delete",
            okButtonProps: { danger: !0 },
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", danger: !0, size: "small", children: "Delete" })
          }
        ),
        s.allowed && v.deletedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Restore feature flag",
            description: "Are you sure you want to restore this feature flag?",
            onConfirm: () => E(v.id),
            okText: "Restore",
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", size: "small", children: "Restore" })
          }
        ),
        !i.allowed && !l.allowed && !s.allowed && /* @__PURE__ */ e(T, { children: "Read-only" })
      ] })
    }
  ];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", marginBottom: 12 }, children: [
      /* @__PURE__ */ e("h2", { style: { margin: 0, flex: 1 }, children: "Feature Flags" }),
      a.allowed && /* @__PURE__ */ e(ce, { title: a.reason === "bypass" ? "Allowed (bypass)" : "Allowed", children: /* @__PURE__ */ e(J, { to: "/feature-flags/create", children: /* @__PURE__ */ e(y, { type: "primary", children: "Create Feature Flag" }) }) })
    ] }),
    /* @__PURE__ */ e(
      ge,
      {
        "aria-label": "Feature flags table",
        dataSource: h,
        columns: B,
        rowKey: "id",
        loading: S
      }
    )
  ] });
}
function Ma() {
  const { message: t } = G.useApp(), n = Z(), [a] = b.useForm(), [i, l] = P("USER"), s = In(), c = Ke([]), d = pe(c.data), u = c.isLoading, g = yt([void 0, 500, 0]), o = We([]), h = pt([0, 500]), p = pe(g.data), w = pe(o.data), S = pe(h.data), f = (E) => {
    l(E), a.setFieldValue("entityId", void 0);
  }, I = async (E) => {
    const B = {
      featureId: E.featureId,
      enabled: E.enabled
    };
    switch (E.entityType) {
      case "USER":
        B.userId = E.entityId;
        break;
      case "ROLE":
        B.roleId = E.entityId;
        break;
      case "TENANT":
        B.tenantId = E.entityId;
        break;
    }
    try {
      await s.mutateAsync([B]), t.success("Feature flag created successfully"), n("/feature-flags");
    } catch (F) {
      t.error(
        `Failed to create feature flag: ${F instanceof Error ? F.message : "Unknown error"}`
      );
    }
  }, R = () => {
    switch (i) {
      case "USER":
        return p.map((E) => ({
          value: E.userId,
          label: E.email || E.userId
        }));
      case "ROLE":
        return w.map((E) => ({
          value: E.id,
          label: E.name || E.id
        }));
      case "TENANT":
        return S.map((E) => ({
          value: E.id,
          label: E.name || E.id
        }));
    }
  }, M = i === "USER" && g.isPending || i === "ROLE" && o.isPending || i === "TENANT" && h.isPending;
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create Feature Flag" }),
    !!s.error && /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: "Creation failed",
        description: String(
          s.error instanceof Error ? s.error.message : "An error occurred while creating the feature flag"
        ),
        showIcon: !0,
        style: { marginBottom: 16 }
      }
    ),
    /* @__PURE__ */ r(
      b,
      {
        form: a,
        layout: "vertical",
        initialValues: { entityType: "USER", enabled: !0 },
        onFinish: I,
        children: [
          /* @__PURE__ */ e(
            b.Item,
            {
              name: "featureId",
              label: "Feature",
              rules: [{ required: !0, message: "Please select a feature" }],
              children: u ? /* @__PURE__ */ e(Re, {}) : /* @__PURE__ */ e(
                V,
                {
                  placeholder: "Select feature",
                  options: d.map((E) => ({
                    label: E.name ?? E.id,
                    value: E.id
                  }))
                }
              )
            }
          ),
          /* @__PURE__ */ e(b.Item, { name: "entityType", label: "Entity Type", children: /* @__PURE__ */ e(
            Oe.Group,
            {
              value: i,
              onChange: (E) => f(E.target.value),
              options: [
                { label: "User", value: "USER" },
                { label: "Role", value: "ROLE" },
                { label: "Tenant", value: "TENANT" }
              ]
            }
          ) }),
          /* @__PURE__ */ e(
            b.Item,
            {
              name: "entityId",
              label: "Entity",
              rules: [{ required: !0, message: "Please select an entity" }],
              children: /* @__PURE__ */ e(
                V,
                {
                  placeholder: "Select entity",
                  loading: M,
                  options: R()
                }
              )
            }
          ),
          /* @__PURE__ */ e(b.Item, { name: "enabled", label: "Enabled", valuePropName: "checked", children: /* @__PURE__ */ e(se, {}) }),
          /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", loading: s.isPending, children: "Create" }) })
        ]
      }
    )
  ] });
}
function xa() {
  const { flagId: t } = ee(), { message: n } = G.useApp(), a = Z(), [i, l] = P(!1), s = Nt([t ?? ""], {
    enabled: !!t
  }), c = s.data, d = Je();
  re(() => {
    c && l(c.enabled);
  }, [c]);
  const u = async () => {
    if (!t) return;
    const o = {
      id: t,
      enabled: i
    };
    try {
      await d.mutateAsync([o]), n.success("Feature flag updated successfully"), a("/feature-flags");
    } catch (h) {
      n.error(
        `Failed to update feature flag: ${h instanceof Error ? h.message : "Unknown error"}`
      );
    }
  };
  if (s.isLoading)
    return /* @__PURE__ */ e("div", { style: { padding: 24, textAlign: "center" }, children: /* @__PURE__ */ e(Re, { size: "large" }) });
  if (s.error)
    return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: "Failed to load feature flag",
        description: s.error instanceof Error ? s.error.message : "Unknown error"
      }
    ) });
  if (!c)
    return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(C, { type: "warning", message: "Feature flag not found" }) });
  const g = {
    USER: "User",
    ROLE: "Role",
    TENANT: "Tenant"
  };
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit Feature Flag" }),
    !!d.error && /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: "Update failed",
        description: String(
          d.error instanceof Error ? d.error.message : "Unknown error"
        ),
        style: { marginBottom: 16 }
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, style: { marginBottom: 24, maxWidth: 600 }, children: [
      /* @__PURE__ */ e(m.Item, { label: "ID", children: c.id }),
      /* @__PURE__ */ e(m.Item, { label: "Feature", children: c.feature?.name ?? c.featureId }),
      /* @__PURE__ */ r(m.Item, { label: "Assigned To", children: [
        /* @__PURE__ */ e(T, { color: "blue", children: g[c.subjectType] }),
        /* @__PURE__ */ e("span", { style: { marginLeft: 8 }, children: c.subjectId })
      ] }),
      /* @__PURE__ */ e(m.Item, { label: "Created At", children: new Date(c.createdAt).toLocaleString() }),
      /* @__PURE__ */ e(m.Item, { label: "Updated At", children: new Date(c.updatedAt).toLocaleString() }),
      c.deletedAt && /* @__PURE__ */ e(m.Item, { label: "Deleted At", children: /* @__PURE__ */ e(T, { color: "red", children: new Date(c.deletedAt).toLocaleString() }) })
    ] }),
    /* @__PURE__ */ r(b, { layout: "vertical", style: { maxWidth: 500 }, children: [
      /* @__PURE__ */ e(b.Item, { label: "Enabled", children: /* @__PURE__ */ e(
        se,
        {
          checked: i,
          onChange: l,
          checkedChildren: "Enabled",
          unCheckedChildren: "Disabled"
        }
      ) }),
      /* @__PURE__ */ r(b.Item, { children: [
        /* @__PURE__ */ e(
          y,
          {
            type: "primary",
            onClick: u,
            loading: d.isPending,
            disabled: i === c.enabled,
            children: "Update Feature Flag"
          }
        ),
        /* @__PURE__ */ e(y, { style: { marginLeft: 8 }, onClick: () => a("/feature-flags"), children: "Cancel" })
      ] })
    ] })
  ] });
}
function Na() {
  const { message: t } = G.useApp(), { flagId: n } = ee(), a = Z(), {
    data: i,
    isLoading: l,
    error: s,
    refetch: c
  } = Nt([n ?? ""], {
    enabled: !!n
  }), d = Mt(), u = xt(), g = Je(), o = N({ feature: "FEATURE_FLAG", action: "delete" }), h = N({ feature: "FEATURE_FLAG", action: "restore" }), p = N({ feature: "FEATURE_FLAG", action: "update" }), w = async () => {
    if (n)
      try {
        await d.mutateAsync([n]), t.success("Feature flag deleted"), c();
      } catch {
        t.error("Failed to delete feature flag");
      }
  }, S = async () => {
    if (n)
      try {
        await u.mutateAsync([n]), t.success("Feature flag restored"), c();
      } catch {
        t.error("Failed to restore feature flag");
      }
  }, f = async (B) => {
    if (n)
      try {
        await g.mutateAsync([{ id: n, enabled: B }]), t.success(`Feature flag ${B ? "enabled" : "disabled"}`), c();
      } catch {
        t.error("Failed to toggle feature flag");
      }
  };
  if (l) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (s) return /* @__PURE__ */ e(C, { type: "error", message: String(s), style: { margin: 24 } });
  if (!i)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Feature flag not found", style: { margin: 24 } });
  const I = i, R = !!I.deletedAt, M = (B) => {
    switch (B) {
      case "USER":
        return "User";
      case "ROLE":
        return "Role";
      case "TENANT":
        return "Tenant";
      default:
        return B || "—";
    }
  }, E = (B) => {
    switch (B) {
      case "USER":
        return "blue";
      case "ROLE":
        return "purple";
      case "TENANT":
        return "orange";
      default:
        return "default";
    }
  };
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Feature Flag Details" }),
          /* @__PURE__ */ r(k, { children: [
            /* @__PURE__ */ e(y, { onClick: () => a("/feature-flags"), children: "Back to Feature Flags" }),
            p.allowed && !R && /* @__PURE__ */ e(y, { type: "primary", onClick: () => a(`/feature-flags/${n}/edit`), children: "Edit" })
          ] })
        ]
      }
    ),
    R && /* @__PURE__ */ e(
      C,
      {
        type: "warning",
        message: "This feature flag has been deleted",
        description: I.deletedAt ? `Deleted on ${new Date(I.deletedAt).toLocaleString()}. The feature flag can be restored.` : "The feature flag can be restored.",
        style: { marginBottom: 24 }
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "ID", children: I.id }),
      /* @__PURE__ */ e(m.Item, { label: "Feature", children: I.feature?.name || I.featureId || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Entity Type", children: /* @__PURE__ */ e(T, { color: E(I.subjectType), children: M(I.subjectType) }) }),
      /* @__PURE__ */ e(m.Item, { label: "Entity ID", children: /* @__PURE__ */ e("code", { children: I.subjectId || "—" }) }),
      /* @__PURE__ */ e(m.Item, { label: "Enabled", children: /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(T, { color: I.enabled ? "green" : "default", children: I.enabled ? "Enabled" : "Disabled" }),
        p.allowed && !R && /* @__PURE__ */ e(
          se,
          {
            checked: I.enabled,
            onChange: f,
            loading: g.isPending,
            checkedChildren: "ON",
            unCheckedChildren: "OFF"
          }
        )
      ] }) }),
      /* @__PURE__ */ e(m.Item, { label: "Lifecycle Status", children: /* @__PURE__ */ e(T, { color: R ? "volcano" : "green", children: R ? "Deleted" : "Active" }) }),
      I.createdAt && /* @__PURE__ */ e(m.Item, { label: "Created At", children: new Date(I.createdAt).toLocaleString() }),
      I.updatedAt && /* @__PURE__ */ e(m.Item, { label: "Updated At", children: new Date(I.updatedAt).toLocaleString() }),
      I.deletedAt && /* @__PURE__ */ e(m.Item, { label: "Deleted At", children: new Date(I.deletedAt).toLocaleString() })
    ] }),
    /* @__PURE__ */ e(ne, {}),
    /* @__PURE__ */ e("h3", { children: "Lifecycle Actions" }),
    /* @__PURE__ */ e("p", { style: { color: "#666", marginBottom: 16 }, children: "Manage the feature flag's lifecycle. Deleted feature flags can be restored." }),
    /* @__PURE__ */ r(k, { wrap: !0, children: [
      !R && o.allowed && /* @__PURE__ */ e(
        $,
        {
          title: "Delete feature flag",
          description: "Are you sure you want to delete this feature flag?",
          onConfirm: w,
          okText: "Delete",
          okButtonProps: { danger: !0 },
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(y, { danger: !0, loading: d.isPending, children: "Delete Feature Flag" })
        }
      ),
      R && h.allowed && /* @__PURE__ */ e(
        $,
        {
          title: "Restore feature flag",
          description: "Are you sure you want to restore this feature flag?",
          onConfirm: S,
          okText: "Restore",
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(
            y,
            {
              type: "primary",
              style: { backgroundColor: "#52c41a", borderColor: "#52c41a" },
              loading: u.isPending,
              children: "Restore Feature Flag"
            }
          )
        }
      )
    ] })
  ] });
}
function La() {
  const {
    data: t,
    status: n,
    error: a,
    refetch: i
  } = wn([void 0, void 0, !0], {
    refetchOnWindowFocus: !1
  }), l = Lt(), s = n === "pending", c = N({ feature: "CONSENT_MGMT", action: "read" }), d = N({ feature: "CONSENT_MGMT", action: "create" }), u = N({ feature: "CONSENT_MGMT", action: "delete" }), g = async (h) => {
    try {
      await l.mutateAsync([{ consentId: h }]), de.success("Consent revoked"), i();
    } catch {
      de.error("Failed to revoke consent");
    }
  };
  if (a)
    return /* @__PURE__ */ e(C, { type: "error", message: a?.message ?? "Failed to load consents" });
  if (!c.allowed && !s)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Not authorized to view consents" });
  const o = [
    { title: "ID", dataIndex: "id", ellipsis: !0, width: 200 },
    {
      title: "User",
      key: "user",
      render: (h, p) => p.user?.email ?? p.userId
    },
    {
      title: "Tenant",
      key: "tenant",
      render: (h, p) => p.tenant?.name ?? p.tenantId
    },
    {
      title: "Scopes",
      dataIndex: "scopes",
      render: (h) => /* @__PURE__ */ e(k, { wrap: !0, children: (h || "").split(" ").filter(Boolean).map((p) => /* @__PURE__ */ e(T, { children: p }, p)) })
    },
    { title: "Version", dataIndex: "version" },
    {
      title: "Status",
      key: "status",
      render: (h, p) => p.revokedAt ? /* @__PURE__ */ e(T, { color: "red", children: "Revoked" }) : /* @__PURE__ */ e(T, { color: "green", children: "Active" })
    },
    {
      title: "Consented At",
      dataIndex: "consentedAt",
      render: (h) => h ? new Date(h).toLocaleString() : "-"
    },
    {
      title: "Actions",
      key: "actions",
      render: (h, p) => /* @__PURE__ */ r(k, { size: "small", children: [
        /* @__PURE__ */ e(J, { to: `/consents/${p.id}`, children: "View" }),
        u.allowed && !p.revokedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Revoke consent",
            description: "Are you sure you want to revoke this consent?",
            onConfirm: () => g(p.id),
            okText: "Revoke",
            okButtonProps: { danger: !0 },
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { type: "link", danger: !0, size: "small", children: "Revoke" })
          }
        )
      ] })
    }
  ];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", marginBottom: 12 }, children: [
      /* @__PURE__ */ e("h2", { style: { margin: 0, flex: 1 }, children: "Consents" }),
      d.allowed && /* @__PURE__ */ e(ce, { title: "Create new consent", children: /* @__PURE__ */ e(J, { to: "/consents/create", children: /* @__PURE__ */ e(y, { type: "primary", children: "Create Consent" }) }) })
    ] }),
    /* @__PURE__ */ e(
      ge,
      {
        "aria-label": "Consents table",
        dataSource: t?.data ?? [],
        columns: o,
        rowKey: "id",
        loading: s
      }
    )
  ] });
}
function Fa() {
  const [t, n] = P(""), { mutate: a, status: i, error: l } = Cn();
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create Consent" }),
    /* @__PURE__ */ e(x, { value: t, onChange: (d) => n(d.target.value), placeholder: "Name" }),
    /* @__PURE__ */ e(y, { onClick: async () => {
      await a([{ name: t }]);
    }, type: "primary", loading: i === "pending", style: { marginTop: 8 }, children: "Create" }),
    !!l && /* @__PURE__ */ e("div", { style: { color: "red" }, children: l?.message ?? "Error" })
  ] });
}
function Ua() {
  const { consentId: t } = ee(), { mutate: n, status: a, error: i } = Tn(), l = a === "pending", [s, c] = P("");
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Edit Consent" }),
    /* @__PURE__ */ e(x, { value: s, onChange: (u) => c(u.target.value), placeholder: "Name" }),
    /* @__PURE__ */ e(y, { onClick: async () => {
      if (!t) return;
      await n([{ name: s, consentId: t }]);
    }, type: "primary", loading: l, style: { marginTop: 8 }, children: "Update" }),
    !!i && /* @__PURE__ */ e("div", { style: { color: "red" }, children: i?.message ?? "Error" })
  ] });
}
function Oa() {
  const { id: t } = ee(), n = t ?? "", {
    data: a,
    status: i,
    error: l,
    refetch: s
  } = En([n], {
    enabled: !!t,
    refetchOnWindowFocus: !1
  }), c = Lt(), d = i === "pending", u = N({ feature: "CONSENT_MGMT", action: "delete" }), g = async () => {
    if (t)
      try {
        await c.mutateAsync([{ consentId: t }]), de.success("Consent revoked"), s();
      } catch {
        de.error("Failed to revoke consent");
      }
  };
  if (d)
    return /* @__PURE__ */ e("div", { style: { padding: 24, textAlign: "center" }, children: /* @__PURE__ */ e(Re, { size: "large" }) });
  if (l)
    return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(C, { type: "error", message: l?.message ?? "Failed to load consent" }) });
  const o = a;
  if (!o)
    return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ e(C, { type: "warning", message: "Consent not found" }) });
  const h = (o.scopes || "").split(" ").filter(Boolean);
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r("div", { style: { display: "flex", alignItems: "center", marginBottom: 16 }, children: [
      /* @__PURE__ */ e("h2", { style: { margin: 0, flex: 1 }, children: "Consent Details" }),
      /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(J, { to: "/consents", children: /* @__PURE__ */ e(y, { children: "Back to List" }) }),
        u.allowed && !o.revokedAt && /* @__PURE__ */ e(
          $,
          {
            title: "Revoke consent",
            description: "Are you sure you want to revoke this consent?",
            onConfirm: g,
            okText: "Revoke",
            okButtonProps: { danger: !0 },
            cancelText: "Cancel",
            children: /* @__PURE__ */ e(y, { danger: !0, children: "Revoke Consent" })
          }
        )
      ] })
    ] }),
    o.revokedAt && /* @__PURE__ */ e(
      C,
      {
        type: "warning",
        message: "This consent has been revoked",
        description: o.revocationReason || void 0,
        style: { marginBottom: 16 }
      }
    ),
    /* @__PURE__ */ e(K, { children: /* @__PURE__ */ r(m, { bordered: !0, column: 1, children: [
      /* @__PURE__ */ e(m.Item, { label: "ID", children: o.id }),
      /* @__PURE__ */ r(m.Item, { label: "User", children: [
        o.user?.email ?? o.userId,
        o.user?.id && o.user.id !== o.userId && /* @__PURE__ */ r("span", { style: { marginLeft: 8, color: "#888" }, children: [
          "(",
          o.userId,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ r(m.Item, { label: "Tenant", children: [
        o.tenant?.name ?? o.tenantId,
        o.tenant?.id && o.tenant.id !== o.tenantId && /* @__PURE__ */ r("span", { style: { marginLeft: 8, color: "#888" }, children: [
          "(",
          o.tenantId,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ e(m.Item, { label: "Scopes", children: /* @__PURE__ */ e(k, { wrap: !0, children: h.length > 0 ? h.map((p) => /* @__PURE__ */ e(T, { children: p }, p)) : /* @__PURE__ */ e("span", { style: { color: "#888" }, children: "No scopes" }) }) }),
      /* @__PURE__ */ e(m.Item, { label: "Policy Version", children: o.version || /* @__PURE__ */ e("span", { style: { color: "#888" }, children: "Not specified" }) }),
      /* @__PURE__ */ e(m.Item, { label: "Status", children: o.revokedAt ? /* @__PURE__ */ e(T, { color: "red", children: "Revoked" }) : /* @__PURE__ */ e(T, { color: "green", children: "Active" }) }),
      /* @__PURE__ */ e(m.Item, { label: "Consented At", children: o.consentedAt ? new Date(o.consentedAt).toLocaleString() : "-" }),
      o.revokedAt && /* @__PURE__ */ r(ie, { children: [
        /* @__PURE__ */ e(m.Item, { label: "Revoked At", children: new Date(o.revokedAt).toLocaleString() }),
        o.revocationReason && /* @__PURE__ */ e(m.Item, { label: "Revocation Reason", children: o.revocationReason })
      ] }),
      /* @__PURE__ */ e(m.Item, { label: "Created At", children: o.createdAt ? new Date(o.createdAt).toLocaleString() : "-" }),
      /* @__PURE__ */ e(m.Item, { label: "Updated At", children: o.updatedAt ? new Date(o.updatedAt).toLocaleString() : "-" })
    ] }) })
  ] });
}
function Ba() {
  const {
    data: t = [],
    isLoading: n,
    error: a
  } = Sn(["current"]);
  if (a)
    return /* @__PURE__ */ e(C, { type: "error", message: a?.message ?? "Error" });
  const i = t?.data ?? [];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Sessions" }),
    /* @__PURE__ */ e(ge, { dataSource: i, columns: [
      { title: "ID", dataIndex: "id" },
      { title: "User", dataIndex: "userId" }
    ], rowKey: "id", loading: n })
  ] });
}
function _a() {
  const { message: t } = G.useApp(), { sessionId: n } = ee(), a = Z(), {
    data: i,
    isLoading: l,
    error: s,
    refetch: c
  } = kn([n ?? ""]), d = Pn(), u = N({ feature: "SESSION_MGMT", action: "delete" }), g = async () => {
    if (n)
      try {
        await d.mutateAsync([n]), t.success("Session revoked"), c();
      } catch {
        t.error("Failed to revoke session");
      }
  };
  if (l) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (s) return /* @__PURE__ */ e(C, { type: "error", message: String(s), style: { margin: 24 } });
  if (!i) return /* @__PURE__ */ e(C, { type: "warning", message: "Session not found", style: { margin: 24 } });
  const o = i, h = !!o.revokedAt, p = o.expiresAt ? new Date(o.expiresAt) < /* @__PURE__ */ new Date() : !1, w = () => h ? /* @__PURE__ */ e(T, { color: "volcano", children: "Revoked" }) : p ? /* @__PURE__ */ e(T, { color: "orange", children: "Expired" }) : /* @__PURE__ */ e(T, { color: "green", children: "Active" }), S = (f) => f ? f.includes("Chrome") ? `Chrome (${f.includes("Mobile") ? "Mobile" : "Desktop"})` : f.includes("Firefox") ? `Firefox (${f.includes("Mobile") ? "Mobile" : "Desktop"})` : f.includes("Safari") && !f.includes("Chrome") ? `Safari (${f.includes("Mobile") ? "Mobile" : "Desktop"})` : f.includes("Edge") ? "Microsoft Edge" : f.substring(0, 50) + (f.length > 50 ? "..." : "") : "—";
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Session Details" }),
          /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(y, { onClick: () => a("..", { relative: "path" }), children: "Back to Sessions" }) })
        ]
      }
    ),
    h && /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: "This session has been revoked",
        description: o.revokedAt ? `Revoked on ${new Date(o.revokedAt).toLocaleString()}` : void 0,
        style: { marginBottom: 24 }
      }
    ),
    !h && p && /* @__PURE__ */ e(
      C,
      {
        type: "warning",
        message: "This session has expired",
        description: o.expiresAt ? `Expired on ${new Date(o.expiresAt).toLocaleString()}` : void 0,
        style: { marginBottom: 24 }
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "Session ID", children: o.id }),
      /* @__PURE__ */ e(m.Item, { label: "User", children: o.user ? /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ r("span", { children: [
          o.user.firstName,
          " ",
          o.user.lastName
        ] }),
        /* @__PURE__ */ e(T, { children: o.user.email })
      ] }) : o.userId || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Status", children: w() }),
      /* @__PURE__ */ e(m.Item, { label: "IP Address", children: /* @__PURE__ */ e("code", { children: o.ipAddress || "—" }) }),
      /* @__PURE__ */ e(m.Item, { label: "User Agent", children: /* @__PURE__ */ e("span", { title: o.userAgent, children: S(o.userAgent) }) }),
      /* @__PURE__ */ e(m.Item, { label: "Created At", children: o.createdAt ? new Date(o.createdAt).toLocaleString() : "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Expires At", children: o.expiresAt ? /* @__PURE__ */ r(k, { children: [
        new Date(o.expiresAt).toLocaleString(),
        p && /* @__PURE__ */ e(T, { color: "orange", children: "Expired" })
      ] }) : "—" }),
      o.revokedAt && /* @__PURE__ */ e(m.Item, { label: "Revoked At", children: new Date(o.revokedAt).toLocaleString() })
    ] }),
    !h && !p && u.allowed && /* @__PURE__ */ r(ie, { children: [
      /* @__PURE__ */ e(ne, {}),
      /* @__PURE__ */ e("h3", { children: "Session Actions" }),
      /* @__PURE__ */ e("p", { style: { color: "#666", marginBottom: 16 }, children: "Revoke this session to immediately log out the user from this device." }),
      /* @__PURE__ */ e(
        $,
        {
          title: "Revoke session",
          description: "Are you sure you want to revoke this session? The user will be logged out immediately.",
          onConfirm: g,
          okText: "Revoke",
          okButtonProps: { danger: !0 },
          cancelText: "Cancel",
          children: /* @__PURE__ */ e(y, { danger: !0, loading: d.isPending, children: "Revoke Session" })
        }
      )
    ] })
  ] });
}
function za() {
  const { data: t } = Dn([void 0]), n = pe(t);
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Login Attempt History" }),
    /* @__PURE__ */ e(ge, { dataSource: n, columns: [
      { title: "Timestamp", dataIndex: "timestamp" },
      { title: "User", dataIndex: "userId" },
      { title: "Tenant", dataIndex: "tenantId" },
      { title: "IP", dataIndex: "ipAddress" },
      { title: "User Agent", dataIndex: "userAgent" },
      { title: "Method", dataIndex: "method" },
      { title: "Device", dataIndex: "deviceInfo" },
      { title: "Geo", dataIndex: "geoLocation" },
      {
        title: "Status",
        dataIndex: "success",
        render: (i, l) => /* @__PURE__ */ r(ie, { children: [
          /* @__PURE__ */ e(T, { color: i ? "green" : "red", children: i ? "Success" : "Failure" }),
          l.lockoutApplied && /* @__PURE__ */ e(T, { color: "red", children: "Locked" })
        ] })
      },
      {
        title: "Actions",
        render: (i, l) => l.userId ? /* @__PURE__ */ e(J, { to: `../users/${l.userId}`, relative: "path", children: "View User" }) : /* @__PURE__ */ e(y, { type: "link", disabled: !0, children: "View User" })
      }
    ], rowKey: "id" })
  ] });
}
function $a() {
  const { loginAttemptId: t } = ee(), n = Z(), {
    data: a,
    isLoading: i,
    error: l
  } = Rn([t ?? ""]);
  if (i) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (l) return /* @__PURE__ */ e(C, { type: "error", message: String(l), style: { margin: 24 } });
  if (!a)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Login attempt not found", style: { margin: 24 } });
  const s = a, c = () => s.success ? /* @__PURE__ */ e(T, { icon: /* @__PURE__ */ e(Ye, {}), color: "success", children: "Successful" }) : /* @__PURE__ */ e(T, { icon: /* @__PURE__ */ e(De, {}), color: "error", children: "Failed" }), d = (g) => g ? g.includes("Chrome") ? `Chrome (${g.includes("Mobile") ? "Mobile" : "Desktop"})` : g.includes("Firefox") ? `Firefox (${g.includes("Mobile") ? "Mobile" : "Desktop"})` : g.includes("Safari") && !g.includes("Chrome") ? `Safari (${g.includes("Mobile") ? "Mobile" : "Desktop"})` : g.includes("Edge") ? "Microsoft Edge" : g.substring(0, 50) + (g.length > 50 ? "..." : "") : "—", u = () => {
    if (!s.location) return "—";
    const g = [s.location.city, s.location.region, s.location.country].filter(Boolean);
    return g.length > 0 ? g.join(", ") : "—";
  };
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Login Attempt Details" }),
          /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(y, { onClick: () => n("..", { relative: "path" }), children: "Back to Login Attempts" }) })
        ]
      }
    ),
    !s.success && s.failureReason && /* @__PURE__ */ e(
      C,
      {
        type: "error",
        icon: /* @__PURE__ */ e(zn, {}),
        message: "Login Failed",
        description: s.failureReason,
        style: { marginBottom: 24 }
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "Attempt ID", children: s.id }),
      /* @__PURE__ */ e(m.Item, { label: "Status", children: c() }),
      /* @__PURE__ */ e(m.Item, { label: "User", children: s.user ? /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ r("span", { children: [
          s.user.firstName,
          " ",
          s.user.lastName
        ] }),
        /* @__PURE__ */ e(T, { children: s.user.email })
      ] }) : s.email || s.userId || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Email", children: s.email || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "IP Address", children: /* @__PURE__ */ e("code", { children: s.ipAddress || "—" }) }),
      /* @__PURE__ */ e(m.Item, { label: "Location", children: u() }),
      /* @__PURE__ */ e(m.Item, { label: "User Agent", children: /* @__PURE__ */ e("span", { title: s.userAgent, children: d(s.userAgent) }) }),
      /* @__PURE__ */ e(m.Item, { label: "MFA", children: s.mfaUsed ? /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(T, { color: "blue", children: "MFA Used" }),
        s.mfaMethod && /* @__PURE__ */ e(T, { children: s.mfaMethod })
      ] }) : /* @__PURE__ */ e(T, { color: "default", children: "No MFA" }) }),
      !s.success && s.failureReason && /* @__PURE__ */ e(m.Item, { label: "Failure Reason", children: /* @__PURE__ */ e(T, { color: "error", children: s.failureReason }) }),
      /* @__PURE__ */ e(m.Item, { label: "Timestamp", children: s.createdAt ? new Date(s.createdAt).toLocaleString() : "—" })
    ] })
  ] });
}
function dt(t) {
  return t.deletedAt ? { label: "Deleted", color: "default" } : t.declinedAt ? { label: "Declined", color: "orange" } : t.usedAt ? { label: "Used", color: "green" } : t.expiresAt && new Date(t.expiresAt) < /* @__PURE__ */ new Date() ? { label: "Expired", color: "red" } : { label: "Pending", color: "blue" };
}
function wr(t) {
  return !t.deletedAt && !t.declinedAt && !t.usedAt;
}
function Ga({ readOnly: t = !1 } = {}) {
  const n = Mn([0, 100]), a = n.data?.data ?? [], i = n.isLoading, l = n.error, s = (h) => ({
    onSuccess: async () => {
      de.success(`Invitation ${h}.`), await n.refetch();
    },
    onError: (p) => {
      const w = p instanceof Error ? p.message : `Failed to ${h} invitation.`;
      de.error(w);
    }
  }), c = Ft(s("resent")), d = Ut(
    s("canceled")
  ), u = xn(
    s("marked as used")
  ), g = Nn(
    s("marked as declined")
  );
  if (l)
    return /* @__PURE__ */ e(C, { type: "error", title: l.message });
  const o = [
    {
      title: "Email",
      key: "email",
      render: (h, p) => p.email ?? p.user?.email ?? "-"
    },
    {
      title: "Status",
      key: "status",
      render: (h, p) => {
        const { label: w, color: S } = dt(p);
        return /* @__PURE__ */ e(T, { color: S, children: w });
      },
      filters: [
        { text: "Pending", value: "Pending" },
        { text: "Used", value: "Used" },
        { text: "Declined", value: "Declined" },
        { text: "Expired", value: "Expired" },
        { text: "Deleted", value: "Deleted" }
      ],
      onFilter: (h, p) => dt(p).label === h
    },
    {
      title: "Expires",
      dataIndex: "expiresAt",
      key: "expiresAt",
      render: (h) => h ? new Date(h).toLocaleDateString() : "-",
      sorter: (h, p) => new Date(h.expiresAt).getTime() - new Date(p.expiresAt).getTime()
    },
    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (h) => h ? new Date(h).toLocaleDateString() : "-",
      sorter: (h, p) => new Date(h.createdAt).getTime() - new Date(p.createdAt).getTime(),
      defaultSortOrder: "descend"
    },
    ...t ? [] : [
      {
        title: "Actions",
        key: "actions",
        render: (h, p) => {
          const w = wr(p);
          return /* @__PURE__ */ r(k, { children: [
            /* @__PURE__ */ e(
              $,
              {
                title: "Resend invitation?",
                description: "This will trigger a resend (side-effect only).",
                okText: "Resend",
                cancelText: "Cancel",
                onConfirm: () => c.mutate([p.id]),
                children: /* @__PURE__ */ e(y, { size: "small", disabled: !w, loading: c.isPending, children: "Resend" })
              }
            ),
            /* @__PURE__ */ e(
              $,
              {
                title: "Mark as used?",
                description: "Mark this invitation as accepted/used.",
                okText: "Confirm",
                cancelText: "Cancel",
                onConfirm: () => u.mutate([p.id]),
                children: /* @__PURE__ */ e(
                  y,
                  {
                    size: "small",
                    disabled: !w,
                    loading: u.isPending,
                    children: "Mark Used"
                  }
                )
              }
            ),
            /* @__PURE__ */ e(
              $,
              {
                title: "Decline invitation?",
                description: "Mark this invitation as declined.",
                okText: "Confirm",
                cancelText: "Cancel",
                onConfirm: () => g.mutate([p.id]),
                children: /* @__PURE__ */ e(
                  y,
                  {
                    size: "small",
                    disabled: !w,
                    loading: g.isPending,
                    children: "Decline"
                  }
                )
              }
            ),
            /* @__PURE__ */ e(
              $,
              {
                title: "Cancel invitation?",
                description: "This will cancel the invitation permanently.",
                okText: "Confirm",
                cancelText: "Cancel",
                onConfirm: () => d.mutate([p.id]),
                children: /* @__PURE__ */ e(
                  y,
                  {
                    size: "small",
                    danger: !0,
                    disabled: !w,
                    loading: d.isPending,
                    children: "Cancel"
                  }
                )
              }
            )
          ] });
        }
      }
    ]
  ];
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Invitations" }),
    /* @__PURE__ */ e(
      ge,
      {
        dataSource: a,
        columns: o,
        rowKey: "id",
        loading: i
      }
    )
  ] });
}
function Va() {
  const [t, n] = P(""), a = Ln(), i = a.status === "pending", l = a.error;
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ e("h2", { children: "Create Invitation" }),
    /* @__PURE__ */ e(x, { value: t, onChange: (c) => n(c.target.value), placeholder: "Email" }),
    /* @__PURE__ */ e(y, { onClick: async () => {
      const c = { email: t };
      await a.mutateAsync([c]);
    }, type: "primary", loading: i, style: { marginTop: 8 }, children: "Create" }),
    l && /* @__PURE__ */ e("div", { style: { color: "red" }, children: l.message })
  ] });
}
function ja() {
  const { message: t } = G.useApp(), { invitationId: n } = ee(), a = Z(), { data: i, isLoading: l, error: s, refetch: c } = Ot(
    [n ?? ""],
    {
      enabled: !!n
    }
  ), d = ze(i), u = Ft(), g = Ut(), o = async () => {
    n && (await u.mutateAsync([n]), t.success("Invitation resent"), c());
  }, h = async () => {
    n && (await g.mutateAsync([n]), t.success("Invitation cancelled"), c());
  };
  return l ? /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." }) : s ? /* @__PURE__ */ e(C, { type: "error", message: String(s), style: { margin: 24 } }) : d ? /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Invitation" }),
          /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(y, { onClick: () => a("..", { relative: "path" }), children: "Back" }) })
        ]
      }
    ),
    /* @__PURE__ */ e(
      C,
      {
        type: "info",
        message: "Invitations cannot be edited",
        description: "Use Resend or Cancel to manage an invitation.",
        style: { marginBottom: 16 },
        showIcon: !0
      }
    ),
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "Invitation ID", children: d.id }),
      /* @__PURE__ */ e(m.Item, { label: "Email", children: d.email ? /* @__PURE__ */ e("a", { href: `mailto:${d.email}`, children: d.email }) : "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Status", children: /* @__PURE__ */ e(T, { children: d.status ?? "—" }) }),
      /* @__PURE__ */ e(m.Item, { label: "Created At", children: d.createdAt ? new Date(d.createdAt).toLocaleString() : "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Expires At", children: d.expiresAt ? new Date(d.expiresAt).toLocaleString() : "—" })
    ] }),
    /* @__PURE__ */ e(ne, {}),
    /* @__PURE__ */ r(k, { children: [
      /* @__PURE__ */ e(y, { onClick: o, loading: u.isPending, children: "Resend" }),
      /* @__PURE__ */ e(
        $,
        {
          title: "Cancel invitation",
          description: "Are you sure? The recipient will no longer be able to accept it.",
          okText: "Cancel Invitation",
          okButtonProps: { danger: !0 },
          cancelText: "Keep",
          onConfirm: h,
          children: /* @__PURE__ */ e(y, { danger: !0, loading: g.isPending, children: "Cancel" })
        }
      )
    ] })
  ] }) : /* @__PURE__ */ e(C, { type: "warning", message: "Invitation not found", style: { margin: 24 } });
}
function qa() {
  const { message: t } = G.useApp(), { invitationId: n } = ee(), a = Z(), {
    data: i,
    isLoading: l,
    error: s,
    refetch: c
  } = Ot([n ?? ""], {
    enabled: !!n
  }), d = Fn(), u = N({ feature: "INVITATION_MGMT", action: "delete" }), g = async () => {
    if (n)
      try {
        await d.mutateAsync([n]), t.success("Invitation cancelled"), c();
      } catch {
        t.error("Failed to cancel invitation");
      }
  };
  if (l) return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: "Loading..." });
  if (s) return /* @__PURE__ */ e(C, { type: "error", message: String(s), style: { margin: 24 } });
  if (!i)
    return /* @__PURE__ */ e(C, { type: "warning", message: "Invitation not found", style: { margin: 24 } });
  const o = i, h = o.expiresAt ? new Date(o.expiresAt) < /* @__PURE__ */ new Date() : !1, p = o.status === "PENDING" && !h, w = () => o.status === "ACCEPTED" ? /* @__PURE__ */ e(T, { icon: /* @__PURE__ */ e(Ye, {}), color: "success", children: "Accepted" }) : o.status === "DECLINED" ? /* @__PURE__ */ e(T, { icon: /* @__PURE__ */ e(De, {}), color: "error", children: "Declined" }) : o.status === "CANCELLED" ? /* @__PURE__ */ e(T, { icon: /* @__PURE__ */ e(De, {}), color: "default", children: "Cancelled" }) : h || o.status === "EXPIRED" ? /* @__PURE__ */ e(T, { icon: /* @__PURE__ */ e($n, {}), color: "warning", children: "Expired" }) : /* @__PURE__ */ e(T, { icon: /* @__PURE__ */ e(Gn, {}), color: "processing", children: "Pending" });
  return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24
        },
        children: [
          /* @__PURE__ */ e("h2", { style: { margin: 0 }, children: "Invitation Details" }),
          /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(y, { onClick: () => a("..", { relative: "path" }), children: "Back to Invitations" }) })
        ]
      }
    ),
    o.status === "ACCEPTED" ? /* @__PURE__ */ e(
      C,
      {
        type: "success",
        message: "Invitation Accepted",
        description: o.acceptedAt ? `Accepted on ${new Date(o.acceptedAt).toLocaleString()}` : void 0,
        style: { marginBottom: 24 }
      }
    ) : o.status === "DECLINED" ? /* @__PURE__ */ e(
      C,
      {
        type: "error",
        message: "Invitation Declined",
        description: o.declinedAt ? `Declined on ${new Date(o.declinedAt).toLocaleString()}` : void 0,
        style: { marginBottom: 24 }
      }
    ) : o.status === "CANCELLED" ? /* @__PURE__ */ e(
      C,
      {
        type: "info",
        message: "Invitation Cancelled",
        description: o.cancelledAt ? `Cancelled on ${new Date(o.cancelledAt).toLocaleString()}` : void 0,
        style: { marginBottom: 24 }
      }
    ) : h || o.status === "EXPIRED" ? /* @__PURE__ */ e(
      C,
      {
        type: "warning",
        message: "Invitation Expired",
        description: o.expiresAt ? `Expired on ${new Date(o.expiresAt).toLocaleString()}` : void 0,
        style: { marginBottom: 24 }
      }
    ) : null,
    /* @__PURE__ */ r(m, { bordered: !0, column: 1, size: "small", children: [
      /* @__PURE__ */ e(m.Item, { label: "Invitation ID", children: o.id }),
      /* @__PURE__ */ e(m.Item, { label: "Status", children: w() }),
      /* @__PURE__ */ e(m.Item, { label: "Email", children: /* @__PURE__ */ e("a", { href: `mailto:${o.email}`, children: o.email || "—" }) }),
      /* @__PURE__ */ e(m.Item, { label: "Role", children: o.role?.name || o.roleId || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Tenant", children: o.tenant?.name || o.tenantId || "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Invited By", children: o.invitedBy ? /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ r("span", { children: [
          o.invitedBy.firstName,
          " ",
          o.invitedBy.lastName
        ] }),
        /* @__PURE__ */ e(T, { children: o.invitedBy.email })
      ] }) : "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Created At", children: o.createdAt ? new Date(o.createdAt).toLocaleString() : "—" }),
      /* @__PURE__ */ e(m.Item, { label: "Expires At", children: o.expiresAt ? /* @__PURE__ */ r(k, { children: [
        new Date(o.expiresAt).toLocaleString(),
        h && /* @__PURE__ */ e(T, { color: "warning", children: "Expired" })
      ] }) : "—" }),
      o.acceptedAt && /* @__PURE__ */ e(m.Item, { label: "Accepted At", children: new Date(o.acceptedAt).toLocaleString() }),
      o.declinedAt && /* @__PURE__ */ e(m.Item, { label: "Declined At", children: new Date(o.declinedAt).toLocaleString() }),
      o.cancelledAt && /* @__PURE__ */ e(m.Item, { label: "Cancelled At", children: new Date(o.cancelledAt).toLocaleString() })
    ] }),
    p && u.allowed && /* @__PURE__ */ r(ie, { children: [
      /* @__PURE__ */ e(ne, {}),
      /* @__PURE__ */ e("h3", { children: "Invitation Actions" }),
      /* @__PURE__ */ e("p", { style: { color: "#666", marginBottom: 16 }, children: "Cancel this invitation to prevent the recipient from accepting it." }),
      /* @__PURE__ */ e(
        $,
        {
          title: "Cancel invitation",
          description: "Are you sure you want to cancel this invitation? The recipient will no longer be able to accept it.",
          onConfirm: g,
          okText: "Cancel Invitation",
          okButtonProps: { danger: !0 },
          cancelText: "Keep",
          children: /* @__PURE__ */ e(y, { danger: !0, loading: d.isPending, children: "Cancel Invitation" })
        }
      )
    ] })
  ] });
}
const { Title: Cr, Text: Ue } = O, Tr = {
  USER_DELETED: {
    label: "Account Deleted",
    color: "orange",
    icon: /* @__PURE__ */ e(_e, {}),
    description: "User initiated account deletion (grace period started)"
  },
  USER_RESTORED: {
    label: "Account Restored",
    color: "green",
    icon: /* @__PURE__ */ e(jn, {}),
    description: "User restored their account within the grace period"
  },
  USER_PERMANENTLY_DELETED: {
    label: "Permanently Deleted",
    color: "red",
    icon: /* @__PURE__ */ e(De, {}),
    description: "Account permanently deleted after retention period (PII erased)"
  }
};
function Qa({ tenantId: t = "default" }) {
  const [n, a] = P(void 0), { data: i, isLoading: l, error: s } = Un([
    t,
    void 0,
    n
  ]), c = oe(() => i?.data ? Array.isArray(i.data) ? i.data : [] : [], [i]);
  return /* @__PURE__ */ e("div", { style: { padding: 24 }, children: /* @__PURE__ */ r(k, { orientation: "vertical", size: "large", style: { width: "100%" }, children: [
    /* @__PURE__ */ r("div", { children: [
      /* @__PURE__ */ r(Cr, { level: 3, children: [
        /* @__PURE__ */ e(_e, { style: { marginRight: 8 } }),
        "Account Deletion Audit Log"
      ] }),
      /* @__PURE__ */ e(Ue, { type: "secondary", children: "View account lifecycle events for GDPR compliance and accountability." })
    ] }),
    /* @__PURE__ */ e(
      C,
      {
        type: "info",
        icon: /* @__PURE__ */ e(Vn, {}),
        message: "GDPR Article 17 Compliance",
        description: "This log tracks all account deletion requests, restorations, and permanent deletions. Permanent deletions indicate that all personal data has been erased in compliance with the Right to Erasure.",
        showIcon: !0
      }
    ),
    /* @__PURE__ */ r(K, { children: [
      /* @__PURE__ */ r(k, { style: { marginBottom: 16 }, children: [
        /* @__PURE__ */ e(Ue, { strong: !0, children: "Filter by Action:" }),
        /* @__PURE__ */ e(
          V,
          {
            style: { width: 200 },
            placeholder: "All Actions",
            allowClear: !0,
            value: n,
            onChange: a,
            options: [
              { value: "USER_DELETED", label: "Account Deleted" },
              { value: "USER_RESTORED", label: "Account Restored" },
              { value: "USER_PERMANENTLY_DELETED", label: "Permanently Deleted" }
            ]
          }
        )
      ] }),
      s ? /* @__PURE__ */ e(
        C,
        {
          type: "error",
          message: "Failed to load audit logs",
          description: "Please try again later or contact support."
        }
      ) : /* @__PURE__ */ e(
        ge,
        {
          dataSource: c,
          columns: [
            {
              title: "Timestamp",
              dataIndex: "createdAt",
              key: "createdAt",
              width: 180,
              render: (u) => new Date(u).toLocaleString(void 0, {
                dateStyle: "medium",
                timeStyle: "short"
              }),
              sorter: (u, g) => new Date(u.createdAt).getTime() - new Date(g.createdAt).getTime(),
              defaultSortOrder: "descend"
            },
            {
              title: "Action",
              dataIndex: "action",
              key: "action",
              width: 200,
              render: (u) => {
                const g = Tr[u];
                return g ? /* @__PURE__ */ e(ce, { title: g.description, children: /* @__PURE__ */ e(T, { icon: g.icon, color: g.color, children: g.label }) }) : /* @__PURE__ */ e(T, { children: u });
              }
            },
            {
              title: "User",
              key: "user",
              width: 250,
              render: (u, g) => /* @__PURE__ */ r(k, { orientation: "vertical", size: 0, children: [
                /* @__PURE__ */ e(Ue, { children: g.userEmail || "Unknown" }),
                /* @__PURE__ */ e(Ue, { type: "secondary", style: { fontSize: 12 }, children: g.userId })
              ] })
            },
            {
              title: "Performed By",
              dataIndex: "performedBy",
              key: "performedBy",
              width: 180,
              render: (u) => /* @__PURE__ */ e(T, { color: u === "self" || u === "user" ? "blue" : "default", children: u === "self" || u === "user" ? "Self-Service" : u })
            },
            {
              title: "IP Address",
              dataIndex: "ipAddress",
              key: "ipAddress",
              width: 140,
              render: (u) => u || "-"
            },
            {
              title: "Status",
              dataIndex: "status",
              key: "status",
              width: 100,
              render: (u) => u ? /* @__PURE__ */ e(T, { color: u === "success" ? "green" : "default", children: u }) : "-"
            }
          ],
          rowKey: "id",
          loading: l,
          pagination: {
            pageSize: 20,
            showSizeChanger: !0,
            showTotal: (u) => `${u} events`
          },
          scroll: { x: 1100 }
        }
      )
    ] })
  ] }) });
}
const Er = [
  "facilities.leasing.admin",
  "facilities.leasing.viewer",
  "facilities.leasing.workflow.operator",
  "facilities.leasing.applicant-access.manager",
  "facilities.leasing.document-reviewer",
  "facilities.leasing.design-reviewer",
  "facilities.leasing.catalog-manager",
  "facilities.leasing.commercial-approver",
  "facilities.leasing.finance-deposit.operator",
  "facilities.leasing.contract-permit.operator"
], Be = {
  "voicepro-customer": {
    id: "voicepro-customer",
    name: "VoicePro Customer",
    description: "Isolated VoicePro tenant with own data visibility. Ideal for end customers.",
    icon: "UserOutlined",
    services: {
      voiceProEnabled: !0,
      crmEnabled: !1,
      messagingEnabled: !1,
      billingEnabled: !1
    },
    steps: ["template-select", "org-details", "voicepro-config", "initial-users", "review"],
    defaultRoles: ["TENANT_OWNER", "TENANT_ADMIN", "VOICEPRO_EDITOR", "VOICEPRO_VIEWER"],
    visibilityScope: "isolated"
  },
  "voicepro-operator": {
    id: "voicepro-operator",
    name: "VoicePro Operator / MSP",
    description: "Cross-tenant VoicePro visibility for operators managing multiple customers.",
    icon: "GlobalOutlined",
    services: {
      voiceProEnabled: !0,
      crmEnabled: !1,
      messagingEnabled: !1,
      billingEnabled: !1
    },
    steps: ["template-select", "org-details", "voicepro-config", "initial-users", "review"],
    defaultRoles: ["TENANT_OWNER", "TENANT_ADMIN", "VOICEPRO_EDITOR", "VOICEPRO_VIEWER"],
    visibilityScope: "cross-tenant"
  },
  corporate: {
    id: "corporate",
    name: "Corporate / Enterprise",
    description: "CRM and messaging enabled tenant without VoicePro. Ideal for enterprise customers.",
    icon: "BankOutlined",
    services: {
      voiceProEnabled: !1,
      crmEnabled: !0,
      messagingEnabled: !0,
      billingEnabled: !0
    },
    steps: ["template-select", "org-details", "crm-config", "initial-users", "review"],
    defaultRoles: ["TENANT_OWNER", "TENANT_ADMIN", "CRM_ADMIN", "CRM_VIEWER"],
    visibilityScope: "isolated"
  },
  "facilities-leasing": {
    id: "facilities-leasing",
    name: "Facilities Leasing",
    description: "Messaging, billing, and leasing-only Facilities admin access for facilities tenants.",
    icon: "BankOutlined",
    services: {
      voiceProEnabled: !1,
      crmEnabled: !1,
      messagingEnabled: !0,
      billingEnabled: !0
    },
    steps: ["template-select", "org-details", "initial-users", "review"],
    defaultRoles: [...Er],
    visibilityScope: "isolated"
  }
};
function xe(t) {
  return Be[t];
}
const Sr = {
  "template-select": "Template",
  "org-details": "Organization",
  "voicepro-config": "VoicePro Setup",
  "crm-config": "CRM & Messaging",
  "initial-users": "Initial Users",
  review: "Review"
}, kr = {
  TENANT_OWNER: { label: "Tenant Owner", value: "TENANT_OWNER" },
  TENANT_ADMIN: { label: "Tenant Admin", value: "TENANT_ADMIN" },
  VOICEPRO_EDITOR: { label: "VoicePro Editor", value: "VOICEPRO_EDITOR" },
  VOICEPRO_VIEWER: { label: "VoicePro Viewer", value: "VOICEPRO_VIEWER" },
  CRM_ADMIN: { label: "CRM Admin", value: "CRM_ADMIN" },
  CRM_VIEWER: { label: "CRM Viewer", value: "CRM_VIEWER" },
  "facilities.leasing.admin": {
    label: "Facilities Leasing Admin",
    value: "facilities.leasing.admin"
  },
  "facilities.leasing.viewer": {
    label: "Facilities Leasing Viewer",
    value: "facilities.leasing.viewer"
  },
  "facilities.leasing.workflow.operator": {
    label: "Leasing Workflow Operator",
    value: "facilities.leasing.workflow.operator"
  },
  "facilities.leasing.applicant-access.manager": {
    label: "Applicant Access Manager",
    value: "facilities.leasing.applicant-access.manager"
  },
  "facilities.leasing.document-reviewer": {
    label: "Document Reviewer",
    value: "facilities.leasing.document-reviewer"
  },
  "facilities.leasing.design-reviewer": {
    label: "Design Reviewer",
    value: "facilities.leasing.design-reviewer"
  },
  "facilities.leasing.catalog-manager": {
    label: "Catalog Manager",
    value: "facilities.leasing.catalog-manager"
  },
  "facilities.leasing.commercial-approver": {
    label: "Commercial Approver",
    value: "facilities.leasing.commercial-approver"
  },
  "facilities.leasing.finance-deposit.operator": {
    label: "Finance and Deposit Operator",
    value: "facilities.leasing.finance-deposit.operator"
  },
  "facilities.leasing.contract-permit.operator": {
    label: "Contract and Permit Operator",
    value: "facilities.leasing.contract-permit.operator"
  }
};
function Pr(t) {
  return xe(t).defaultRoles.map((a) => kr[a]);
}
function Wa(t, n) {
  return xe(t).steps.includes(n);
}
const Dr = "Africa/Johannesburg", jt = [
  {
    label: "Africa",
    zones: [
      "Africa/Johannesburg",
      "Africa/Nairobi",
      "Africa/Cairo",
      "Africa/Lagos",
      "Africa/Casablanca"
    ]
  },
  {
    label: "America",
    zones: [
      "America/New_York",
      "America/Chicago",
      "America/Denver",
      "America/Los_Angeles",
      "America/Toronto",
      "America/Vancouver",
      "America/Mexico_City",
      "America/Sao_Paulo",
      "America/Buenos_Aires"
    ]
  },
  {
    label: "Asia",
    zones: [
      "Asia/Dubai",
      "Asia/Kolkata",
      "Asia/Singapore",
      "Asia/Hong_Kong",
      "Asia/Tokyo",
      "Asia/Seoul",
      "Asia/Bangkok",
      "Asia/Jakarta"
    ]
  },
  {
    label: "Europe",
    zones: [
      "Europe/London",
      "Europe/Amsterdam",
      "Europe/Paris",
      "Europe/Berlin",
      "Europe/Madrid",
      "Europe/Rome",
      "Europe/Zurich",
      "Europe/Stockholm"
    ]
  },
  {
    label: "Oceania",
    zones: ["Australia/Sydney", "Australia/Perth", "Australia/Melbourne", "Pacific/Auckland"]
  },
  {
    label: "UTC",
    zones: ["UTC"]
  }
], Rr = jt.map((t) => ({
  label: t.label,
  options: t.zones.map((n) => ({ label: n, value: n }))
})), Mr = (t) => !!(t && jt.some((n) => n.zones.includes(t))), xr = {
  "voicepro-customer": /* @__PURE__ */ e(Qn, { style: { fontSize: 32 } }),
  "voicepro-operator": /* @__PURE__ */ e(qn, { style: { fontSize: 32 } }),
  corporate: /* @__PURE__ */ e(it, { style: { fontSize: 32 } }),
  "facilities-leasing": /* @__PURE__ */ e(it, { style: { fontSize: 32 } })
};
function ct(t) {
  const n = xe(t).defaultRoles;
  return n.find((a) => a === "TENANT_ADMIN" || a.endsWith(".admin")) ?? n[0] ?? "TENANT_ADMIN";
}
const Nr = [
  { id: "create-tenant", label: "Creating tenant record", status: "pending" },
  { id: "setup-registry", label: "Setting up registry mappings", status: "pending" },
  { id: "create-users", label: "Creating users", status: "pending" },
  { id: "finalize", label: "Finalizing configuration", status: "pending" }
], Lr = (t) => {
  switch (t) {
    case "in-progress":
      return "process";
    case "completed":
      return "finish";
    case "failed":
      return "error";
    default:
      return "wait";
  }
};
function Ka() {
  const { message: t } = G.useApp(), { token: n } = Ne.useToken(), a = Z(), [i] = b.useForm(), [l, s] = P(0), [c, d] = P(!1), [u, g] = P(null), [o, h] = P(null), [p, w] = P(null), [S, f] = P(
    null
  ), [I, R] = P("idle"), M = qe(null), [E, B] = P([]), [F, v] = P(!1), [le, be] = P(null), he = qe(!1), j = b.useWatch("templateId", i), ue = oe(() => j ? xe(j).steps.map((D) => ({
    title: Sr[D],
    stepId: D
  })) : [{ title: "Template", stepId: "template-select" }], [j]), q = ue[l]?.stepId ?? "template-select", Ae = (A) => ({
    "template-select": ["templateId"],
    "org-details": [
      "organizationName",
      "description",
      "contactEmail",
      "country",
      "timezone",
      "currency"
    ],
    "voicepro-config": ["voiceProTenantId", "voiceProTenantIds", "portaCredentialsTenantId"],
    "crm-config": ["crmTenantId", "messagingProvider"],
    "initial-users": ["users"],
    review: []
  })[A] ?? [], Ie = oe(() => j ? Pr(j) : [], [j]), ve = X(async (A) => {
    const D = A.trim().toLowerCase();
    if (!D || !/^[a-z0-9-]+$/i.test(D)) {
      R("idle");
      return;
    }
    R("checking");
    try {
      const W = (await Ce.get("/api/tenants/check-slug", {
        params: { slug: D }
      })).data.available ? "available" : "taken";
      R(W);
    } catch {
      R("error");
    }
  }, []), U = X(
    (A) => {
      M.current && clearTimeout(M.current), M.current = setTimeout(() => {
        ve(A);
      }, 400);
    },
    [ve]
  );
  re(() => () => {
    M.current && clearTimeout(M.current);
  }, []);
  const ae = (A) => {
    const D = {
      display: "inline-flex",
      width: 16,
      justifyContent: "center"
    };
    switch (A) {
      case "checking":
        return /* @__PURE__ */ e("span", { style: D, children: /* @__PURE__ */ e(Wn, { style: { color: "#1890ff" } }) });
      case "available":
        return /* @__PURE__ */ e("span", { style: D, children: /* @__PURE__ */ e(Ye, { style: { color: "#52c41a" } }) });
      case "taken":
        return /* @__PURE__ */ e("span", { style: D, children: /* @__PURE__ */ e(De, { style: { color: "#ff4d4f" } }) });
      case "error":
        return /* @__PURE__ */ e("span", { style: D, children: /* @__PURE__ */ e(De, { style: { color: "#faad14" } }) });
      default:
        return /* @__PURE__ */ e("span", { "aria-hidden": "true", style: D });
    }
  }, Ee = oe(() => I === "taken", [I]), ye = oe(() => new Set(E), [E]), Se = b.useWatch("voiceProTenantIds", i), Q = oe(() => (Se ?? []).map((D) => String(D).trim().toLowerCase()).filter(Boolean).filter((D) => !ye.has(D)), [ye, Se]);
  re(() => {
    j === "voicepro-operator" && (he.current || (he.current = !0, v(!0), be(null), (async () => {
      try {
        const D = ((await Ce.get(
          "/api/tenants/voicepro/tenant-slugs"
        )).data?.items ?? []).map((Y) => String(Y).trim().toLowerCase()).filter(Boolean);
        B(Array.from(new Set(D)).sort((Y, W) => Y.localeCompare(W)));
      } catch (A) {
        he.current = !1;
        const D = Ce.isAxiosError(A) && A.response ? A.response.data?.message || `Request failed (${A.response.status})` : A instanceof Error ? A.message : "Unable to load tenant slug suggestions.";
        be(D);
      } finally {
        v(!1);
      }
    })()));
  }, [j]);
  const z = async () => {
    const A = Ae(q);
    try {
      await i.validateFields(A), s((D) => Math.min(D + 1, ue.length - 1));
    } catch {
      t.error("Please fix the validation errors before continuing.");
    }
  }, _ = () => s((A) => Math.max(A - 1, 0)), me = (A) => {
    i.setFieldValue("templateId", A);
    const D = ct(A);
    i.setFieldValue("users", [{ role: D }]), s(1);
  }, Ge = async () => {
    try {
      g(null);
      const A = await i.validateFields();
      if (!A.templateId) {
        g("Please select a template.");
        return;
      }
      const D = A.users ?? i.getFieldValue("users") ?? [];
      if (D.length === 0) {
        g("Add at least one user.");
        return;
      }
      const Y = {
        templateId: A.templateId,
        organizationName: A.organizationName,
        description: A.description,
        contactEmail: A.contactEmail,
        country: A.country,
        timezone: A.timezone,
        currency: A.currency,
        users: D.map((L) => {
          const te = {
            email: L.email,
            role: L.role,
            inviteOnly: !!L.inviteOnly
          };
          return L.inviteOnly || (te.password = L.password), te;
        })
      };
      if (A.templateId === "voicepro-customer" || A.templateId === "voicepro-operator") {
        const L = A.voiceProTenantId?.trim().toLowerCase() ?? "";
        if (Y.voiceProTenantId = L, A.templateId === "voicepro-operator") {
          const te = (A.voiceProTenantIds ?? []).map((ke) => ke.trim().toLowerCase()).filter(Boolean).filter((ke) => ke !== L), we = Array.from(/* @__PURE__ */ new Set([L, ...te]));
          Y.voiceProTenantIds = we;
        }
        A.templateId === "voicepro-customer" && A.portaCredentialsTenantId && (Y.portaCredentialsTenantId = A.portaCredentialsTenantId.trim().toLowerCase());
      }
      A.templateId === "corporate" && (A.crmTenantId && (Y.crmTenantId = A.crmTenantId), A.messagingProvider && (Y.messagingProvider = A.messagingProvider)), d(!0);
      const W = await Ce.post("/api/tenants/provision", Y);
      w(W.data), f(null), t.info("Provisioning started. Tracking progress...");
    } catch (A) {
      const D = Ce.isAxiosError(A) && A.response ? A.response.data?.message || `Request failed (${A.response.status})` : A instanceof Error ? A.message : "Provisioning failed.";
      g(D);
    } finally {
      d(!1);
    }
  };
  re(() => {
    if (!p?.jobId)
      return;
    let A = !1, D;
    const Y = async () => {
      try {
        const W = p.statusUrl ?? `/api/tenants/provision/jobs/${p.jobId}`, L = await Ce.get(W);
        if (A) return;
        if (f(L.data), L.data.status === "completed") {
          L.data.result ? (h(L.data.result), t.success(`Provisioned ${L.data.result.tenantName}`)) : g("Provisioning completed but no result was returned."), w(null), f(null);
          return;
        }
        if (L.data.status === "failed") {
          g(L.data.error?.message ?? "Provisioning failed.");
          return;
        }
        D = setTimeout(Y, 1500);
      } catch (W) {
        if (A) return;
        const L = Ce.isAxiosError(W) && W.response ? W.response.data?.message || `Request failed (${W.response.status})` : W instanceof Error ? W.message : "Unable to fetch provisioning status.";
        g(L);
      }
    };
    return Y(), () => {
      A = !0, D && clearTimeout(D);
    };
  }, [p?.jobId, p?.statusUrl, t]);
  const qt = () => {
    i.resetFields(), h(null), w(null), f(null), g(null), s(0);
  }, Qt = () => {
    w(null), f(null), g(null);
  };
  if (o) {
    const A = o.templateId ? Be[o.templateId].name : "Tenant";
    return /* @__PURE__ */ r("div", { style: { padding: 24 }, children: [
      /* @__PURE__ */ e(
        Yt,
        {
          status: "success",
          title: `${A} provisioned`,
          subTitle: `Tenant ${o.tenantName}${o.voiceProTenantId ? ` (${o.voiceProTenantId})` : ""} is ready.`,
          extra: [
            /* @__PURE__ */ e(y, { type: "primary", onClick: () => a("/tenants"), children: "View Tenants" }, "tenants"),
            /* @__PURE__ */ e(y, { onClick: qt, children: "Onboard Another Tenant" }, "again")
          ]
        }
      ),
      /* @__PURE__ */ r(K, { style: { maxWidth: 720, margin: "0 auto" }, children: [
        /* @__PURE__ */ e(O.Title, { level: 5, style: { marginTop: 0 }, children: "Users Created" }),
        /* @__PURE__ */ e("ul", { children: o.users.map((D) => /* @__PURE__ */ r("li", { children: [
          D.email,
          " — ",
          D.role
        ] }, D.userId)) })
      ] })
    ] });
  }
  if (p) {
    const A = S?.steps?.length ? S.steps : Nr, D = A.map((te) => ({
      title: te.label,
      status: Lr(te.status),
      content: te.message
    })), Y = Math.max(
      A.findIndex((te) => te.status === "in-progress"),
      0
    ), W = S?.error?.message ?? u, L = S?.status === "failed" || !!W;
    return /* @__PURE__ */ e("div", { style: { padding: 24, maxWidth: 720, margin: "0 auto" }, children: /* @__PURE__ */ e(K, { title: "Provisioning tenant", children: /* @__PURE__ */ r(k, { orientation: "vertical", size: "large", style: { width: "100%" }, children: [
      /* @__PURE__ */ r(O.Text, { type: "secondary", children: [
        "Job ID: ",
        p.jobId
      ] }),
      /* @__PURE__ */ e(rt, { current: Y, items: D }),
      L ? /* @__PURE__ */ e(C, { type: "error", message: W ?? "Provisioning failed.", showIcon: !0 }) : /* @__PURE__ */ e(
        C,
        {
          type: "info",
          message: "Provisioning in progress. This can take a few moments.",
          showIcon: !0
        }
      ),
      L && /* @__PURE__ */ e(k, { children: /* @__PURE__ */ e(y, { type: "primary", onClick: Qt, children: "Back to Review" }) })
    ] }) }) });
  }
  return /* @__PURE__ */ e("div", { style: { maxWidth: 860, margin: "0 auto", padding: 24 }, children: /* @__PURE__ */ r(k, { orientation: "vertical", size: "large", style: { width: "100%" }, children: [
    /* @__PURE__ */ r("div", { children: [
      /* @__PURE__ */ e(O.Title, { level: 3, style: { marginBottom: 4 }, children: "Tenant Onboarding Wizard" }),
      /* @__PURE__ */ e(O.Text, { type: "secondary", children: "Create a tenant with registry mapping and initial users in one flow." })
    ] }),
    /* @__PURE__ */ e(rt, { current: l, items: ue.map((A) => ({ title: A.title })) }),
    u && /* @__PURE__ */ e(C, { type: "error", message: u, showIcon: !0 }),
    /* @__PURE__ */ r(
      b,
      {
        form: i,
        layout: "vertical",
        initialValues: {
          country: "ZA",
          timezone: Dr,
          currency: "ZAR",
          users: [{ role: "TENANT_ADMIN" }]
        },
        children: [
          /* @__PURE__ */ e(b.Item, { name: "templateId", hidden: !0, children: /* @__PURE__ */ e(x, {}) }),
          q === "template-select" && /* @__PURE__ */ e(K, { title: "Select Tenant Template", children: /* @__PURE__ */ e("div", { style: { display: "flex", gap: 16, flexWrap: "wrap" }, children: Object.keys(Be).map((A) => {
            const D = Be[A];
            return /* @__PURE__ */ r(
              K,
              {
                hoverable: !0,
                style: {
                  width: 260,
                  textAlign: "center",
                  border: j === A ? "2px solid #1890ff" : "1px solid #d9d9d9"
                },
                onClick: () => me(A),
                children: [
                  xr[A],
                  /* @__PURE__ */ e(O.Title, { level: 5, style: { marginTop: 12, marginBottom: 4 }, children: D.name }),
                  /* @__PURE__ */ e(O.Text, { type: "secondary", style: { fontSize: 12 }, children: D.description }),
                  /* @__PURE__ */ e("div", { style: { marginTop: 8 }, children: /* @__PURE__ */ e(
                    O.Text,
                    {
                      type: D.visibilityScope === "cross-tenant" ? "warning" : "success",
                      style: { fontSize: 11 },
                      children: D.visibilityScope === "cross-tenant" ? "Cross-tenant visibility" : "Isolated visibility"
                    }
                  ) })
                ]
              },
              A
            );
          }) }) }),
          q === "org-details" && /* @__PURE__ */ r(K, { title: "Organization Details", children: [
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "Organization Name",
                name: "organizationName",
                rules: [{ required: !0, message: "Organization name is required." }],
                children: /* @__PURE__ */ e(x, { placeholder: "e.g. Yolo Communications" })
              }
            ),
            /* @__PURE__ */ e(b.Item, { label: "Description", name: "description", children: /* @__PURE__ */ e(x.TextArea, { rows: 3, placeholder: "Optional description..." }) }),
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "Contact Email",
                name: "contactEmail",
                rules: [{ required: !0, type: "email" }],
                children: /* @__PURE__ */ e(x, { placeholder: "support@yolo.co.za" })
              }
            ),
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "Country",
                name: "country",
                rules: [{ required: !0, message: "Country is required." }],
                children: /* @__PURE__ */ e(x, { placeholder: "ZA" })
              }
            ),
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "Timezone",
                name: "timezone",
                rules: [
                  { required: !0, message: "Timezone is required." },
                  {
                    validator: (A, D) => D ? Mr(D) ? Promise.resolve() : Promise.reject(new Error("Select a valid IANA timezone.")) : Promise.resolve()
                  }
                ],
                children: /* @__PURE__ */ e(
                  V,
                  {
                    showSearch: !0,
                    placeholder: "Select timezone",
                    options: Rr,
                    filterOption: (A, D) => (D?.label ?? "").toString().toLowerCase().includes(A.toLowerCase())
                  }
                )
              }
            ),
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "Currency",
                name: "currency",
                rules: [
                  { required: !0, message: "Currency is required." },
                  { len: 3, message: "Use a 3-letter currency code." }
                ],
                children: /* @__PURE__ */ e(x, { placeholder: "ZAR" })
              }
            )
          ] }),
          q === "voicepro-config" && /* @__PURE__ */ r(K, { title: "VoicePro Configuration", children: [
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "VoicePro Tenant Slug",
                name: "voiceProTenantId",
                rules: [
                  { required: !0, message: "Tenant slug is required." },
                  {
                    pattern: /^[a-z0-9-]+$/i,
                    message: "Use only letters, numbers, and hyphens."
                  },
                  {
                    validator: () => I === "taken" ? Promise.reject(new Error("This slug is already in use.")) : Promise.resolve()
                  }
                ],
                validateStatus: I === "taken" ? "error" : I === "available" ? "success" : void 0,
                help: I === "taken" ? "This slug is already in use." : I === "available" ? "Slug is available." : I === "checking" ? "Checking availability..." : void 0,
                children: /* @__PURE__ */ e(
                  x,
                  {
                    placeholder: "yolo",
                    onChange: (A) => U(A.target.value),
                    suffix: ae(I)
                  }
                )
              }
            ),
            j === "voicepro-operator" && /* @__PURE__ */ e(
              b.Item,
              {
                label: "Managed VoicePro Tenant Slugs",
                name: "voiceProTenantIds",
                rules: [
                  {
                    required: !0,
                    message: "At least one managed tenant slug is required for operators."
                  }
                ],
                tooltip: "Enter all customer tenant slugs this operator will manage. Existing slugs are suggested from the registry; unknown entries are allowed but flagged.",
                validateStatus: Q.length > 0 ? "warning" : void 0,
                help: /* @__PURE__ */ r(ie, { children: [
                  le ? /* @__PURE__ */ e(
                    C,
                    {
                      type: "warning",
                      showIcon: !0,
                      message: "Unable to load slug suggestions",
                      description: le
                    }
                  ) : null,
                  Q.length > 0 ? /* @__PURE__ */ r(O.Text, { type: "warning", children: [
                    "Unknown slugs (not found in registry): ",
                    Q.join(", ")
                  ] }) : null
                ] }),
                children: /* @__PURE__ */ e(
                  V,
                  {
                    mode: "tags",
                    placeholder: "Add customer slugs (e.g., gcl, acme)",
                    loading: F,
                    options: E.map((A) => ({
                      value: A,
                      label: A
                    })),
                    tagRender: (A) => {
                      const { value: D, closable: Y, onClose: W } = A, L = String(D).trim().toLowerCase(), te = ye.has(L);
                      return /* @__PURE__ */ r(
                        "span",
                        {
                          style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            marginInlineEnd: 8
                          },
                          children: [
                            /* @__PURE__ */ e(
                              "span",
                              {
                                style: {
                                  padding: "2px 8px",
                                  borderRadius: 999,
                                  border: `1px solid ${te ? "#52c41a" : "#faad14"}`,
                                  color: te ? "#389e0d" : "#d46b08",
                                  background: te ? "rgba(82, 196, 26, 0.08)" : "rgba(250, 173, 20, 0.08)",
                                  fontSize: 12
                                },
                                children: L || D
                              }
                            ),
                            Y ? /* @__PURE__ */ e(
                              y,
                              {
                                size: "small",
                                type: "text",
                                onClick: W,
                                style: { lineHeight: 1, height: 18, padding: 0 },
                                children: "×"
                              }
                            ) : null
                          ]
                        }
                      );
                    }
                  }
                )
              }
            ),
            j === "voicepro-customer" && /* @__PURE__ */ e(
              b.Item,
              {
                label: "Inherit Porta Credentials From (optional)",
                name: "portaCredentialsTenantId",
                tooltip: "If this customer uses an operator's Porta credentials, enter the operator's tenant slug.",
                children: /* @__PURE__ */ e(x, { placeholder: "yolo (operator slug)" })
              }
            ),
            /* @__PURE__ */ e(O.Text, { type: "secondary", children: j === "voicepro-operator" ? "Operator tenants have cross-tenant visibility. Enter all customer slugs this operator will manage." : "Customer tenants have isolated visibility and can only see their own data." })
          ] }),
          q === "crm-config" && /* @__PURE__ */ r(K, { title: "CRM & Messaging Configuration", children: [
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "CRM Tenant ID",
                name: "crmTenantId",
                tooltip: "Optional custom CRM tenant identifier. Defaults to the Access Control tenant ID.",
                children: /* @__PURE__ */ e(x, { placeholder: "Leave blank to auto-generate" })
              }
            ),
            /* @__PURE__ */ e(
              b.Item,
              {
                label: "Messaging Provider",
                name: "messagingProvider",
                tooltip: "Select the messaging provider for this tenant.",
                children: /* @__PURE__ */ r(V, { placeholder: "Select provider", children: [
                  /* @__PURE__ */ e(V.Option, { value: "sendgrid", children: "SendGrid" }),
                  /* @__PURE__ */ e(V.Option, { value: "twilio", children: "Twilio" }),
                  /* @__PURE__ */ e(V.Option, { value: "internal", children: "Internal" })
                ] })
              }
            ),
            /* @__PURE__ */ e(O.Text, { type: "secondary", children: "Corporate tenants have CRM and messaging enabled without VoicePro features." })
          ] }),
          q === "initial-users" && /* @__PURE__ */ e(K, { title: "Initial Users", children: /* @__PURE__ */ e(
            b.List,
            {
              name: "users",
              rules: [
                {
                  validator: async (A, D) => !D || D.length < 1 ? Promise.reject(new Error("Add at least one user.")) : Promise.resolve()
                }
              ],
              children: (A, { add: D, remove: Y }, { errors: W }) => /* @__PURE__ */ r(ie, { children: [
                A.map((L, te) => /* @__PURE__ */ r(
                  K,
                  {
                    size: "small",
                    title: `User ${te + 1}`,
                    style: { marginBottom: 12 },
                    extra: A.length > 1 ? /* @__PURE__ */ e(y, { type: "link", danger: !0, onClick: () => Y(L.name), children: "Remove" }) : null,
                    children: [
                      /* @__PURE__ */ e(
                        b.Item,
                        {
                          label: "Email",
                          name: [L.name, "email"],
                          rules: [{ required: !0, type: "email" }],
                          children: /* @__PURE__ */ e(x, { placeholder: "admin@example.com" })
                        }
                      ),
                      /* @__PURE__ */ e(
                        b.Item,
                        {
                          name: [L.name, "inviteOnly"],
                          valuePropName: "checked",
                          style: { marginBottom: 8 },
                          children: /* @__PURE__ */ e(
                            Ht,
                            {
                              onChange: (we) => {
                                we.target.checked && i.setFieldValue(["users", L.name, "password"], void 0);
                              },
                              children: "Send invite email (user sets password)"
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ e(
                        b.Item,
                        {
                          noStyle: !0,
                          shouldUpdate: (we, ke) => we.users?.[L.name]?.inviteOnly !== ke.users?.[L.name]?.inviteOnly,
                          children: ({ getFieldValue: we }) => we([
                            "users",
                            L.name,
                            "inviteOnly"
                          ]) ? /* @__PURE__ */ e(
                            C,
                            {
                              type: "info",
                              message: "Invite email will be sent with a password reset link.",
                              showIcon: !0,
                              style: { marginBottom: 12 }
                            }
                          ) : /* @__PURE__ */ e(
                            b.Item,
                            {
                              label: "Password",
                              name: [L.name, "password"],
                              dependencies: [["users", L.name, "inviteOnly"]],
                              rules: [
                                ({ getFieldValue: Wt }) => ({
                                  validator: (_r, tt) => Wt([
                                    "users",
                                    L.name,
                                    "inviteOnly"
                                  ]) ? Promise.resolve() : tt ? String(tt).length < 8 ? Promise.reject(
                                    new Error("Use at least 8 characters.")
                                  ) : Promise.resolve() : Promise.reject(new Error("Password is required."))
                                })
                              ],
                              children: /* @__PURE__ */ e(x.Password, { placeholder: "Set an initial password" })
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ e(
                        b.Item,
                        {
                          label: "Role",
                          name: [L.name, "role"],
                          rules: [{ required: !0, message: "Role is required." }],
                          children: /* @__PURE__ */ e(V, { options: Ie })
                        }
                      )
                    ]
                  },
                  L.key
                )),
                /* @__PURE__ */ e(
                  y,
                  {
                    type: "dashed",
                    onClick: () => {
                      const L = j ? xe(j) : null, te = L ? ct(L.id) : "TENANT_ADMIN";
                      D({ role: te });
                    },
                    block: !0,
                    children: "Add User"
                  }
                ),
                /* @__PURE__ */ e(b.ErrorList, { errors: W })
              ] })
            }
          ) }),
          q === "review" && /* @__PURE__ */ r(K, { title: "Review & Provision", children: [
            /* @__PURE__ */ e(O.Paragraph, { children: "Confirm the details below before provisioning the tenant." }),
            /* @__PURE__ */ e(
              "pre",
              {
                style: {
                  background: n.colorBgContainer,
                  color: n.colorText,
                  padding: 12,
                  borderRadius: n.borderRadiusLG,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word"
                },
                children: JSON.stringify(
                  {
                    ...i.getFieldsValue(),
                    users: (i.getFieldsValue().users ?? []).map((A) => ({
                      ...A,
                      password: A.inviteOnly ? "Invite email" : "••••••••"
                    }))
                  },
                  null,
                  2
                )
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ r(k, { style: { display: "flex", justifyContent: "space-between" }, children: [
      /* @__PURE__ */ e(y, { disabled: l === 0, onClick: _, children: "Back" }),
      q === "template-select" ? /* @__PURE__ */ e(O.Text, { type: "secondary", children: "Select a template to continue" }) : l < ue.length - 1 ? /* @__PURE__ */ e(
        y,
        {
          type: "primary",
          onClick: z,
          disabled: q === "voicepro-config" && Ee,
          children: "Next"
        }
      ) : /* @__PURE__ */ e(y, { type: "primary", loading: c, onClick: Ge, children: "Provision Tenant" })
    ] })
  ] }) });
}
const ut = (t) => {
  if (!t) return "-";
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? "-" : n.toLocaleString();
};
function Fr(t) {
  return t instanceof Error && t.name === "NotAllowedError" ? "Passkey request was cancelled." : t instanceof Error && t.name === "NotSupportedError" ? "Passkeys are not supported on this device." : t instanceof Error && t.message ? t.message : "Unable to register passkey.";
}
function Ja({
  api: t,
  enabled: n,
  ensureRecentSecuritySession: a,
  startRegistration: i,
  supported: l
}) {
  const { message: s } = G.useApp(), [c, d] = P([]), [u, g] = P(!1), [o, h] = P(null), [p, w] = P(!1), [S, f] = P(!1), [I, R] = P(""), [M, E] = P(null), [B, F] = P(null), [v, le] = P(""), [be, he] = P(!1), [j, ue] = P(null), [q, Ae] = P(""), [Ie, ve] = P(!1), U = X(async () => {
    g(!0), h(null);
    try {
      const _ = await t.listPasskeys();
      d(_.items);
    } catch {
      h("Unable to load passkeys."), s.error("Unable to load passkeys.");
    } finally {
      g(!1);
    }
  }, [t, s]);
  re(() => {
    n && U();
  }, [n, U]);
  const ae = async () => {
    if (!(!l || !n) && !(a && !a())) {
      E(null), f(!0);
      try {
        const _ = await t.beginPasskeyRegistration(), me = _.optionsJSON ?? _.options;
        if (!me)
          throw new Error("Passkey registration options missing from server response.");
        const Ge = await i(me);
        await t.verifyPasskeyRegistration({
          challengeId: _.challengeId,
          response: Ge,
          ...I.trim() ? { deviceName: I.trim() } : {}
        }), s.success("Passkey added."), w(!1), R(""), await U();
      } catch (_) {
        E(Fr(_));
      } finally {
        f(!1);
      }
    }
  }, Ee = (_) => {
    F(_), le(_.deviceName ?? "");
  }, ye = async () => {
    if (B && !(a && !a())) {
      he(!0);
      try {
        await t.renamePasskey(B.id, { deviceName: v.trim() }), s.success("Passkey updated."), F(null), le(""), await U();
      } catch {
        s.error("Unable to update passkey.");
      } finally {
        he(!1);
      }
    }
  }, Se = (_) => {
    ue(_), Ae("");
  }, Q = async () => {
    if (j && !(a && !a())) {
      ve(!0);
      try {
        await t.revokePasskey(
          j.id,
          q.trim() ? { reason: q.trim() } : {}
        ), s.success("Passkey revoked."), ue(null), Ae(""), await U();
      } catch {
        s.error("Unable to revoke passkey.");
      } finally {
        ve(!1);
      }
    }
  }, z = oe(
    () => [
      {
        title: "Device",
        dataIndex: "deviceName",
        render: (_, me) => /* @__PURE__ */ r(k, { orientation: "vertical", size: 4, children: [
          /* @__PURE__ */ e("span", { children: _ || "Unnamed passkey" }),
          /* @__PURE__ */ r(k, { size: 6, children: [
            /* @__PURE__ */ e(T, { children: me.credentialDeviceType }),
            /* @__PURE__ */ e(T, { color: me.credentialBackedUp ? "blue" : "default", children: me.credentialBackedUp ? "Backed up" : "Device-only" })
          ] })
        ] })
      },
      {
        title: "Created",
        dataIndex: "createdAt",
        render: (_) => ut(_)
      },
      {
        title: "Last used",
        dataIndex: "lastUsedAt",
        render: (_) => _ ? ut(_) : "Never"
      },
      {
        title: "Status",
        dataIndex: "revokedAt",
        render: (_) => _ ? /* @__PURE__ */ e(T, { color: "red", children: "Revoked" }) : /* @__PURE__ */ e(T, { color: "green", children: "Active" })
      },
      {
        title: "Actions",
        key: "actions",
        render: (_, me) => /* @__PURE__ */ r(k, { children: [
          /* @__PURE__ */ e(
            y,
            {
              size: "small",
              icon: /* @__PURE__ */ e(Kn, {}),
              onClick: () => Ee(me),
              disabled: !!me.revokedAt,
              children: "Rename"
            }
          ),
          /* @__PURE__ */ e(
            y,
            {
              size: "small",
              danger: !0,
              icon: /* @__PURE__ */ e(_e, {}),
              onClick: () => Se(me),
              disabled: !!me.revokedAt,
              children: "Revoke"
            }
          )
        ] })
      }
    ],
    []
  );
  return /* @__PURE__ */ r(
    K,
    {
      title: /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(Yn, {}),
        /* @__PURE__ */ e("span", { children: "Passkeys" })
      ] }),
      extra: /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(
          y,
          {
            icon: /* @__PURE__ */ e(He, {}),
            onClick: () => U(),
            loading: u,
            disabled: !n,
            children: "Refresh"
          }
        ),
        /* @__PURE__ */ e(
          y,
          {
            type: "primary",
            icon: /* @__PURE__ */ e(Jn, {}),
            onClick: () => w(!0),
            disabled: !n || !l,
            children: "Add Passkey"
          }
        )
      ] }),
      children: [
        !n && /* @__PURE__ */ e(
          C,
          {
            type: "info",
            message: "Passkeys are currently disabled.",
            style: { marginBottom: 16 },
            showIcon: !0
          }
        ),
        !l && n && /* @__PURE__ */ e(O.Text, { type: "secondary", children: "Passkeys are not available on this device or browser." }),
        o && /* @__PURE__ */ e(
          C,
          {
            type: "error",
            message: "Passkeys could not be loaded",
            description: o,
            showIcon: !0,
            style: { marginTop: 16 }
          }
        ),
        /* @__PURE__ */ e(
          ge,
          {
            dataSource: c,
            columns: z,
            rowKey: "id",
            loading: u,
            locale: {
              emptyText: o ? "Passkeys could not be loaded." : "No passkeys registered yet."
            },
            pagination: !1,
            style: { marginTop: 16 }
          }
        ),
        /* @__PURE__ */ e(
          Te,
          {
            title: "Add Passkey",
            open: p,
            onCancel: () => w(!1),
            onOk: ae,
            confirmLoading: S,
            okButtonProps: { disabled: !l },
            children: /* @__PURE__ */ r(k, { orientation: "vertical", style: { width: "100%" }, children: [
              /* @__PURE__ */ e(O.Paragraph, { children: "Register a new passkey using your device biometrics or a security key." }),
              /* @__PURE__ */ e(
                x,
                {
                  "aria-label": "Device name (optional)",
                  value: I,
                  onChange: (_) => R(_.target.value),
                  placeholder: "Device name (optional)"
                }
              ),
              M && /* @__PURE__ */ e(O.Text, { type: "danger", children: M })
            ] })
          }
        ),
        /* @__PURE__ */ e(
          Te,
          {
            title: "Rename Passkey",
            open: !!B,
            onCancel: () => F(null),
            onOk: ye,
            confirmLoading: be,
            okButtonProps: { disabled: !v.trim() },
            children: /* @__PURE__ */ e(
              x,
              {
                "aria-label": "New device name",
                value: v,
                onChange: (_) => le(_.target.value),
                placeholder: "New device name"
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          Te,
          {
            title: "Revoke Passkey",
            open: !!j,
            onCancel: () => ue(null),
            onOk: Q,
            confirmLoading: Ie,
            okButtonProps: { danger: !0 },
            children: /* @__PURE__ */ r(k, { orientation: "vertical", style: { width: "100%" }, children: [
              /* @__PURE__ */ e(O.Text, { children: "This passkey will no longer be able to sign in." }),
              /* @__PURE__ */ e(
                x,
                {
                  "aria-label": "Revocation reason (optional)",
                  value: q,
                  onChange: (_) => Ae(_.target.value),
                  placeholder: "Reason (optional)"
                }
              )
            ] })
          }
        )
      ]
    }
  );
}
function Ur({
  canDelete: t,
  canUpdate: n,
  config: a,
  onDelete: i,
  onModeChange: l,
  onRefreshMetadata: s,
  onToggle: c,
  tenantId: d
}) {
  return /* @__PURE__ */ r(k, { style: { marginTop: 24 }, wrap: !0, children: [
    /* @__PURE__ */ e(
      y,
      {
        type: a.enabled ? "default" : "primary",
        icon: /* @__PURE__ */ e(Hn, {}),
        onClick: () => void c(!a.enabled),
        disabled: !n,
        children: a.enabled ? "Disable SAML" : "Enable SAML"
      }
    ),
    /* @__PURE__ */ r(
      V,
      {
        "aria-label": "SAML mode",
        value: a.mode,
        onChange: (u) => void l(u),
        disabled: !n,
        style: { width: 150 },
        children: [
          /* @__PURE__ */ e(V.Option, { value: "disabled", children: "Disabled" }),
          /* @__PURE__ */ e(V.Option, { value: "optional", children: "Optional" }),
          /* @__PURE__ */ e(V.Option, { value: "enforced", children: "Enforced" })
        ]
      }
    ),
    a.idpMetadata.source === "url" && /* @__PURE__ */ e(
      y,
      {
        icon: /* @__PURE__ */ e(He, {}),
        onClick: () => void s(),
        disabled: !n,
        children: "Refresh Metadata"
      }
    ),
    /* @__PURE__ */ e(
      y,
      {
        danger: !0,
        icon: /* @__PURE__ */ e(_e, {}),
        onClick: () => Te.confirm({
          title: "Delete SAML configuration?",
          content: `This removes all SAML settings for tenant ${d}. Users will no longer be able to use SSO.`,
          okText: "Delete",
          okButtonProps: { danger: !0 },
          onOk: i
        }),
        disabled: !t,
        children: "Delete Configuration"
      }
    )
  ] });
}
const Pe = {
  email: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
  firstName: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
  lastName: "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"
};
function Or({
  loading: t,
  onCancel: n,
  onCreate: a
}) {
  const [i] = b.useForm();
  return /* @__PURE__ */ e(
    K,
    {
      title: "Configure SAML SSO",
      extra: /* @__PURE__ */ e(y, { onClick: n, children: "Cancel" }),
      style: { margin: 24 },
      children: /* @__PURE__ */ r(
        b,
        {
          form: i,
          layout: "vertical",
          onFinish: (l) => void a(l),
          initialValues: {
            metadataSource: "url",
            mode: "optional",
            allowIdpInitiated: !0,
            requireSignedAssertions: !0,
            requireSignedResponse: !0,
            mappingEmail: Pe.email,
            mappingFirstName: Pe.firstName,
            mappingLastName: Pe.lastName
          },
          children: [
            /* @__PURE__ */ e(O.Title, { level: 5, children: "IdP Metadata" }),
            /* @__PURE__ */ e(b.Item, { name: "metadataSource", label: "Metadata Source", children: /* @__PURE__ */ r(Oe.Group, { children: [
              /* @__PURE__ */ e(Oe.Button, { value: "url", children: "URL (recommended)" }),
              /* @__PURE__ */ e(Oe.Button, { value: "xml", children: "Paste XML" })
            ] }) }),
            /* @__PURE__ */ e(
              b.Item,
              {
                noStyle: !0,
                shouldUpdate: (l, s) => l.metadataSource !== s.metadataSource,
                children: ({ getFieldValue: l }) => l("metadataSource") === "url" ? /* @__PURE__ */ e(
                  b.Item,
                  {
                    name: "metadataValue",
                    label: "Metadata URL",
                    rules: [
                      { required: !0, message: "Metadata URL is required" },
                      { type: "url", message: "Enter a valid metadata URL" }
                    ],
                    children: /* @__PURE__ */ e(x, { placeholder: "https://idp.example.com/metadata" })
                  }
                ) : /* @__PURE__ */ e(
                  b.Item,
                  {
                    name: "metadataValue",
                    label: "Metadata XML",
                    rules: [
                      { required: !0, message: "Metadata XML is required" },
                      {
                        validator: (s, c) => !c || /^\s*<(\?xml|(\w+:)?EntityDescriptor)[\s>]/.test(c) ? Promise.resolve() : Promise.reject(
                          new Error("Paste valid SAML metadata XML (EntityDescriptor document)")
                        )
                      }
                    ],
                    children: /* @__PURE__ */ e(x.TextArea, { rows: 6, placeholder: "Paste IdP metadata XML here..." })
                  }
                )
              }
            ),
            /* @__PURE__ */ e(ne, {}),
            /* @__PURE__ */ e(O.Title, { level: 5, children: "SSO Mode" }),
            /* @__PURE__ */ e(b.Item, { name: "mode", label: "SAML Mode", children: /* @__PURE__ */ r(V, { children: [
              /* @__PURE__ */ e(V.Option, { value: "disabled", children: "Disabled" }),
              /* @__PURE__ */ e(V.Option, { value: "optional", children: "Optional (users can choose)" }),
              /* @__PURE__ */ e(V.Option, { value: "enforced", children: "Enforced (SAML only)" })
            ] }) }),
            /* @__PURE__ */ e(ne, {}),
            /* @__PURE__ */ e(O.Title, { level: 5, children: "Security Policy" }),
            /* @__PURE__ */ e(b.Item, { name: "allowIdpInitiated", label: "Allow IdP-initiated SSO", valuePropName: "checked", children: /* @__PURE__ */ e(se, {}) }),
            /* @__PURE__ */ e(
              b.Item,
              {
                name: "requireSignedAssertions",
                label: "Require signed assertions",
                valuePropName: "checked",
                children: /* @__PURE__ */ e(se, {})
              }
            ),
            /* @__PURE__ */ e(
              b.Item,
              {
                name: "requireSignedResponse",
                label: "Require signed response",
                valuePropName: "checked",
                children: /* @__PURE__ */ e(se, {})
              }
            ),
            /* @__PURE__ */ e(ne, {}),
            /* @__PURE__ */ e(O.Title, { level: 5, children: "Attribute Mappings" }),
            /* @__PURE__ */ e(
              b.Item,
              {
                name: "mappingEmail",
                label: "Email attribute",
                rules: [{ required: !0, message: "Email attribute is required" }],
                children: /* @__PURE__ */ e(x, { placeholder: Pe.email })
              }
            ),
            /* @__PURE__ */ e(b.Item, { name: "mappingFirstName", label: "First name attribute", children: /* @__PURE__ */ e(x, { placeholder: Pe.firstName }) }),
            /* @__PURE__ */ e(b.Item, { name: "mappingLastName", label: "Last name attribute", children: /* @__PURE__ */ e(x, { placeholder: Pe.lastName }) }),
            /* @__PURE__ */ e(ne, {}),
            /* @__PURE__ */ e(b.Item, { children: /* @__PURE__ */ e(y, { type: "primary", htmlType: "submit", icon: /* @__PURE__ */ e(Xn, {}), loading: t, children: "Create SAML Configuration" }) })
          ]
        }
      )
    }
  );
}
const je = (t) => {
  if (!t) return "-";
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? "-" : n.toLocaleString();
};
function Br(t) {
  return t?.response?.status;
}
function Ya({
  api: t,
  canDelete: n,
  canRead: a,
  canUpdate: i,
  onBackToTenants: l,
  tenantId: s
}) {
  const { message: c } = G.useApp(), [d, u] = P(null), [g, o] = P(!1), [h, p] = P(null), [w, S] = P(!1), f = !!a.loading, I = X(async () => {
    o(!0), p(null);
    try {
      const v = await t.getTenantSamlConfig(s);
      u(v), S(!1);
    } catch (v) {
      Br(v) === 404 ? u(null) : p("Unable to load SAML configuration.");
    } finally {
      o(!1);
    }
  }, [t, s]);
  re(() => {
    f || !a.allowed || I();
  }, [a.allowed, I, f]);
  const R = async (v) => {
    if (!(!a.allowed || !i.allowed)) {
      o(!0);
      try {
        await t.createTenantSamlConfig({
          tenantId: s,
          enabled: !0,
          mode: v.mode,
          idpMetadata: {
            source: v.metadataSource,
            value: v.metadataValue
          },
          policy: {
            allowIdpInitiated: v.allowIdpInitiated,
            requireSignedAssertions: v.requireSignedAssertions,
            requireSignedResponse: v.requireSignedResponse,
            forceReauthOnAcrChange: !1
          },
          mappings: {
            email: v.mappingEmail,
            ...v.mappingFirstName ? { firstName: v.mappingFirstName } : {},
            ...v.mappingLastName ? { lastName: v.mappingLastName } : {}
          }
        }), c.success("SAML configuration created."), await I();
      } catch {
        c.error("Unable to create SAML configuration.");
      } finally {
        o(!1);
      }
    }
  }, M = async (v) => {
    if (!(!i.allowed || !d)) {
      o(!0);
      try {
        await t.updateTenantSamlConfig(s, { enabled: v }), c.success(`SAML ${v ? "enabled" : "disabled"} for tenant.`), await I();
      } catch {
        c.error("Unable to update SAML configuration.");
      } finally {
        o(!1);
      }
    }
  }, E = async (v) => {
    if (!(!i.allowed || !d)) {
      o(!0);
      try {
        await t.updateTenantSamlConfig(s, { mode: v }), c.success(`SAML mode set to ${v}.`), await I();
      } catch {
        c.error("Unable to update SAML mode.");
      } finally {
        o(!1);
      }
    }
  }, B = async () => {
    if (!(!i.allowed || !d)) {
      o(!0);
      try {
        const v = await t.refreshTenantSamlConfig(s);
        v.refreshed ? c.success(
          v.changed ? "Metadata refreshed (changes detected)." : "Metadata refreshed (no changes)."
        ) : c.warning("Metadata refresh failed."), await I();
      } catch {
        c.error("Unable to refresh metadata.");
      } finally {
        o(!1);
      }
    }
  }, F = async () => {
    if (n.allowed) {
      o(!0);
      try {
        await t.deleteTenantSamlConfig(s), c.success("SAML configuration deleted."), u(null);
      } catch {
        c.error("Unable to delete SAML configuration.");
      } finally {
        o(!1);
      }
    }
  };
  return w && a.allowed && !d ? /* @__PURE__ */ e(
    Or,
    {
      loading: g,
      onCancel: () => S(!1),
      onCreate: R
    }
  ) : /* @__PURE__ */ r(
    K,
    {
      title: "SAML SSO",
      extra: /* @__PURE__ */ r(k, { children: [
        /* @__PURE__ */ e(y, { onClick: l, children: "Back to Tenants" }),
        /* @__PURE__ */ e(
          y,
          {
            icon: /* @__PURE__ */ e(He, {}),
            onClick: () => I(),
            loading: g,
            disabled: f || !a.allowed,
            children: "Refresh"
          }
        )
      ] }),
      style: { margin: 24 },
      loading: g || f,
      children: [
        /* @__PURE__ */ e(O.Paragraph, { type: "secondary", children: "Configure SAML single sign-on for this tenant. Users can authenticate via your identity provider." }),
        h && /* @__PURE__ */ e(
          C,
          {
            type: "error",
            message: "Error",
            description: h,
            showIcon: !0,
            style: { marginBottom: 16 }
          }
        ),
        !a.allowed && !f && /* @__PURE__ */ e(
          C,
          {
            type: "warning",
            message: "SAML configuration access denied",
            description: "You need tenant management read permission to view SAML settings for this tenant.",
            showIcon: !0,
            style: { marginBottom: 16 }
          }
        ),
        !h && !g && a.allowed && !d && /* @__PURE__ */ r(ie, { children: [
          /* @__PURE__ */ e(
            C,
            {
              type: "info",
              message: "No SAML configuration yet",
              description: "Set up SAML SSO to allow users to authenticate via your identity provider.",
              showIcon: !0,
              style: { marginBottom: 16 }
            }
          ),
          /* @__PURE__ */ e(y, { type: "primary", onClick: () => S(!0), disabled: !i.allowed, children: "Configure SAML SSO" })
        ] }),
        d && /* @__PURE__ */ r(ie, { children: [
          /* @__PURE__ */ r(m, { bordered: !0, size: "middle", column: 1, children: [
            /* @__PURE__ */ e(m.Item, { label: "Tenant ID", children: s }),
            /* @__PURE__ */ e(m.Item, { label: "Status", children: d.enabled ? /* @__PURE__ */ e(T, { color: "green", children: "Enabled" }) : /* @__PURE__ */ e(T, { children: "Disabled" }) }),
            /* @__PURE__ */ e(m.Item, { label: "Mode", children: /* @__PURE__ */ e(
              T,
              {
                color: d.mode === "enforced" ? "red" : d.mode === "optional" ? "blue" : void 0,
                children: d.mode.toUpperCase()
              }
            ) })
          ] }),
          /* @__PURE__ */ e(ne, { titlePlacement: "left", children: "Service Provider (SP) Endpoints" }),
          /* @__PURE__ */ r(m, { bordered: !0, size: "small", column: 1, children: [
            /* @__PURE__ */ e(m.Item, { label: "Entity ID", children: /* @__PURE__ */ e(O.Text, { code: !0, copyable: !0, children: d.entityId }) }),
            /* @__PURE__ */ e(m.Item, { label: "ACS URL", children: /* @__PURE__ */ e(O.Text, { code: !0, copyable: !0, children: d.acsUrl }) }),
            d.sloUrl && /* @__PURE__ */ e(m.Item, { label: "SLO URL", children: /* @__PURE__ */ e(O.Text, { code: !0, copyable: !0, children: d.sloUrl }) })
          ] }),
          /* @__PURE__ */ e(ne, { titlePlacement: "left", children: "Identity Provider (IdP)" }),
          /* @__PURE__ */ r(m, { bordered: !0, size: "small", column: 1, children: [
            /* @__PURE__ */ e(m.Item, { label: "IdP Entity ID", children: /* @__PURE__ */ e(O.Text, { code: !0, children: d.idp.entityId }) }),
            /* @__PURE__ */ e(m.Item, { label: "SSO URL", children: /* @__PURE__ */ e(O.Text, { code: !0, children: d.idp.ssoUrl }) }),
            d.idp.sloUrl && /* @__PURE__ */ e(m.Item, { label: "SLO URL", children: /* @__PURE__ */ e(O.Text, { code: !0, children: d.idp.sloUrl }) }),
            /* @__PURE__ */ e(m.Item, { label: "Certificates", children: d.idp.signingCertificates.map((v) => /* @__PURE__ */ r(T, { color: v.active ? "green" : "default", children: [
              v.kid,
              " ",
              v.active && "(active)"
            ] }, v.kid)) }),
            /* @__PURE__ */ r(m.Item, { label: "Metadata Source", children: [
              /* @__PURE__ */ e(T, { children: d.idpMetadata.source.toUpperCase() }),
              d.idpMetadata.fetchedAt && /* @__PURE__ */ r(O.Text, { type: "secondary", style: { marginLeft: 8 }, children: [
                "Fetched ",
                je(d.idpMetadata.fetchedAt)
              ] })
            ] })
          ] }),
          /* @__PURE__ */ e(ne, { titlePlacement: "left", children: "Security Policy" }),
          /* @__PURE__ */ r(m, { bordered: !0, size: "small", column: 2, children: [
            /* @__PURE__ */ e(m.Item, { label: "IdP-initiated SSO", children: /* @__PURE__ */ e(T, { color: d.policy.allowIdpInitiated ? "green" : "default", children: d.policy.allowIdpInitiated ? "Allowed" : "Blocked" }) }),
            /* @__PURE__ */ e(m.Item, { label: "Signed Assertions", children: /* @__PURE__ */ e(T, { color: d.policy.requireSignedAssertions ? "green" : "orange", children: d.policy.requireSignedAssertions ? "Required" : "Optional" }) }),
            /* @__PURE__ */ e(m.Item, { label: "Signed Response", children: /* @__PURE__ */ e(T, { color: d.policy.requireSignedResponse ? "green" : "orange", children: d.policy.requireSignedResponse ? "Required" : "Optional" }) })
          ] }),
          /* @__PURE__ */ e(ne, { titlePlacement: "left", children: "Attribute Mappings" }),
          /* @__PURE__ */ r(m, { bordered: !0, size: "small", column: 1, children: [
            /* @__PURE__ */ e(m.Item, { label: "Email", children: /* @__PURE__ */ e(O.Text, { code: !0, children: d.mappings.email }) }),
            d.mappings.firstName && /* @__PURE__ */ e(m.Item, { label: "First Name", children: /* @__PURE__ */ e(O.Text, { code: !0, children: d.mappings.firstName }) }),
            d.mappings.lastName && /* @__PURE__ */ e(m.Item, { label: "Last Name", children: /* @__PURE__ */ e(O.Text, { code: !0, children: d.mappings.lastName }) })
          ] }),
          /* @__PURE__ */ e(ne, { titlePlacement: "left", children: "Timestamps" }),
          /* @__PURE__ */ r(m, { bordered: !0, size: "small", column: 2, children: [
            /* @__PURE__ */ e(m.Item, { label: "Created", children: je(d.createdAt) }),
            /* @__PURE__ */ e(m.Item, { label: "Updated", children: je(d.updatedAt) })
          ] }),
          /* @__PURE__ */ e(
            Ur,
            {
              canDelete: n.allowed,
              canUpdate: i.allowed,
              config: d,
              onDelete: F,
              onModeChange: E,
              onRefreshMetadata: B,
              onToggle: M,
              tenantId: s
            }
          )
        ] })
      ]
    }
  );
}
export {
  Za as AccessControlApiProvider,
  Xr as CapabilitiesProvider,
  Gt as ChangePasswordModal,
  $t as ChangeRoleModal,
  Oa as ConsentDetailPage,
  La as ConsentsPage,
  Fa as CreateConsentPage,
  Ma as CreateFeatureFlagPage,
  ka as CreateFeaturePage,
  Va as CreateInvitationPage,
  Ca as CreatePermissionAssignmentPage,
  Aa as CreatePermissionPage,
  pa as CreateRolePage,
  Yr as CreateTenantPage,
  ua as CreateUserPage,
  ea as DashboardPage,
  Qa as DeletionAuditLogsPage,
  Ua as EditConsentPage,
  xa as EditFeatureFlagPage,
  Pa as EditFeaturePage,
  ja as EditInvitationPage,
  Ta as EditPermissionAssignmentPage,
  va as EditPermissionPage,
  ya as EditRolePage,
  Hr as EditTenantPage,
  ma as EditUserPage,
  Da as FeatureDetailPage,
  Na as FeatureFlagDetailPage,
  Ra as FeatureFlagsPage,
  Sa as FeaturesPage,
  qa as InvitationDetailPage,
  Ga as InvitationsPage,
  $a as LoginAttemptDetailPage,
  za as LoginAttemptHistoryPage,
  Ja as PasskeyManagementCard,
  Ea as PermissionAssignmentDetailPage,
  wa as PermissionAssignmentsPage,
  Ia as PermissionDetailPage,
  ba as PermissionsPage,
  kr as ROLE_OPTIONS,
  fa as RoleDetailPage,
  ha as RolesPage,
  Sr as STEP_TITLES,
  _a as SessionDetailPage,
  Ba as SessionsPage,
  oa as SettingsPage,
  Be as TENANT_TEMPLATES,
  Ya as TenantSamlConfigPanel,
  Zr as TenantsPage,
  ga as UserDetailPage,
  da as UserProfilesPage,
  ca as UsersPage,
  Ka as VoiceProOnboardingWizard,
  et as buildEmbeddedAccessControlTenantRoute,
  cr as extractTenantIdFromEmbeddedAccessControlPath,
  la as getEmbeddedAccessControlBaseUrl,
  dr as getEmbeddedAccessControlEntryRoute,
  ta as getEmbeddedAccessControlEntryRoutePattern,
  Ze as getEmbeddedAccessControlHostConfig,
  ra as getEmbeddedAccessControlMenuItems,
  ia as getEmbeddedAccessControlTenantDiagnosticRoutes,
  aa as getEmbeddedAccessControlTenantMenuItems,
  sa as getEmbeddedAccessControlTenantPathWithTenant,
  $e as getEmbeddedAccessControlTenantRoute,
  na as getEmbeddedAccessControlTenantRoutePattern,
  Pr as getRoleOptionsForTemplate,
  xe as getTemplate,
  Fr as mapPasskeyRegistrationError,
  Wa as templateHasStep,
  N as useCapability
};
//# sourceMappingURL=index.js.map
